var el = Object.defineProperty;
var ll = (g, I, c) => I in g ? el(g, I, { enumerable: !0, configurable: !0, writable: !0, value: c }) : g[I] = c;
var Yg = (g, I, c) => (ll(g, typeof I != "symbol" ? I + "" : I, c), c);
import { jsx as W, jsxs as z } from "@emotion/react/jsx-runtime";
import { useShowNotification as il, hideNotification as tl, createPolymorphicComponent as nl, Text as BI, COLOR_PALETTE as yg, Box as w, Group as v, Anchor as FI, OptimizeImage as qc, Indicator as bl, Stack as $g, Flex as $c, ActionIcon as xg, Icon as mg, Skeleton as ge } from "@inflearn/ds-react";
import { css as S } from "@emotion/react";
import { createContext as YI, useContext as fI, useState as zI, useRef as SI, useEffect as eg, useCallback as Ug, useMemo as Lg } from "react";
import { jsx as Ie, Fragment as ce, jsxs as Cl } from "react/jsx-runtime";
import TI from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/ko";
import al from "dayjs/plugin/localizedFormat";
import sl from "dayjs/plugin/updateLocale";
import { useAnalytics as Al } from "@inflearn/analytics";
import { useQuery as vg, useMutation as ee, useQueryClient as ul } from "@tanstack/react-query";
import { ResponseStatus as CI, IsomorphicFetch as dl, ApiError as Zg, StatusCodeLookup as rl } from "@inflearn/datasource-rest";
var ol = typeof global == "object" && global && global.Object === Object && global;
const le = ol;
var Gl = typeof self == "object" && self && self.Object === Object && self, Xl = le || Gl || Function("return this")();
const tg = Xl;
var Zl = tg.Symbol;
const Og = Zl;
var ie = Object.prototype, Wl = ie.hasOwnProperty, hl = ie.toString, dg = Og ? Og.toStringTag : void 0;
function Vl(g) {
  var I = Wl.call(g, dg), c = g[dg];
  try {
    g[dg] = void 0;
    var e = !0;
  } catch {
  }
  var l = hl.call(g);
  return e && (I ? g[dg] = c : delete g[dg]), l;
}
var xl = Object.prototype, ml = xl.toString;
function Nl(g) {
  return ml.call(g);
}
var Rl = "[object Null]", Jl = "[object Undefined]", Ic = Og ? Og.toStringTag : void 0;
function ng(g) {
  return g == null ? g === void 0 ? Jl : Rl : Ic && Ic in Object(g) ? Vl(g) : Nl(g);
}
function $(g) {
  return g != null && typeof g == "object";
}
var pl = "[object Symbol]";
function yl(g) {
  return typeof g == "symbol" || $(g) && ng(g) == pl;
}
function vl(g, I) {
  for (var c = -1, e = g == null ? 0 : g.length, l = Array(e); ++c < e; )
    l[c] = I(g[c], c, g);
  return l;
}
var Bl = Array.isArray;
const Eg = Bl;
var Fl = /\s/;
function Yl(g) {
  for (var I = g.length; I-- && Fl.test(g.charAt(I)); )
    ;
  return I;
}
var fl = /^\s+/;
function zl(g) {
  return g && g.slice(0, Yl(g) + 1).replace(fl, "");
}
function D(g) {
  var I = typeof g;
  return g != null && (I == "object" || I == "function");
}
var cc = 0 / 0, Sl = /^[-+]0x[0-9a-f]+$/i, Tl = /^0b[01]+$/i, Hl = /^0o[0-7]+$/i, wl = parseInt;
function Ul(g) {
  if (typeof g == "number")
    return g;
  if (yl(g))
    return cc;
  if (D(g)) {
    var I = typeof g.valueOf == "function" ? g.valueOf() : g;
    g = D(I) ? I + "" : I;
  }
  if (typeof g != "string")
    return g === 0 ? g : +g;
  g = zl(g);
  var c = Tl.test(g);
  return c || Hl.test(g) ? wl(g.slice(2), c ? 2 : 8) : Sl.test(g) ? cc : +g;
}
var ec = 1 / 0, Ll = 17976931348623157e292;
function Ol(g) {
  if (!g)
    return g === 0 ? g : 0;
  if (g = Ul(g), g === ec || g === -ec) {
    var I = g < 0 ? -1 : 1;
    return I * Ll;
  }
  return g === g ? g : 0;
}
function El(g) {
  var I = Ol(g), c = I % 1;
  return I === I ? c ? I - c : I : 0;
}
function HI(g) {
  return g;
}
var jl = "[object AsyncFunction]", Dl = "[object Function]", Pl = "[object GeneratorFunction]", kl = "[object Proxy]";
function wI(g) {
  if (!D(g))
    return !1;
  var I = ng(g);
  return I == Dl || I == Pl || I == jl || I == kl;
}
var Ql = tg["__core-js_shared__"];
const aI = Ql;
var lc = function() {
  var g = /[^.]+$/.exec(aI && aI.keys && aI.keys.IE_PROTO || "");
  return g ? "Symbol(src)_1." + g : "";
}();
function Ml(g) {
  return !!lc && lc in g;
}
var Kl = Function.prototype, _l = Kl.toString;
function ql(g) {
  if (g != null) {
    try {
      return _l.call(g);
    } catch {
    }
    try {
      return g + "";
    } catch {
    }
  }
  return "";
}
var $l = /[\\^$.*+?()[\]{}|]/g, gi = /^\[object .+?Constructor\]$/, Ii = Function.prototype, ci = Object.prototype, ei = Ii.toString, li = ci.hasOwnProperty, ii = RegExp(
  "^" + ei.call(li).replace($l, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function ti(g) {
  if (!D(g) || Ml(g))
    return !1;
  var I = wI(g) ? ii : gi;
  return I.test(ql(g));
}
function ni(g, I) {
  return g == null ? void 0 : g[I];
}
function UI(g, I) {
  var c = ni(g, I);
  return ti(c) ? c : void 0;
}
var ic = Object.create, bi = function() {
  function g() {
  }
  return function(I) {
    if (!D(I))
      return {};
    if (ic)
      return ic(I);
    g.prototype = I;
    var c = new g();
    return g.prototype = void 0, c;
  };
}();
const Ci = bi;
function ai(g, I, c) {
  switch (c.length) {
    case 0:
      return g.call(I);
    case 1:
      return g.call(I, c[0]);
    case 2:
      return g.call(I, c[0], c[1]);
    case 3:
      return g.call(I, c[0], c[1], c[2]);
  }
  return g.apply(I, c);
}
function si(g, I) {
  var c = -1, e = g.length;
  for (I || (I = Array(e)); ++c < e; )
    I[c] = g[c];
  return I;
}
var Ai = 800, ui = 16, di = Date.now;
function ri(g) {
  var I = 0, c = 0;
  return function() {
    var e = di(), l = ui - (e - c);
    if (c = e, l > 0) {
      if (++I >= Ai)
        return arguments[0];
    } else
      I = 0;
    return g.apply(void 0, arguments);
  };
}
function te(g) {
  return function() {
    return g;
  };
}
var oi = function() {
  try {
    var g = UI(Object, "defineProperty");
    return g({}, "", {}), g;
  } catch {
  }
}();
const jg = oi;
var Gi = jg ? function(g, I) {
  return jg(g, "toString", {
    configurable: !0,
    enumerable: !1,
    value: te(I),
    writable: !0
  });
} : HI;
const Xi = Gi;
var Zi = ri(Xi);
const Wi = Zi;
function hi(g, I, c, e) {
  for (var l = g.length, i = c + (e ? 1 : -1); e ? i-- : ++i < l; )
    if (I(g[i], i, g))
      return i;
  return -1;
}
function Vi(g) {
  return g !== g;
}
function xi(g, I, c) {
  for (var e = c - 1, l = g.length; ++e < l; )
    if (g[e] === I)
      return e;
  return -1;
}
function mi(g, I, c) {
  return I === I ? xi(g, I, c) : hi(g, Vi, c);
}
var Ni = 9007199254740991, Ri = /^(?:0|[1-9]\d*)$/;
function ne(g, I) {
  var c = typeof g;
  return I = I ?? Ni, !!I && (c == "number" || c != "symbol" && Ri.test(g)) && g > -1 && g % 1 == 0 && g < I;
}
function LI(g, I, c) {
  I == "__proto__" && jg ? jg(g, I, {
    configurable: !0,
    enumerable: !0,
    value: c,
    writable: !0
  }) : g[I] = c;
}
function gI(g, I) {
  return g === I || g !== g && I !== I;
}
var Ji = Object.prototype, pi = Ji.hasOwnProperty;
function yi(g, I, c) {
  var e = g[I];
  (!(pi.call(g, I) && gI(e, c)) || c === void 0 && !(I in g)) && LI(g, I, c);
}
function vi(g, I, c, e) {
  var l = !c;
  c || (c = {});
  for (var i = -1, t = I.length; ++i < t; ) {
    var n = I[i], C = e ? e(c[n], g[n], n, c, g) : void 0;
    C === void 0 && (C = g[n]), l ? LI(c, n, C) : yi(c, n, C);
  }
  return c;
}
var tc = Math.max;
function Bi(g, I, c) {
  return I = tc(I === void 0 ? g.length - 1 : I, 0), function() {
    for (var e = arguments, l = -1, i = tc(e.length - I, 0), t = Array(i); ++l < i; )
      t[l] = e[I + l];
    l = -1;
    for (var n = Array(I + 1); ++l < I; )
      n[l] = e[l];
    return n[I] = c(t), ai(g, this, n);
  };
}
function Fi(g, I) {
  return Wi(Bi(g, I, HI), g + "");
}
var Yi = 9007199254740991;
function be(g) {
  return typeof g == "number" && g > -1 && g % 1 == 0 && g <= Yi;
}
function Bg(g) {
  return g != null && be(g.length) && !wI(g);
}
function fi(g, I, c) {
  if (!D(c))
    return !1;
  var e = typeof I;
  return (e == "number" ? Bg(c) && ne(I, c.length) : e == "string" && I in c) ? gI(c[I], g) : !1;
}
function zi(g) {
  return Fi(function(I, c) {
    var e = -1, l = c.length, i = l > 1 ? c[l - 1] : void 0, t = l > 2 ? c[2] : void 0;
    for (i = g.length > 3 && typeof i == "function" ? (l--, i) : void 0, t && fi(c[0], c[1], t) && (i = l < 3 ? void 0 : i, l = 1), I = Object(I); ++e < l; ) {
      var n = c[e];
      n && g(I, n, e, i);
    }
    return I;
  });
}
var Si = Object.prototype;
function OI(g) {
  var I = g && g.constructor, c = typeof I == "function" && I.prototype || Si;
  return g === c;
}
function Ti(g, I) {
  for (var c = -1, e = Array(g); ++c < g; )
    e[c] = I(c);
  return e;
}
var Hi = "[object Arguments]";
function nc(g) {
  return $(g) && ng(g) == Hi;
}
var Ce = Object.prototype, wi = Ce.hasOwnProperty, Ui = Ce.propertyIsEnumerable, Li = nc(function() {
  return arguments;
}()) ? nc : function(g) {
  return $(g) && wi.call(g, "callee") && !Ui.call(g, "callee");
};
const XI = Li;
function Oi() {
  return !1;
}
var ae = typeof exports == "object" && exports && !exports.nodeType && exports, bc = ae && typeof module == "object" && module && !module.nodeType && module, Ei = bc && bc.exports === ae, Cc = Ei ? tg.Buffer : void 0, ji = Cc ? Cc.isBuffer : void 0, Di = ji || Oi;
const se = Di;
var Pi = "[object Arguments]", ki = "[object Array]", Qi = "[object Boolean]", Mi = "[object Date]", Ki = "[object Error]", _i = "[object Function]", qi = "[object Map]", $i = "[object Number]", gt = "[object Object]", It = "[object RegExp]", ct = "[object Set]", et = "[object String]", lt = "[object WeakMap]", it = "[object ArrayBuffer]", tt = "[object DataView]", nt = "[object Float32Array]", bt = "[object Float64Array]", Ct = "[object Int8Array]", at = "[object Int16Array]", st = "[object Int32Array]", At = "[object Uint8Array]", ut = "[object Uint8ClampedArray]", dt = "[object Uint16Array]", rt = "[object Uint32Array]", p = {};
p[nt] = p[bt] = p[Ct] = p[at] = p[st] = p[At] = p[ut] = p[dt] = p[rt] = !0;
p[Pi] = p[ki] = p[it] = p[Qi] = p[tt] = p[Mi] = p[Ki] = p[_i] = p[qi] = p[$i] = p[gt] = p[It] = p[ct] = p[et] = p[lt] = !1;
function ot(g) {
  return $(g) && be(g.length) && !!p[ng(g)];
}
function Gt(g) {
  return function(I) {
    return g(I);
  };
}
var Ae = typeof exports == "object" && exports && !exports.nodeType && exports, hg = Ae && typeof module == "object" && module && !module.nodeType && module, Xt = hg && hg.exports === Ae, sI = Xt && le.process, Zt = function() {
  try {
    var g = hg && hg.require && hg.require("util").types;
    return g || sI && sI.binding && sI.binding("util");
  } catch {
  }
}();
const ac = Zt;
var sc = ac && ac.isTypedArray, Wt = sc ? Gt(sc) : ot;
const ue = Wt;
var ht = Object.prototype, Vt = ht.hasOwnProperty;
function de(g, I) {
  var c = Eg(g), e = !c && XI(g), l = !c && !e && se(g), i = !c && !e && !l && ue(g), t = c || e || l || i, n = t ? Ti(g.length, String) : [], C = n.length;
  for (var b in g)
    (I || Vt.call(g, b)) && !(t && // Safari 9 has enumerable `arguments.length` in strict mode.
    (b == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    l && (b == "offset" || b == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (b == "buffer" || b == "byteLength" || b == "byteOffset") || // Skip index properties.
    ne(b, C))) && n.push(b);
  return n;
}
function re(g, I) {
  return function(c) {
    return g(I(c));
  };
}
var xt = re(Object.keys, Object);
const mt = xt;
var Nt = Object.prototype, Rt = Nt.hasOwnProperty;
function Jt(g) {
  if (!OI(g))
    return mt(g);
  var I = [];
  for (var c in Object(g))
    Rt.call(g, c) && c != "constructor" && I.push(c);
  return I;
}
function oe(g) {
  return Bg(g) ? de(g) : Jt(g);
}
function pt(g) {
  var I = [];
  if (g != null)
    for (var c in Object(g))
      I.push(c);
  return I;
}
var yt = Object.prototype, vt = yt.hasOwnProperty;
function Bt(g) {
  if (!D(g))
    return pt(g);
  var I = OI(g), c = [];
  for (var e in g)
    e == "constructor" && (I || !vt.call(g, e)) || c.push(e);
  return c;
}
function Ge(g) {
  return Bg(g) ? de(g, !0) : Bt(g);
}
var Ft = UI(Object, "create");
const Ng = Ft;
function Yt() {
  this.__data__ = Ng ? Ng(null) : {}, this.size = 0;
}
function ft(g) {
  var I = this.has(g) && delete this.__data__[g];
  return this.size -= I ? 1 : 0, I;
}
var zt = "__lodash_hash_undefined__", St = Object.prototype, Tt = St.hasOwnProperty;
function Ht(g) {
  var I = this.__data__;
  if (Ng) {
    var c = I[g];
    return c === zt ? void 0 : c;
  }
  return Tt.call(I, g) ? I[g] : void 0;
}
var wt = Object.prototype, Ut = wt.hasOwnProperty;
function Lt(g) {
  var I = this.__data__;
  return Ng ? I[g] !== void 0 : Ut.call(I, g);
}
var Ot = "__lodash_hash_undefined__";
function Et(g, I) {
  var c = this.__data__;
  return this.size += this.has(g) ? 0 : 1, c[g] = Ng && I === void 0 ? Ot : I, this;
}
function q(g) {
  var I = -1, c = g == null ? 0 : g.length;
  for (this.clear(); ++I < c; ) {
    var e = g[I];
    this.set(e[0], e[1]);
  }
}
q.prototype.clear = Yt;
q.prototype.delete = ft;
q.prototype.get = Ht;
q.prototype.has = Lt;
q.prototype.set = Et;
function jt() {
  this.__data__ = [], this.size = 0;
}
function II(g, I) {
  for (var c = g.length; c--; )
    if (gI(g[c][0], I))
      return c;
  return -1;
}
var Dt = Array.prototype, Pt = Dt.splice;
function kt(g) {
  var I = this.__data__, c = II(I, g);
  if (c < 0)
    return !1;
  var e = I.length - 1;
  return c == e ? I.pop() : Pt.call(I, c, 1), --this.size, !0;
}
function Qt(g) {
  var I = this.__data__, c = II(I, g);
  return c < 0 ? void 0 : I[c][1];
}
function Mt(g) {
  return II(this.__data__, g) > -1;
}
function Kt(g, I) {
  var c = this.__data__, e = II(c, g);
  return e < 0 ? (++this.size, c.push([g, I])) : c[e][1] = I, this;
}
function k(g) {
  var I = -1, c = g == null ? 0 : g.length;
  for (this.clear(); ++I < c; ) {
    var e = g[I];
    this.set(e[0], e[1]);
  }
}
k.prototype.clear = jt;
k.prototype.delete = kt;
k.prototype.get = Qt;
k.prototype.has = Mt;
k.prototype.set = Kt;
var _t = UI(tg, "Map");
const Xe = _t;
function qt() {
  this.size = 0, this.__data__ = {
    hash: new q(),
    map: new (Xe || k)(),
    string: new q()
  };
}
function $t(g) {
  var I = typeof g;
  return I == "string" || I == "number" || I == "symbol" || I == "boolean" ? g !== "__proto__" : g === null;
}
function cI(g, I) {
  var c = g.__data__;
  return $t(I) ? c[typeof I == "string" ? "string" : "hash"] : c.map;
}
function gn(g) {
  var I = cI(this, g).delete(g);
  return this.size -= I ? 1 : 0, I;
}
function In(g) {
  return cI(this, g).get(g);
}
function cn(g) {
  return cI(this, g).has(g);
}
function en(g, I) {
  var c = cI(this, g), e = c.size;
  return c.set(g, I), this.size += c.size == e ? 0 : 1, this;
}
function bg(g) {
  var I = -1, c = g == null ? 0 : g.length;
  for (this.clear(); ++I < c; ) {
    var e = g[I];
    this.set(e[0], e[1]);
  }
}
bg.prototype.clear = qt;
bg.prototype.delete = gn;
bg.prototype.get = In;
bg.prototype.has = cn;
bg.prototype.set = en;
var ln = re(Object.getPrototypeOf, Object);
const Ze = ln;
var tn = "[object Object]", nn = Function.prototype, bn = Object.prototype, We = nn.toString, Cn = bn.hasOwnProperty, an = We.call(Object);
function sn(g) {
  if (!$(g) || ng(g) != tn)
    return !1;
  var I = Ze(g);
  if (I === null)
    return !0;
  var c = Cn.call(I, "constructor") && I.constructor;
  return typeof c == "function" && c instanceof c && We.call(c) == an;
}
function An() {
  this.__data__ = new k(), this.size = 0;
}
function un(g) {
  var I = this.__data__, c = I.delete(g);
  return this.size = I.size, c;
}
function dn(g) {
  return this.__data__.get(g);
}
function rn(g) {
  return this.__data__.has(g);
}
var on = 200;
function Gn(g, I) {
  var c = this.__data__;
  if (c instanceof k) {
    var e = c.__data__;
    if (!Xe || e.length < on - 1)
      return e.push([g, I]), this.size = ++c.size, this;
    c = this.__data__ = new bg(e);
  }
  return c.set(g, I), this.size = c.size, this;
}
function Cg(g) {
  var I = this.__data__ = new k(g);
  this.size = I.size;
}
Cg.prototype.clear = An;
Cg.prototype.delete = un;
Cg.prototype.get = dn;
Cg.prototype.has = rn;
Cg.prototype.set = Gn;
var he = typeof exports == "object" && exports && !exports.nodeType && exports, Ac = he && typeof module == "object" && module && !module.nodeType && module, Xn = Ac && Ac.exports === he, uc = Xn ? tg.Buffer : void 0, dc = uc ? uc.allocUnsafe : void 0;
function Zn(g, I) {
  if (I)
    return g.slice();
  var c = g.length, e = dc ? dc(c) : new g.constructor(c);
  return g.copy(e), e;
}
var Wn = tg.Uint8Array;
const rc = Wn;
function hn(g) {
  var I = new g.constructor(g.byteLength);
  return new rc(I).set(new rc(g)), I;
}
function Vn(g, I) {
  var c = I ? hn(g.buffer) : g.buffer;
  return new g.constructor(c, g.byteOffset, g.length);
}
function xn(g) {
  return typeof g.constructor == "function" && !OI(g) ? Ci(Ze(g)) : {};
}
function mn(g) {
  return function(I, c, e) {
    for (var l = -1, i = Object(I), t = e(I), n = t.length; n--; ) {
      var C = t[g ? n : ++l];
      if (c(i[C], C, i) === !1)
        break;
    }
    return I;
  };
}
var Nn = mn();
const Ve = Nn;
function Rn(g, I) {
  return g && Ve(g, I, oe);
}
function ZI(g, I, c) {
  (c !== void 0 && !gI(g[I], c) || c === void 0 && !(I in g)) && LI(g, I, c);
}
function Jn(g) {
  return $(g) && Bg(g);
}
function WI(g, I) {
  if (!(I === "constructor" && typeof g[I] == "function") && I != "__proto__")
    return g[I];
}
function pn(g) {
  return vi(g, Ge(g));
}
function yn(g, I, c, e, l, i, t) {
  var n = WI(g, c), C = WI(I, c), b = t.get(C);
  if (b) {
    ZI(g, c, b);
    return;
  }
  var a = i ? i(n, C, c + "", g, I, t) : void 0, u = a === void 0;
  if (u) {
    var A = Eg(C), G = !A && se(C), m = !A && !G && ue(C);
    a = C, A || G || m ? Eg(n) ? a = n : Jn(n) ? a = si(n) : G ? (u = !1, a = Zn(C, !0)) : m ? (u = !1, a = Vn(C, !0)) : a = [] : sn(C) || XI(C) ? (a = n, XI(n) ? a = pn(n) : (!D(n) || wI(n)) && (a = xn(C))) : u = !1;
  }
  u && (t.set(C, a), l(a, C, e, i, t), t.delete(C)), ZI(g, c, a);
}
function xe(g, I, c, e, l) {
  g !== I && Ve(I, function(i, t) {
    if (l || (l = new Cg()), D(i))
      yn(g, I, t, c, xe, e, l);
    else {
      var n = e ? e(WI(g, t), i, t + "", g, I, l) : void 0;
      n === void 0 && (n = i), ZI(g, t, n);
    }
  }, Ge);
}
var vn = "[object String]";
function Bn(g) {
  return typeof g == "string" || !Eg(g) && $(g) && ng(g) == vn;
}
function Fn(g, I) {
  return vl(I, function(c) {
    return g[c];
  });
}
function Yn(g) {
  return g == null ? [] : Fn(g, oe(g));
}
var fn = Math.max;
function zn(g, I, c, e) {
  g = Bg(g) ? g : Yn(g), c = c && !e ? El(c) : 0;
  var l = g.length;
  return c < 0 && (c = fn(l + c, 0)), Bn(g) ? c <= l && g.indexOf(I, c) > -1 : !!l && mi(g, I, c) > -1;
}
function Sn(g, I, c, e) {
  return Rn(g, function(l, i, t) {
    I(e, c(l), i, t);
  }), e;
}
function Tn(g, I) {
  return function(c, e) {
    return Sn(c, g, I(e), {});
  };
}
var Hn = Object.prototype, wn = Hn.toString, Un = Tn(function(g, I, c) {
  I != null && typeof I.toString != "function" && (I = wn.call(I)), g[I] = c;
}, te(HI));
const Ln = Un;
var On = zi(function(g, I, c) {
  xe(g, I, c);
});
const me = On;
function Ne(g) {
  return g && g.__esModule && Object.prototype.hasOwnProperty.call(g, "default") ? g.default : g;
}
const En = (...g) => {
  console != null && console.warn && (_(g[0]) && (g[0] = `react-i18next:: ${g[0]}`), console.warn(...g));
}, oc = {}, hI = (...g) => {
  _(g[0]) && oc[g[0]] || (_(g[0]) && (oc[g[0]] = /* @__PURE__ */ new Date()), En(...g));
}, Re = (g, I) => () => {
  if (g.isInitialized)
    I();
  else {
    const c = () => {
      setTimeout(() => {
        g.off("initialized", c);
      }, 0), I();
    };
    g.on("initialized", c);
  }
}, Gc = (g, I, c) => {
  g.loadNamespaces(I, Re(g, c));
}, Xc = (g, I, c, e) => {
  _(c) && (c = [c]), c.forEach((l) => {
    g.options.ns.indexOf(l) < 0 && g.options.ns.push(l);
  }), g.loadLanguages(I, Re(g, e));
}, jn = (g, I, c = {}) => !I.languages || !I.languages.length ? (hI("i18n.languages were undefined or empty", I.languages), !0) : I.hasLoadedNamespace(g, {
  lng: c.lng,
  precheck: (e, l) => {
    var i;
    if (((i = c.bindI18n) == null ? void 0 : i.indexOf("languageChanging")) > -1 && e.services.backendConnector.backend && e.isLanguageChangingTo && !l(e.isLanguageChangingTo, g))
      return !1;
  }
}), _ = (g) => typeof g == "string", Dn = (g) => typeof g == "object" && g !== null, Pn = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, kn = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, Qn = (g) => kn[g], Mn = (g) => g.replace(Pn, Qn);
let VI = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: Mn
};
const Kn = (g = {}) => {
  VI = {
    ...VI,
    ...g
  };
}, _n = () => VI;
let Je;
const qn = (g) => {
  Je = g;
}, $n = () => Je, gb = {
  type: "3rdParty",
  init(g) {
    Kn(g.options.react), qn(g);
  }
}, Ib = YI();
class cb {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(I) {
    I.forEach((c) => {
      this.usedNamespaces[c] || (this.usedNamespaces[c] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
const eb = (g, I) => {
  const c = SI();
  return eg(() => {
    c.current = I ? c.current : g;
  }, [g, I]), c.current;
}, pe = (g, I, c, e) => g.getFixedT(I, c, e), lb = (g, I, c, e) => Ug(pe(g, I, c, e), [g, I, c, e]), ye = (g, I = {}) => {
  var d, o, X, x;
  const {
    i18n: c
  } = I, {
    i18n: e,
    defaultNS: l
  } = fI(Ib) || {}, i = c || e || $n();
  if (i && !i.reportNamespaces && (i.reportNamespaces = new cb()), !i) {
    hI("You will need to pass in an i18next instance by using initReactI18next");
    const h = (T, Y) => _(Y) ? Y : Dn(Y) && _(Y.defaultValue) ? Y.defaultValue : Array.isArray(T) ? T[T.length - 1] : T, J = [h, {}, !1];
    return J.t = h, J.i18n = {}, J.ready = !1, J;
  }
  (d = i.options.react) != null && d.wait && hI("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const t = {
    ..._n(),
    ...i.options.react,
    ...I
  }, {
    useSuspense: n,
    keyPrefix: C
  } = t;
  let b = g || l || ((o = i.options) == null ? void 0 : o.defaultNS);
  b = _(b) ? [b] : b || ["translation"], (x = (X = i.reportNamespaces).addUsedNamespaces) == null || x.call(X, b);
  const a = (i.isInitialized || i.initializedStoreOnce) && b.every((h) => jn(h, i, t)), u = lb(i, I.lng || null, t.nsMode === "fallback" ? b : b[0], C), A = () => u, G = () => pe(i, I.lng || null, t.nsMode === "fallback" ? b : b[0], C), [m, V] = zI(A);
  let R = b.join();
  I.lng && (R = `${I.lng}${R}`);
  const y = eb(R), s = SI(!0);
  eg(() => {
    const {
      bindI18n: h,
      bindI18nStore: J
    } = t;
    s.current = !0, !a && !n && (I.lng ? Xc(i, I.lng, b, () => {
      s.current && V(G);
    }) : Gc(i, b, () => {
      s.current && V(G);
    })), a && y && y !== R && s.current && V(G);
    const T = () => {
      s.current && V(G);
    };
    return h && (i == null || i.on(h, T)), J && (i == null || i.store.on(J, T)), () => {
      s.current = !1, i && (h == null || h.split(" ").forEach((Y) => i.off(Y, T))), J && i && J.split(" ").forEach((Y) => i.store.off(Y, T));
    };
  }, [i, R]), eg(() => {
    s.current && a && V(A);
  }, [i, C, a]);
  const r = [m, i, a];
  if (r.t = m, r.i18n = i, r.ready = a, a || !a && !n)
    return r;
  throw new Promise((h) => {
    I.lng ? Xc(i, I.lng, b, () => h()) : Gc(i, b, () => h());
  });
};
function ve(g) {
  return ye("appShell", g);
}
/*! js-cookie v3.0.5 | MIT */
function fg(g) {
  for (var I = 1; I < arguments.length; I++) {
    var c = arguments[I];
    for (var e in c)
      g[e] = c[e];
  }
  return g;
}
var ib = {
  read: function(g) {
    return g[0] === '"' && (g = g.slice(1, -1)), g.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(g) {
    return encodeURIComponent(g).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function xI(g, I) {
  function c(l, i, t) {
    if (!(typeof document > "u")) {
      t = fg({}, I, t), typeof t.expires == "number" && (t.expires = new Date(Date.now() + t.expires * 864e5)), t.expires && (t.expires = t.expires.toUTCString()), l = encodeURIComponent(l).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var n = "";
      for (var C in t)
        t[C] && (n += "; " + C, t[C] !== !0 && (n += "=" + t[C].split(";")[0]));
      return document.cookie = l + "=" + g.write(i, l) + n;
    }
  }
  function e(l) {
    if (!(typeof document > "u" || arguments.length && !l)) {
      for (var i = document.cookie ? document.cookie.split("; ") : [], t = {}, n = 0; n < i.length; n++) {
        var C = i[n].split("="), b = C.slice(1).join("=");
        try {
          var a = decodeURIComponent(C[0]);
          if (t[a] = g.read(b, a), l === a)
            break;
        } catch {
        }
      }
      return l ? t[l] : t;
    }
  }
  return Object.create(
    {
      set: c,
      get: e,
      remove: function(l, i) {
        c(
          l,
          "",
          fg({}, i, {
            expires: -1
          })
        );
      },
      withAttributes: function(l) {
        return xI(this.converter, fg({}, this.attributes, l));
      },
      withConverter: function(l) {
        return xI(fg({}, this.converter, l), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(I) },
      converter: { value: Object.freeze(g) }
    }
  );
}
var Be = xI(ib, { path: "/" });
const Zs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Be
}, Symbol.toStringTag, { value: "Module" })), tb = {
  MODE: "development",
  CDN_URL: "https://cdn.devinflearn.com",
  API_URL: "https://www.devinflearn.com",
  SITE_URL: "https://www.devinflearn.com",
  MENTORING_SITE_URL: "https://mentoring.devinflearn.com",
  SOCIAL_ACCOUNT_URL: "https://account.devinflearn.com",
  ACCOUNT_API_URL: "https://account-api.devinflearn.com",
  COURSE_API_URL: "https://course-api.devinflearn.com",
  UCC_API_URL: "https://ucc-api.devinflearn.com",
  RALLIT_SITE_URL: "https://www.devrallit.com",
  BUSINESS_DOMAIN: "https://business.devinflearn.com",
  ADMIN_DOMAIN: "https://admin.devinflearn.com",
  COOKIE_DOMAIN: ".devinflearn.com",
  OAUTH_APPLE_CLIENT_ID: "com.inflab.inflearn.test",
  OAUTH_GITHUB_CLIENT_ID_LEGACY: "65fef69e7b3b778bd124",
  OAUTH_GITHUB_CLIENT_ID: "41f342acfada922e9fb5",
  OAUTH_GOOGLE_CLIENT_ID: "333892070963-abo0eoss3ielmeukj8dtvpr4l0fbniun.apps.googleusercontent.com",
  OAUTH_KAKAO_REST_ID: "1281a93457d30e1f2ffafe9fe0c197ab",
  HACKLE_BROWSER_SDK_KEY: "ygFNanOzYS2M5JgfrE5gUk69EbkFIzZ4",
  MIXPANEL_TOKEN: "2df837e504078b475f90b32d9a268c01",
  CDN_INTEGRATION_URL: "https://cdn.devinflab.com"
}, nb = {
  MODE: "localhost",
  CDN_URL: "https://cdn.devinflearn.com",
  API_URL: "http://localhost:3000",
  SITE_URL: "http://localhost:3000",
  MENTORING_SITE_URL: "https://mentoring.devinflearn.com",
  SOCIAL_ACCOUNT_URL: "https://account.devinflearn.com",
  ACCOUNT_API_URL: "https://account-api.devinflearn.com",
  COURSE_API_URL: "https://course-api.devinflearn.com",
  UCC_API_URL: "https://ucc-api.devinflearn.com",
  RALLIT_SITE_URL: "https://www.devrallit.com",
  BUSINESS_DOMAIN: "http://localhost:7020",
  ADMIN_DOMAIN: "http://localhost:7010",
  COOKIE_DOMAIN: "localhost",
  OAUTH_APPLE_CLIENT_ID: "com.inflab.inflearn.test",
  OAUTH_GITHUB_CLIENT_ID_LEGACY: "65fef69e7b3b778bd124",
  OAUTH_GITHUB_CLIENT_ID: "41f342acfada922e9fb5",
  OAUTH_GOOGLE_CLIENT_ID: "333892070963-abo0eoss3ielmeukj8dtvpr4l0fbniun.apps.googleusercontent.com",
  OAUTH_KAKAO_REST_ID: "1281a93457d30e1f2ffafe9fe0c197ab",
  HACKLE_BROWSER_SDK_KEY: "ygFNanOzYS2M5JgfrE5gUk69EbkFIzZ4",
  MIXPANEL_TOKEN: "2df837e504078b475f90b32d9a268c01",
  CDN_INTEGRATION_URL: "https://cdn.devinflab.com"
}, Zc = {
  MODE: "production",
  CDN_URL: "https://cdn.inflearn.com",
  API_URL: "https://www.inflearn.com",
  SITE_URL: "https://www.inflearn.com",
  MENTORING_SITE_URL: "https://mentoring.inflearn.com",
  SOCIAL_ACCOUNT_URL: "https://account.inflearn.com",
  ACCOUNT_API_URL: "https://account-api.inflearn.com",
  COURSE_API_URL: "https://course-api.inflearn.com",
  UCC_API_URL: "https://ucc-api.inflearn.com",
  RALLIT_SITE_URL: "https://www.rallit.com",
  BUSINESS_DOMAIN: "https://business.inflearn.com",
  ADMIN_DOMAIN: "https://admin.inflearn.com",
  COOKIE_DOMAIN: ".inflearn.com",
  OAUTH_APPLE_CLIENT_ID: "com.inflab.inflearn.web",
  OAUTH_GITHUB_CLIENT_ID_LEGACY: "5fd8e44b142806d9cbea",
  OAUTH_GITHUB_CLIENT_ID: "419780d6d3750d84d1db",
  OAUTH_GOOGLE_CLIENT_ID: "887875630717-ror9t8ig4obhvokdij07eoochpqbu5kf.apps.googleusercontent.com",
  OAUTH_KAKAO_REST_ID: "0de1184063abadc9cef9dbf417c567a5",
  HACKLE_BROWSER_SDK_KEY: "rb1wDPCB39swIGfTAhDcz0QXvmh6hayS",
  MIXPANEL_TOKEN: "c05d8cc017a29af05e50c0d43d848d2d",
  CDN_INTEGRATION_URL: "https://cdn.inflab.com"
};
function bb() {
  return typeof window < "u" && (window != null && window.env) ? window.env : process.env.NEXT_PUBLIC_ENV || process.env.APP_ENV;
}
function Cb() {
  const g = bb();
  return g ? g === "localhost" ? nb : g === "production" ? Zc : tb : (console.error("app-shell env is not defined"), Zc);
}
const B = Cb(), EI = B.CDN_URL, jI = B.SITE_URL, Dg = B.MENTORING_SITE_URL, Ws = B.SOCIAL_ACCOUNT_URL, ab = B.API_URL, sb = `${ab}/api`, Ab = B.ACCOUNT_API_URL, ub = B.COURSE_API_URL, db = B.UCC_API_URL, rb = B.MODE, Wc = B.RALLIT_SITE_URL, hs = B.OAUTH_APPLE_CLIENT_ID, Vs = B.OAUTH_GITHUB_CLIENT_ID, xs = B.OAUTH_GOOGLE_CLIENT_ID, ms = B.OAUTH_KAKAO_REST_ID, Fe = B.BUSINESS_DOMAIN, ob = B.COOKIE_DOMAIN, Ns = B.HACKLE_BROWSER_SDK_KEY, Gb = B.MIXPANEL_TOKEN;
B.CDN_INTEGRATION_URL;
const AI = Be.withAttributes({
  path: "/",
  domain: ob
}).withConverter({
  write: function(g) {
    return encodeURIComponent(g);
  }
});
class Hg {
  static set(I, c, e = this.COOKIE_EXPIRE_DAY, l = "Medium") {
    AI.set(I, c, {
      expires: e,
      priority: l
    });
  }
  static get(I) {
    return AI.get(I);
  }
  static remove(I) {
    AI.remove(I);
  }
}
Yg(Hg, "COOKIE_EXPIRE_DAY", 7);
var eI = { exports: {} };
function Xb(g) {
  try {
    return JSON.stringify(g);
  } catch {
    return '"[Circular]"';
  }
}
var Zb = Wb;
function Wb(g, I, c) {
  var e = c && c.stringify || Xb, l = 1;
  if (typeof g == "object" && g !== null) {
    var i = I.length + l;
    if (i === 1)
      return g;
    var t = new Array(i);
    t[0] = e(g);
    for (var n = 1; n < i; n++)
      t[n] = e(I[n]);
    return t.join(" ");
  }
  if (typeof g != "string")
    return g;
  var C = I.length;
  if (C === 0)
    return g;
  for (var b = "", a = 1 - l, u = -1, A = g && g.length || 0, G = 0; G < A; ) {
    if (g.charCodeAt(G) === 37 && G + 1 < A) {
      switch (u = u > -1 ? u : 0, g.charCodeAt(G + 1)) {
        case 100:
        case 102:
          if (a >= C || I[a] == null)
            break;
          u < G && (b += g.slice(u, G)), b += Number(I[a]), u = G + 2, G++;
          break;
        case 105:
          if (a >= C || I[a] == null)
            break;
          u < G && (b += g.slice(u, G)), b += Math.floor(Number(I[a])), u = G + 2, G++;
          break;
        case 79:
        case 111:
        case 106:
          if (a >= C || I[a] === void 0)
            break;
          u < G && (b += g.slice(u, G));
          var m = typeof I[a];
          if (m === "string") {
            b += "'" + I[a] + "'", u = G + 2, G++;
            break;
          }
          if (m === "function") {
            b += I[a].name || "<anonymous>", u = G + 2, G++;
            break;
          }
          b += e(I[a]), u = G + 2, G++;
          break;
        case 115:
          if (a >= C)
            break;
          u < G && (b += g.slice(u, G)), b += String(I[a]), u = G + 2, G++;
          break;
        case 37:
          u < G && (b += g.slice(u, G)), b += "%", u = G + 2, G++, a--;
          break;
      }
      ++a;
    }
    ++G;
  }
  return u === -1 ? g : (u < A && (b += g.slice(u)), b);
}
const hc = Zb;
eI.exports = P;
const Rg = zb().console || {}, hb = {
  mapHttpRequest: zg,
  mapHttpResponse: zg,
  wrapRequestSerializer: uI,
  wrapResponseSerializer: uI,
  wrapErrorSerializer: uI,
  req: zg,
  res: zg,
  err: xc,
  errWithCause: xc
};
function Pg(g, I) {
  return g === "silent" ? 1 / 0 : I.levels.values[g];
}
const DI = Symbol("pino.logFuncs"), mI = Symbol("pino.hierarchy"), Vb = {
  error: "log",
  fatal: "error",
  warn: "error",
  info: "log",
  debug: "log",
  trace: "log"
};
function Vc(g, I) {
  const c = {
    logger: I,
    parent: g[mI]
  };
  I[mI] = c;
}
function xb(g, I, c) {
  const e = {};
  I.forEach((l) => {
    e[l] = c[l] ? c[l] : Rg[l] || Rg[Vb[l] || "log"] || Jg;
  }), g[DI] = e;
}
function mb(g, I) {
  return Array.isArray(g) ? g.filter(function(e) {
    return e !== "!stdSerializers.err";
  }) : g === !0 ? Object.keys(I) : !1;
}
function P(g) {
  g = g || {}, g.browser = g.browser || {};
  const I = g.browser.transmit;
  if (I && typeof I.send != "function")
    throw Error("pino: transmit option must have a send function");
  const c = g.browser.write || Rg;
  g.browser.write && (g.browser.asObject = !0);
  const e = g.serializers || {}, l = mb(g.browser.serialize, e);
  let i = g.browser.serialize;
  Array.isArray(g.browser.serialize) && g.browser.serialize.indexOf("!stdSerializers.err") > -1 && (i = !1);
  const t = Object.keys(g.customLevels || {}), n = ["error", "fatal", "warn", "info", "debug", "trace"].concat(t);
  typeof c == "function" && n.forEach(function(V) {
    c[V] = c;
  }), (g.enabled === !1 || g.browser.disabled) && (g.level = "silent");
  const C = g.level || "info", b = Object.create(c);
  b.log || (b.log = Jg), xb(b, n, c), Vc({}, b), Object.defineProperty(b, "levelVal", {
    get: u
  }), Object.defineProperty(b, "level", {
    get: A,
    set: G
  });
  const a = {
    transmit: I,
    serialize: l,
    asObject: g.browser.asObject,
    formatters: g.browser.formatters,
    levels: n,
    timestamp: Fb(g)
  };
  b.levels = Nb(g), b.level = C, b.setMaxListeners = b.getMaxListeners = b.emit = b.addListener = b.on = b.prependListener = b.once = b.prependOnceListener = b.removeListener = b.removeAllListeners = b.listeners = b.listenerCount = b.eventNames = b.write = b.flush = Jg, b.serializers = e, b._serialize = l, b._stdErrSerialize = i, b.child = m, I && (b._logEvent = NI());
  function u() {
    return Pg(this.level, this);
  }
  function A() {
    return this._level;
  }
  function G(V) {
    if (V !== "silent" && !this.levels.values[V])
      throw Error("unknown level " + V);
    this._level = V, K(this, a, b, "error"), K(this, a, b, "fatal"), K(this, a, b, "warn"), K(this, a, b, "info"), K(this, a, b, "debug"), K(this, a, b, "trace"), t.forEach((R) => {
      K(this, a, b, R);
    });
  }
  function m(V, R) {
    if (!V)
      throw new Error("missing bindings for child Pino");
    R = R || {}, l && V.serializers && (R.serializers = V.serializers);
    const y = R.serializers;
    if (l && y) {
      var s = Object.assign({}, e, y), r = g.browser.serialize === !0 ? Object.keys(s) : l;
      delete V.serializers, lI([V], r, s, this._stdErrSerialize);
    }
    function d(X) {
      this._childLevel = (X._childLevel | 0) + 1, this.bindings = V, s && (this.serializers = s, this._serialize = r), I && (this._logEvent = NI(
        [].concat(X._logEvent.bindings, V)
      ));
    }
    d.prototype = this;
    const o = new d(this);
    return Vc(this, o), o.level = this.level, o;
  }
  return b;
}
function Nb(g) {
  const I = g.customLevels || {}, c = Object.assign({}, P.levels.values, I), e = Object.assign({}, P.levels.labels, Rb(I));
  return {
    values: c,
    labels: e
  };
}
function Rb(g) {
  const I = {};
  return Object.keys(g).forEach(function(c) {
    I[g[c]] = c;
  }), I;
}
P.levels = {
  values: {
    fatal: 60,
    error: 50,
    warn: 40,
    info: 30,
    debug: 20,
    trace: 10
  },
  labels: {
    10: "trace",
    20: "debug",
    30: "info",
    40: "warn",
    50: "error",
    60: "fatal"
  }
};
P.stdSerializers = hb;
P.stdTimeFunctions = Object.assign({}, { nullTime: Ye, epochTime: fe, unixTime: Yb, isoTime: fb });
function Jb(g) {
  const I = [];
  g.bindings && I.push(g.bindings);
  let c = g[mI];
  for (; c.parent; )
    c = c.parent, c.logger.bindings && I.push(c.logger.bindings);
  return I.reverse();
}
function K(g, I, c, e) {
  if (Object.defineProperty(g, e, {
    value: Pg(g.level, c) > Pg(e, c) ? Jg : c[DI][e],
    writable: !0,
    enumerable: !0,
    configurable: !0
  }), !I.transmit && g[e] === Jg)
    return;
  g[e] = yb(g, I, c, e);
  const l = Jb(g);
  l.length !== 0 && (g[e] = pb(l, g[e]));
}
function pb(g, I) {
  return function() {
    return I.apply(this, [...g, ...arguments]);
  };
}
function yb(g, I, c, e) {
  return function(l) {
    return function() {
      const t = I.timestamp(), n = new Array(arguments.length), C = Object.getPrototypeOf && Object.getPrototypeOf(this) === Rg ? Rg : this;
      for (var b = 0; b < n.length; b++)
        n[b] = arguments[b];
      if (I.serialize && !I.asObject && lI(n, this._serialize, this.serializers, this._stdErrSerialize), I.asObject || I.formatters ? l.call(C, vb(this, e, n, t, I.formatters)) : l.apply(C, n), I.transmit) {
        const a = I.transmit.level || g._level, u = c.levels.values[a], A = c.levels.values[e];
        if (A < u)
          return;
        Bb(this, {
          ts: t,
          methodLevel: e,
          methodValue: A,
          transmitLevel: a,
          transmitValue: c.levels.values[I.transmit.level || g._level],
          send: I.transmit.send,
          val: Pg(g._level, c)
        }, n);
      }
    };
  }(g[DI][e]);
}
function vb(g, I, c, e, l = {}) {
  const {
    level: i = () => g.levels.values[I],
    log: t = (A) => A
  } = l;
  g._serialize && lI(c, g._serialize, g.serializers, g._stdErrSerialize);
  const n = c.slice();
  let C = n[0];
  const b = {};
  e && (b.time = e), b.level = i(I, g.levels.values[I]);
  let a = (g._childLevel | 0) + 1;
  if (a < 1 && (a = 1), C !== null && typeof C == "object") {
    for (; a-- && typeof n[0] == "object"; )
      Object.assign(b, n.shift());
    C = n.length ? hc(n.shift(), n) : void 0;
  } else
    typeof C == "string" && (C = hc(n.shift(), n));
  return C !== void 0 && (b.msg = C), t(b);
}
function lI(g, I, c, e) {
  for (const l in g)
    if (e && g[l] instanceof Error)
      g[l] = P.stdSerializers.err(g[l]);
    else if (typeof g[l] == "object" && !Array.isArray(g[l]))
      for (const i in g[l])
        I && I.indexOf(i) > -1 && i in c && (g[l][i] = c[i](g[l][i]));
}
function Bb(g, I, c) {
  const e = I.send, l = I.ts, i = I.methodLevel, t = I.methodValue, n = I.val, C = g._logEvent.bindings;
  lI(
    c,
    g._serialize || Object.keys(g.serializers),
    g.serializers,
    g._stdErrSerialize === void 0 ? !0 : g._stdErrSerialize
  ), g._logEvent.ts = l, g._logEvent.messages = c.filter(function(b) {
    return C.indexOf(b) === -1;
  }), g._logEvent.level.label = i, g._logEvent.level.value = t, e(i, g._logEvent, n), g._logEvent = NI(C);
}
function NI(g) {
  return {
    ts: 0,
    messages: [],
    bindings: g || [],
    level: { label: "", value: 0 }
  };
}
function xc(g) {
  const I = {
    type: g.constructor.name,
    msg: g.message,
    stack: g.stack
  };
  for (const c in g)
    I[c] === void 0 && (I[c] = g[c]);
  return I;
}
function Fb(g) {
  return typeof g.timestamp == "function" ? g.timestamp : g.timestamp === !1 ? Ye : fe;
}
function zg() {
  return {};
}
function uI(g) {
  return g;
}
function Jg() {
}
function Ye() {
  return !1;
}
function fe() {
  return Date.now();
}
function Yb() {
  return Math.round(Date.now() / 1e3);
}
function fb() {
  return new Date(Date.now()).toISOString();
}
function zb() {
  function g(I) {
    return typeof I < "u" && I;
  }
  try {
    return typeof globalThis < "u" || Object.defineProperty(Object.prototype, "globalThis", {
      get: function() {
        return delete Object.prototype.globalThis, this.globalThis = this;
      },
      configurable: !0
    }), globalThis;
  } catch {
    return g(self) || g(window) || g(this) || {};
  }
}
eI.exports.default = P;
eI.exports.pino = P;
var Sb = eI.exports;
const Tb = /* @__PURE__ */ Ne(Sb);
class Hb {
  constructor() {
    Yg(this, "logger");
    /**
     * 서버와 log level을 동기화 하기 위한 설정
     * @see {@link https://github.com/winstonjs/winston#logging-levels Winston log level}
     */
    Yg(this, "defaultLogLevelMap");
    this.defaultLogLevelMap = {
      error: 3,
      warn: 4,
      info: 6,
      debug: 7
    }, this.logger = Tb(), this.logger.levels = {
      labels: Ln(this.defaultLogLevelMap),
      values: this.defaultLogLevelMap
    };
  }
  debug(I) {
    this.log("debug", I);
  }
  info(I) {
    this.log("info", I);
  }
  warn(I) {
    this.log("warn", I);
  }
  error(I) {
    this.log("error", I);
  }
  log(I, c) {
    if (this.isLogLevelKey(I)) {
      this.logger[I](c);
      return;
    }
    const e = this.findLoggerTypeForSyslogLevel(I);
    e && this.logger[e](c);
  }
  isLogLevelKey(I) {
    return typeof I == "string" && zn(Object.keys(this.defaultLogLevelMap), I);
  }
  findLoggerTypeForSyslogLevel(I) {
    const c = this.logger.levels.labels[I];
    return this.isLogLevelKey(c) ? c : null;
  }
}
const mc = new Hb(), wb = 10 * 1e3, Ub = [CI.NOT_FOUND, CI.UNAUTHORIZED, CI.BAD_PARAMETER];
class ag extends dl {
  static from(I) {
    return new ag({
      credentials: "include",
      timeout: wb,
      ...I
    });
  }
  afterRequest(I, c, e, l) {
    if (Zg.isHandledResponse(l)) {
      const i = Zg.createApiError(l, {
        status: I,
        handled: !0,
        extra: l,
        url: e.path
      }), {
        level: t,
        message: n
      } = i.logMessage();
      throw mc[t](n), i;
    }
    return l;
  }
  performError(I) {
    if (!(I instanceof DOMException && I.name === "AbortError") && Zg.isUnhandledResponse(I)) {
      const c = Zg.createApiError({
        statusCode: rl[I.status] || String(I.status),
        message: `[${I.name}] ${I.url} | ${I}`,
        data: null
      }, {
        handled: !1,
        url: I.url,
        status: I.status
      }, Ub), {
        level: e,
        message: l
      } = c.logMessage();
      mc[e](l);
    }
  }
}
const iI = ag.from({
  baseUrl: sb
}), Lb = ag.from({
  baseUrl: Ab
}), Rs = ag.from({
  baseUrl: ub
}), Js = ag.from({
  baseUrl: db
});
var ze = /* @__PURE__ */ ((g) => (g.OK = "OK", g.SERVER_ERROR = "SERVER_ERROR", g.DUPLICATE = "DUPLICATE", g.NOT_FOUND = "NOT_FOUND", g.BAD_REQUEST = "BAD_REQUEST", g.BAD_PARAMETER = "BAD_PARAMETER", g.CONFLICT = "CONFLICT", g.UNAUTHORIZED = "UNAUTHORIZED", g.FORBIDDEN = "FORBIDDEN", g.PAYLOAD_TOO_LARGE = "PAYLOAD_TOO_LARGE", g.TOO_MANY_REQUESTS = "TOO_MANY_REQUESTS", g))(ze || {});
const ps = {
  V1_MESSAGE: "/user/api/v1/messages/unchecked",
  V1_USER_META: "/v1/user/meta",
  V1_GROUP_BY_USER: "/v1/group/by-user",
  V1_GROUP_ID_NOTICE_EXPOSURE: (g) => `/v1/group/${g}/notice/exposure`,
  V1_NOTICE_EXPOSURE: "/v1/notice/exposure"
}, Ob = async (g, I) => iI.get(g, I);
function ys({
  queryKey: g,
  url: I,
  options: c,
  requestOptions: e
}) {
  var i;
  const l = vg(g, () => Ob(I, e), c);
  return {
    ...l,
    data: (i = l.data) == null ? void 0 : i.data
  };
}
const Eb = async (g, I) => iI.get(g, I);
function vs({
  queryKey: g,
  url: I,
  options: c,
  requestOptions: e
}) {
  var i;
  const l = vg(g, () => Eb(I, e), c);
  return {
    ...l,
    data: (i = l.data) == null ? void 0 : i.data
  };
}
const jb = async (g, I) => iI.get(g, I);
function Bs({
  queryKey: g,
  url: I,
  options: c,
  requestOptions: e
}) {
  var i;
  const l = vg(g, () => jb(I, e), c);
  return {
    ...l,
    data: (i = l.data) == null ? void 0 : i.data
  };
}
const Db = async (g, I) => iI.get(g, I);
function Fs({
  queryKey: g,
  url: I,
  options: c,
  requestOptions: e
}) {
  var i;
  const l = vg(g, () => Db(I, e), c);
  return {
    ...l,
    data: (i = l.data) == null ? void 0 : i.data
  };
}
const PI = () => typeof window < "u", Ys = () => typeof document < "u", fs = () => typeof window < "u", Pb = (g) => {
  if (typeof window > "u")
    return "";
  try {
    return new URLSearchParams(window.location.search).get(g) ?? "";
  } catch {
    return "";
  }
}, kb = (g) => new URL(g).hostname.split(".").slice(-2).join("."), Qb = (g) => {
  try {
    const I = kb(jI);
    if (!I)
      return !1;
    const c = new URL(g).hostname;
    return c === I || c.endsWith(`.${I}`);
  } catch {
    return !1;
  }
}, tI = (g) => g.replace(/^\/(ko|en|ja|vi)(\/|$)/, "/"), L = {
  COURSES: (g) => g === "/courses" || g.startsWith("/courses/") || g.startsWith("/course/"),
  CHALLENGES: (g) => g.startsWith("/challenges") || g.startsWith("/challenge"),
  MENTORING: (g, I) => I === Dg || g.startsWith("/mentors"),
  ROADMAPS: (g) => g.startsWith("/roadmaps"),
  SEARCH: (g) => g.startsWith("/search"),
  CLIPS: (g) => g.startsWith("/clips") || g.startsWith("/clip"),
  COMMUNITY: (g) => g.startsWith("/community")
}, Se = {
  COURSES: (g) => g === "/" || g === "/courses" || g.startsWith("/courses/"),
  CHALLENGES: (g) => g === "/challenges",
  MENTORING: (g) => g === "/mentors",
  ROADMAPS: (g) => g === "/roadmaps",
  SEARCH: (g) => g === "/search",
  CLIPS: (g) => g === "/clips",
  COMMUNITY: (g) => g === "/community"
}, zs = () => {
  if (!PI())
    return !1;
  const g = window.location.pathname, I = tI(g);
  return Object.values(Se).some((c) => c(I));
}, Mb = (g) => {
  const I = tI(g);
  return Object.values(Se).some((c) => c(I));
}, Nc = (g) => {
  if (!PI())
    return !1;
  const I = window.location.pathname, c = window.location.origin, e = tI(I);
  return Qb(c) ? c === Dg ? g === "MENTORING" : g === "COURSES" ? L.COURSES(e) : g === "ROADMAPS" ? L.ROADMAPS(e) : g === "CLIPS" ? L.CLIPS(e) : g === "CHALLENGES" ? L.CHALLENGES(e) : g === "COMMUNITY" ? L.COMMUNITY(e) : !1 : !1;
}, Ss = () => {
  if (!PI())
    return "COURSES";
  const g = window.location.pathname, I = window.location.origin, c = Pb("types"), e = tI(g);
  return L.ROADMAPS(e) ? "ROADMAPS" : L.CHALLENGES(e) ? "CHALLENGES" : L.MENTORING(e, I) ? "MENTORING" : L.CLIPS(e) ? "CLIPS" : c === "CHALLENGE" ? "CHALLENGES" : L.COMMUNITY(e) ? "COMMUNITY" : "COURSES";
}, wg = "gnb_snapshot", Te = {
  COURSES: "courses",
  // 강의 메뉴
  ROADMAPS: "roadmaps",
  // 로드맵 메뉴
  MENTORING: "mentoring",
  // 멘토링 메뉴
  COMMUNITY: "community",
  // 커뮤니티 메뉴
  CHALLENGES: "challenges",
  // 챌린지 메뉴
  INSTRUCTOR: "instructor",
  // 강사 메뉴
  BUSINESS: "business",
  // 비즈니스 메뉴
  clips: "clips"
  // 클립 메뉴
}, kg = {
  SHOW_MENU: "data-show-menu",
  // 메뉴 표시 여부 (예: data-show-menu-courses="1")
  LABEL: "data-label",
  // 메뉴 라벨 텍스트 (예: data-label-courses="강의")
  SHOW_BUTTON: "data-show-button",
  // 버튼 표시 여부 (예: data-show-button-profile="1")
  COUNT: "data-count",
  // 카운트 값 (예: data-count-cart="3")
  FEATURE: "data-feature",
  // A/B 테스트 플래그 (예: data-feature-196="1")
  SHOW_SEARCH_BAR: "data-show-search-bar"
  // 검색바 표시 여부 (예: data-show-search-bar="1")
}, RI = {
  LABEL: "--label",
  // 메뉴 라벨 (예: --label-courses: "강의")
  CART_COUNT: "--cart-count",
  // 장바구니 개수 (예: --cart-count: "3")
  GNB_LOGO_URL: "--gnb-logo-url",
  // GNB 로고 이미지 (예: --gnb-logo-url: url('logo.png'))
  PROFILE_THUMBNAIL_URL: "--profile-thumbnail-url"
  // 프로필 썸네일 (예: --profile-thumbnail-url: url('thumb.jpg'))
};
function Rc(g) {
  const I = {};
  return g && g.split(";").forEach((c) => {
    const e = c.indexOf("=");
    if (e < 0)
      return;
    const l = decodeURIComponent(c.slice(0, e).trim()), i = decodeURIComponent(c.slice(e + 1).trim());
    l && (I[l] = i);
  }), I;
}
function Kb(g) {
  return (g == null ? void 0 : g.cookieHeader) != null ? Rc(g.cookieHeader) : typeof document < "u" ? Rc(document.cookie) : {};
}
function _b(g) {
  if (g)
    try {
      return JSON.parse(g);
    } catch {
      return;
    }
}
const qb = (g) => g ? `url('${g.replace(/'/g, "\\'")}')` : "none", Jc = (g) => g ? "1" : "0", $b = (g) => g == null || g === "" ? "0" : "1", gC = (g) => (g ?? "").toString(), He = (g) => `'${(g ?? "").replace(/'/g, "\\'")}'`, IC = (g, I) => {
  const c = {}, e = {};
  return Object.values(Te).forEach((l) => {
    const i = g[l], t = l === "courses" || I;
    c[`${kg.SHOW_MENU}-${l}`] = t ? $b(i) : "0", e[`${kg.LABEL}-${l}`] = gC(i);
  }), {
    visibilityAttributes: c,
    labelAttributes: e
  };
}, cC = (g) => {
  const I = {};
  return Object.values(Te).forEach((c) => {
    const e = g[c];
    I[`${RI.LABEL}-${c}`] = He(e);
  }), I;
};
function eC(g, I) {
  const c = {
    attrs: {},
    cssVars: {}
  };
  if (!g)
    return c;
  const e = g.menuList || {}, l = g.lang === "ko", {
    visibilityAttributes: i,
    labelAttributes: t
  } = IC(e, l), n = cC(e);
  Object.assign(c.cssVars, n), c.cssVars[`${RI.LABEL}-language`] = He(g.lang), Object.assign(c.attrs, i, t);
  const C = I != null && I.pathname ? Mb(I.pathname) : !1;
  if (c.attrs[kg.SHOW_SEARCH_BAR] = Jc(C), g.hackleFeatures)
    for (const [b, a] of Object.entries(g.hackleFeatures))
      c.attrs[`${kg.FEATURE}-${b}`] = Jc(!!a);
  return c.cssVars[RI.GNB_LOGO_URL] = qb(g.logo), c;
}
function Ts(g) {
  const I = Kb(g), c = _b(I[wg]), e = g != null && g.overwrite ? me({}, c, g.overwrite) : c;
  return eC(e, {
    pathname: g == null ? void 0 : g.pathname
  });
}
function Hs(g, I = "html", c = !1) {
  if (typeof document > "u")
    return c;
  const l = (I === "html" ? document.documentElement : I === "body" ? document.body : document.querySelector(I) || document.documentElement).getAttribute(g);
  return l === null ? c : l === "1" || l === "true" || l === "True";
}
function ws(g, I = "html", c = "") {
  if (typeof document > "u")
    return c;
  const l = (I === "html" ? document.documentElement : I === "body" ? document.body : document.querySelector(I) || document.documentElement).getAttribute(g);
  return l === null ? c : l;
}
function Us(g, I = "html") {
  if (typeof document > "u")
    return;
  const c = I === "html" ? document.documentElement : I === "body" ? document.body : document.querySelector(I) || document.documentElement;
  Object.entries(g.attrs).forEach(([e, l]) => c.setAttribute(e, l)), Object.entries(g.cssVars).forEach(([e, l]) => c.style.setProperty(e, l));
}
function lC(g) {
  return g / (24 * 60);
}
const iC = 60 * 24, tC = () => {
  const g = Ug((c) => {
    const e = I(), l = typeof document < "u" && document.documentElement.lang || "ko", i = {
      ...c,
      lang: l
    };
    Hg.set(wg, JSON.stringify(me({}, e, i)), lC(iC), "High");
  }, []), I = Ug(() => {
    const c = Hg.get(wg);
    if (!c)
      return null;
    try {
      return JSON.parse(c);
    } catch (e) {
      return console.error("Failed to parse GNB Snapshot:", e), Hg.remove(wg), null;
    }
  }, []);
  return {
    setSnapshot: g,
    getSnapshot: I
  };
}, JI = (g) => !!g.group || !!g.managedGroup, nC = (g) => !!g.group, bC = (g) => !!g.managedGroup, CC = (g) => !!g.marketingPartner, aC = 42, sC = 6233, Ls = (g) => g === sC || g === aC, kI = Lb, pI = {
  CLIENT_V2_ACCOUNTS_PROFILE: "/client/api/v2/accounts/profile",
  CLIENT_V2_AUTH_SIGNIN: "/client/api/v2/auth/signin",
  CLIENT_V3_AUTH_SIGNUP_VERIFY_EMAIL: "/client/api/v3/auth/signup/verify/email"
};
function Os({
  url: g,
  options: I,
  requestOptions: c
}) {
  var l;
  const e = ee({
    mutationFn: (i) => kI.post(g, i, c),
    ...I
  });
  return {
    ...e,
    data: (l = e.data) == null ? void 0 : l.data
  };
}
function Es({
  url: g,
  options: I,
  requestOptions: c
}) {
  var l;
  const e = ee({
    mutationFn: (i) => kI.post(g, i, c),
    ...I
  });
  return {
    ...e,
    data: (l = e.data) == null ? void 0 : l.data
  };
}
const AC = async (g, I) => kI.get(g, I), uC = ({
  queryKey: g,
  url: I,
  options: c,
  requestOptions: e
}) => ({
  queryKey: g,
  queryFn: () => AC(I, e),
  ...c
});
function dC(g) {
  var c;
  const I = vg(uC(g));
  return {
    ...I,
    data: (c = I.data) == null ? void 0 : c.data
  };
}
const js = (g) => g * (24 * (60 * (1e3 * 60))), Ds = (g) => g * 1e3, pc = (g) => g * (1e3 * 60);
function rC(g) {
  const I = g == null ? void 0 : g.options;
  return dC({
    queryKey: [pI.CLIENT_V2_ACCOUNTS_PROFILE],
    url: pI.CLIENT_V2_ACCOUNTS_PROFILE,
    options: {
      cacheTime: pc(1),
      staleTime: pc(1),
      suspense: !1,
      useErrorBoundary: !1,
      keepPreviousData: !0,
      refetchOnReconnect: !0,
      ...I
    }
  });
}
const we = YI(null), Ps = (g) => /* @__PURE__ */ W(we.Provider, { value: {
  isShowing: g.isShowing
}, children: g.children }), oC = () => {
  const g = fI(we);
  if (!g)
    throw Error("useShowLoginNeededNotificationContext must use in ShowLoginNeededNotificationContext");
  return g;
};
function GC(g) {
  const {
    isShowing: I
  } = oC(), {
    showNotification: c
  } = il(), {
    t: e
  } = ve();
  eg(() => {
    g instanceof Zg && g.statusCode === ze.UNAUTHORIZED && I && (tl("UNAUTHORIZED"), c({
      type: "error",
      id: "UNAUTHORIZED",
      title: e("로그인이 필요한 요청입니다.")
    }));
  }, [I, g]);
}
var Ue = {}, XC = (g) => encodeURIComponent(g).replace(/[!'()*]/g, (I) => `%${I.charCodeAt(0).toString(16).toUpperCase()}`), Le = "%[a-f0-9]{2}", yc = new RegExp("(" + Le + ")|([^%]+?)", "gi"), vc = new RegExp("(" + Le + ")+", "gi");
function yI(g, I) {
  try {
    return [decodeURIComponent(g.join(""))];
  } catch {
  }
  if (g.length === 1)
    return g;
  I = I || 1;
  var c = g.slice(0, I), e = g.slice(I);
  return Array.prototype.concat.call([], yI(c), yI(e));
}
function ZC(g) {
  try {
    return decodeURIComponent(g);
  } catch {
    for (var I = g.match(yc) || [], c = 1; c < I.length; c++)
      g = yI(I, c).join(""), I = g.match(yc) || [];
    return g;
  }
}
function WC(g) {
  for (var I = {
    "%FE%FF": "��",
    "%FF%FE": "��"
  }, c = vc.exec(g); c; ) {
    try {
      I[c[0]] = decodeURIComponent(c[0]);
    } catch {
      var e = ZC(c[0]);
      e !== c[0] && (I[c[0]] = e);
    }
    c = vc.exec(g);
  }
  I["%C2"] = "�";
  for (var l = Object.keys(I), i = 0; i < l.length; i++) {
    var t = l[i];
    g = g.replace(new RegExp(t, "g"), I[t]);
  }
  return g;
}
var hC = function(g) {
  if (typeof g != "string")
    throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof g + "`");
  try {
    return g = g.replace(/\+/g, " "), decodeURIComponent(g);
  } catch {
    return WC(g);
  }
}, VC = (g, I) => {
  if (!(typeof g == "string" && typeof I == "string"))
    throw new TypeError("Expected the arguments to be of type `string`");
  if (I === "")
    return [g];
  const c = g.indexOf(I);
  return c === -1 ? [g] : [
    g.slice(0, c),
    g.slice(c + I.length)
  ];
}, xC = function(g, I) {
  for (var c = {}, e = Object.keys(g), l = Array.isArray(I), i = 0; i < e.length; i++) {
    var t = e[i], n = g[t];
    (l ? I.indexOf(t) !== -1 : I(t, n, g)) && (c[t] = n);
  }
  return c;
};
(function(g) {
  const I = XC, c = hC, e = VC, l = xC, i = (s) => s == null, t = Symbol("encodeFragmentIdentifier");
  function n(s) {
    switch (s.arrayFormat) {
      case "index":
        return (r) => (d, o) => {
          const X = d.length;
          return o === void 0 || s.skipNull && o === null || s.skipEmptyString && o === "" ? d : o === null ? [...d, [a(r, s), "[", X, "]"].join("")] : [
            ...d,
            [a(r, s), "[", a(X, s), "]=", a(o, s)].join("")
          ];
        };
      case "bracket":
        return (r) => (d, o) => o === void 0 || s.skipNull && o === null || s.skipEmptyString && o === "" ? d : o === null ? [...d, [a(r, s), "[]"].join("")] : [...d, [a(r, s), "[]=", a(o, s)].join("")];
      case "colon-list-separator":
        return (r) => (d, o) => o === void 0 || s.skipNull && o === null || s.skipEmptyString && o === "" ? d : o === null ? [...d, [a(r, s), ":list="].join("")] : [...d, [a(r, s), ":list=", a(o, s)].join("")];
      case "comma":
      case "separator":
      case "bracket-separator": {
        const r = s.arrayFormat === "bracket-separator" ? "[]=" : "=";
        return (d) => (o, X) => X === void 0 || s.skipNull && X === null || s.skipEmptyString && X === "" ? o : (X = X === null ? "" : X, o.length === 0 ? [[a(d, s), r, a(X, s)].join("")] : [[o, a(X, s)].join(s.arrayFormatSeparator)]);
      }
      default:
        return (r) => (d, o) => o === void 0 || s.skipNull && o === null || s.skipEmptyString && o === "" ? d : o === null ? [...d, a(r, s)] : [...d, [a(r, s), "=", a(o, s)].join("")];
    }
  }
  function C(s) {
    let r;
    switch (s.arrayFormat) {
      case "index":
        return (d, o, X) => {
          if (r = /\[(\d*)\]$/.exec(d), d = d.replace(/\[\d*\]$/, ""), !r) {
            X[d] = o;
            return;
          }
          X[d] === void 0 && (X[d] = {}), X[d][r[1]] = o;
        };
      case "bracket":
        return (d, o, X) => {
          if (r = /(\[\])$/.exec(d), d = d.replace(/\[\]$/, ""), !r) {
            X[d] = o;
            return;
          }
          if (X[d] === void 0) {
            X[d] = [o];
            return;
          }
          X[d] = [].concat(X[d], o);
        };
      case "colon-list-separator":
        return (d, o, X) => {
          if (r = /(:list)$/.exec(d), d = d.replace(/:list$/, ""), !r) {
            X[d] = o;
            return;
          }
          if (X[d] === void 0) {
            X[d] = [o];
            return;
          }
          X[d] = [].concat(X[d], o);
        };
      case "comma":
      case "separator":
        return (d, o, X) => {
          const x = typeof o == "string" && o.includes(s.arrayFormatSeparator), h = typeof o == "string" && !x && u(o, s).includes(s.arrayFormatSeparator);
          o = h ? u(o, s) : o;
          const J = x || h ? o.split(s.arrayFormatSeparator).map((T) => u(T, s)) : o === null ? o : u(o, s);
          X[d] = J;
        };
      case "bracket-separator":
        return (d, o, X) => {
          const x = /(\[\])$/.test(d);
          if (d = d.replace(/\[\]$/, ""), !x) {
            X[d] = o && u(o, s);
            return;
          }
          const h = o === null ? [] : o.split(s.arrayFormatSeparator).map((J) => u(J, s));
          if (X[d] === void 0) {
            X[d] = h;
            return;
          }
          X[d] = [].concat(X[d], h);
        };
      default:
        return (d, o, X) => {
          if (X[d] === void 0) {
            X[d] = o;
            return;
          }
          X[d] = [].concat(X[d], o);
        };
    }
  }
  function b(s) {
    if (typeof s != "string" || s.length !== 1)
      throw new TypeError("arrayFormatSeparator must be single character string");
  }
  function a(s, r) {
    return r.encode ? r.strict ? I(s) : encodeURIComponent(s) : s;
  }
  function u(s, r) {
    return r.decode ? c(s) : s;
  }
  function A(s) {
    return Array.isArray(s) ? s.sort() : typeof s == "object" ? A(Object.keys(s)).sort((r, d) => Number(r) - Number(d)).map((r) => s[r]) : s;
  }
  function G(s) {
    const r = s.indexOf("#");
    return r !== -1 && (s = s.slice(0, r)), s;
  }
  function m(s) {
    let r = "";
    const d = s.indexOf("#");
    return d !== -1 && (r = s.slice(d)), r;
  }
  function V(s) {
    s = G(s);
    const r = s.indexOf("?");
    return r === -1 ? "" : s.slice(r + 1);
  }
  function R(s, r) {
    return r.parseNumbers && !Number.isNaN(Number(s)) && typeof s == "string" && s.trim() !== "" ? s = Number(s) : r.parseBooleans && s !== null && (s.toLowerCase() === "true" || s.toLowerCase() === "false") && (s = s.toLowerCase() === "true"), s;
  }
  function y(s, r) {
    r = Object.assign({
      decode: !0,
      sort: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ",",
      parseNumbers: !1,
      parseBooleans: !1
    }, r), b(r.arrayFormatSeparator);
    const d = C(r), o = /* @__PURE__ */ Object.create(null);
    if (typeof s != "string" || (s = s.trim().replace(/^[?#&]/, ""), !s))
      return o;
    for (const X of s.split("&")) {
      if (X === "")
        continue;
      let [x, h] = e(r.decode ? X.replace(/\+/g, " ") : X, "=");
      h = h === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(r.arrayFormat) ? h : u(h, r), d(u(x, r), h, o);
    }
    for (const X of Object.keys(o)) {
      const x = o[X];
      if (typeof x == "object" && x !== null)
        for (const h of Object.keys(x))
          x[h] = R(x[h], r);
      else
        o[X] = R(x, r);
    }
    return r.sort === !1 ? o : (r.sort === !0 ? Object.keys(o).sort() : Object.keys(o).sort(r.sort)).reduce((X, x) => {
      const h = o[x];
      return h && typeof h == "object" && !Array.isArray(h) ? X[x] = A(h) : X[x] = h, X;
    }, /* @__PURE__ */ Object.create(null));
  }
  g.extract = V, g.parse = y, g.stringify = (s, r) => {
    if (!s)
      return "";
    r = Object.assign({
      encode: !0,
      strict: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ","
    }, r), b(r.arrayFormatSeparator);
    const d = (h) => r.skipNull && i(s[h]) || r.skipEmptyString && s[h] === "", o = n(r), X = {};
    for (const h of Object.keys(s))
      d(h) || (X[h] = s[h]);
    const x = Object.keys(X);
    return r.sort !== !1 && x.sort(r.sort), x.map((h) => {
      const J = s[h];
      return J === void 0 ? "" : J === null ? a(h, r) : Array.isArray(J) ? J.length === 0 && r.arrayFormat === "bracket-separator" ? a(h, r) + "[]" : J.reduce(o(h), []).join("&") : a(h, r) + "=" + a(J, r);
    }).filter((h) => h.length > 0).join("&");
  }, g.parseUrl = (s, r) => {
    r = Object.assign({
      decode: !0
    }, r);
    const [d, o] = e(s, "#");
    return Object.assign(
      {
        url: d.split("?")[0] || "",
        query: y(V(s), r)
      },
      r && r.parseFragmentIdentifier && o ? { fragmentIdentifier: u(o, r) } : {}
    );
  }, g.stringifyUrl = (s, r) => {
    r = Object.assign({
      encode: !0,
      strict: !0,
      [t]: !0
    }, r);
    const d = G(s.url).split("?")[0] || "", o = g.extract(s.url), X = g.parse(o, { sort: !1 }), x = Object.assign(X, s.query);
    let h = g.stringify(x, r);
    h && (h = `?${h}`);
    let J = m(s.url);
    return s.fragmentIdentifier && (J = `#${r[t] ? a(s.fragmentIdentifier, r) : s.fragmentIdentifier}`), `${d}${h}${J}`;
  }, g.pick = (s, r, d) => {
    d = Object.assign({
      parseFragmentIdentifier: !0,
      [t]: !1
    }, d);
    const { url: o, query: X, fragmentIdentifier: x } = g.parseUrl(s, d);
    return g.stringifyUrl({
      url: o,
      query: l(X, r),
      fragmentIdentifier: x
    }, d);
  }, g.exclude = (s, r, d) => {
    const o = Array.isArray(r) ? (X) => !r.includes(X) : (X, x) => !r(X, x);
    return g.pick(s, o, d);
  };
})(Ue);
const E = /* @__PURE__ */ Ne(Ue), mC = {
  CLICK_SEARCHBAR: "click_searchbar",
  GNB_NOTI_ICON_CLICK: "GNB_noti-icon-click",
  GNB_ROADMAP_CLICK: "GNB_roadmap-click",
  GNB_PROFILE_ICON_CLICK: "GNB_profile-icon-click",
  GNB_OPENKNOWLEDGE_CLICK: "GNB_openknowledge-click",
  GNB_MENTORS_CLICK: "GNB_mentors-click",
  GNB_LOGIN_BTN_CLICK: "GNB_login-btn-click",
  CLICK_CATEGORY_AT_HEADER: "click_category_at_header",
  VIEW_SIGNIN_MODAL: "view_signin_modal",
  CLICK_SIGNIN_AT_SIGNIN: "click_signin_at_signin",
  CLICK_FIND_ID_AT_SIGNIN: "click_find_id_at_signin",
  CLICK_FIND_PW_AT_SIGNIN: "click_find_pw_at_signin",
  CLICK_SIGNUP_AT_SIGNIN: "click_signup_at_signin",
  /**
   * @deprecated 헤더 '인프런' 메뉴 deprecated
   * */
  GNB_COURSES_CLICK: "GNB_courses-click",
  GNB_COMMUNITY_CLICK: "GNB_community-click",
  GNB_CART_COURSE_CLICK: "GNB_cart-course-click",
  GNB_CART_TOTAL_CLICK: "GNB_cart-total-click",
  GNB_INFLEARN_LOGO_CLICK: "GNB_inflearn-logo-click",
  GNB_CART_ICON_CLICK: "GNB_cart-icon-click",
  GNB_RALLIT_CLICK: "GNB_Rallit_Click",
  GNB_SEARCH_ICON_CLICK: "GNB_search-icon-click",
  GNB_SEARCH_INPUT_CLICK: "GNB_search-input-click",
  GNB_DASHBOARD_CLICK: "GNB_dashboard-click",
  HEADER_BUSINESS_CLICK: "Header_business-click",
  HEADER_INFLEARN_CLICK: "Header_inflearn-click",
  HEADER_INSTRUCTOR_CLICK: "Header_instructor-click",
  HEADER_BIZ_INTRO_CLICK: "header_biz-intro-click",
  COMPLETE_SIGNUP: "complete_signup",
  COMPLETE_REGISTRATION: "complete_registration",
  CLICK_WELCOME_BUTTON: "click_welcome_button",
  CLICK_MYCATEGORY_GUIDE_BUTTON: "click_mycategory_guide_button",
  VIEW_MYCATEGORY: "view_mycategory",
  CLICK_SAVE_MYCATEGORY: "click_save_mycategory",
  SEARCH_COURSE: "search_course",
  EXPERIMENT_STARTED: "experiment_started",
  /**
   * 신규 헤더 신규 이벤트
   */
  CLICK_HEADER_MENU: "click_header_menu",
  CLICK_LOGO_AT_HEADER: "click_logo_at_header",
  CLICK_LOGIN_AT_HEADER: "click_login_at_header",
  CLICK_CART_AT_HEADER: "click_cart_at_header",
  CLICK_PROFILE_MENU_AT_HEADER: "click_profile_menu_at_header",
  CLICK_CATEGORY_AT_SEARCHBAR: "click_category_at_searchbar",
  CLICK_HEADER_MENU_AT_SEARCHBAR: "click_header_menu_at_searchbar",
  CLICK_RECOMMENDATION_AT_SEARCHBAR: "click_recommendation_at_searchbar",
  CLICK_HEADER_NOTICE: "click_header_notice",
  CLICK_SERVICE_MENU_AT_HEADER: "click_service_menu_at_header"
};
var cg = { ko: "ko", en: "en", ja: "ja", vi: "vi" }, lg = cg.ko;
Object.values(cg);
var NC = { [cg.ko]: "82", [cg.en]: "1", [cg.ja]: "81", [cg.vi]: "84" }, f = { ko: "ko-KR", en: "en-US", ja: "ja-JP", vi: "vi-VN" };
function RC() {
  let { i18n: g } = ye();
  return Lg(() => {
    let I = g.language || lg;
    return { lang: I, locale: f[I], countryCode: NC[I], isKo: I === lg };
  }, [g.language]);
}
var ks = ({ children: g }) => {
  let { isKo: I } = RC();
  return Ie(ce, { children: I && g });
};
TI.extend(sl);
TI.extend(al);
TI.updateLocale("ko", { formats: { L: "YYYY. MM. DD.", LL: "YYYY년 MM월 DD일", LT: "A h:mm" } });
var Wg = { [f.ko]: "KRW", [f.en]: "USD", [f.ja]: "JPY", [f.vi]: "VND" }, JC = { [Wg[f.ko]]: f.ko, [Wg[f.en]]: f.en, [Wg[f.ja]]: f.ja, [Wg[f.vi]]: f.vi }, pC = (g, I) => new Intl.NumberFormat(g, { style: "currency", currency: I }), yC = ({ locale: g, amount: I, currency: c, hiddenKRW: e = !1, leftSection: l = "", rightSection: i = "", ...t }) => {
  let n = g ?? JC[c ?? f.ko], C = c ?? Wg[n], b = Lg(() => pC(n, C), [n, C]), a = Lg(() => e && g === f.ko ? I.toLocaleString() : b.format(Number(I)), [g, b, I, e]);
  return Ie(BI, { ...t, children: Cl(ce, { children: [l, a, i] }) });
};
nl(yC);
const N = (g) => typeof g == "string", rg = () => {
  let g, I;
  const c = new Promise((e, l) => {
    g = e, I = l;
  });
  return c.resolve = g, c.reject = I, c;
}, Bc = (g) => g == null ? "" : "" + g, vC = (g, I, c) => {
  g.forEach((e) => {
    I[e] && (c[e] = I[e]);
  });
}, BC = /###/g, Fc = (g) => g && g.indexOf("###") > -1 ? g.replace(BC, ".") : g, Yc = (g) => !g || N(g), Vg = (g, I, c) => {
  const e = N(I) ? I.split(".") : I;
  let l = 0;
  for (; l < e.length - 1; ) {
    if (Yc(g))
      return {};
    const i = Fc(e[l]);
    !g[i] && c && (g[i] = new c()), Object.prototype.hasOwnProperty.call(g, i) ? g = g[i] : g = {}, ++l;
  }
  return Yc(g) ? {} : {
    obj: g,
    k: Fc(e[l])
  };
}, fc = (g, I, c) => {
  const {
    obj: e,
    k: l
  } = Vg(g, I, Object);
  if (e !== void 0 || I.length === 1) {
    e[l] = c;
    return;
  }
  let i = I[I.length - 1], t = I.slice(0, I.length - 1), n = Vg(g, t, Object);
  for (; n.obj === void 0 && t.length; )
    i = `${t[t.length - 1]}.${i}`, t = t.slice(0, t.length - 1), n = Vg(g, t, Object), n && n.obj && typeof n.obj[`${n.k}.${i}`] < "u" && (n.obj = void 0);
  n.obj[`${n.k}.${i}`] = c;
}, FC = (g, I, c, e) => {
  const {
    obj: l,
    k: i
  } = Vg(g, I, Object);
  l[i] = l[i] || [], l[i].push(c);
}, Qg = (g, I) => {
  const {
    obj: c,
    k: e
  } = Vg(g, I);
  if (c)
    return c[e];
}, YC = (g, I, c) => {
  const e = Qg(g, c);
  return e !== void 0 ? e : Qg(I, c);
}, Oe = (g, I, c) => {
  for (const e in I)
    e !== "__proto__" && e !== "constructor" && (e in g ? N(g[e]) || g[e] instanceof String || N(I[e]) || I[e] instanceof String ? c && (g[e] = I[e]) : Oe(g[e], I[e], c) : g[e] = I[e]);
  return g;
}, gg = (g) => g.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var fC = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const zC = (g) => N(g) ? g.replace(/[&<>"'\/]/g, (I) => fC[I]) : g;
class SC {
  constructor(I) {
    this.capacity = I, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(I) {
    const c = this.regExpMap.get(I);
    if (c !== void 0)
      return c;
    const e = new RegExp(I);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(I, e), this.regExpQueue.push(I), e;
  }
}
const TC = [" ", ",", "?", "!", ";"], HC = new SC(20), wC = (g, I, c) => {
  I = I || "", c = c || "";
  const e = TC.filter((t) => I.indexOf(t) < 0 && c.indexOf(t) < 0);
  if (e.length === 0)
    return !0;
  const l = HC.getRegExp(`(${e.map((t) => t === "?" ? "\\?" : t).join("|")})`);
  let i = !l.test(g);
  if (!i) {
    const t = g.indexOf(c);
    t > 0 && !l.test(g.substring(0, t)) && (i = !0);
  }
  return i;
}, vI = function(g, I) {
  let c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!g)
    return;
  if (g[I])
    return g[I];
  const e = I.split(c);
  let l = g;
  for (let i = 0; i < e.length; ) {
    if (!l || typeof l != "object")
      return;
    let t, n = "";
    for (let C = i; C < e.length; ++C)
      if (C !== i && (n += c), n += e[C], t = l[n], t !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof t) > -1 && C < e.length - 1)
          continue;
        i += C - i + 1;
        break;
      }
    l = t;
  }
  return l;
}, Mg = (g) => g && g.replace("_", "-"), UC = {
  type: "logger",
  log(g) {
    this.output("log", g);
  },
  warn(g) {
    this.output("warn", g);
  },
  error(g) {
    this.output("error", g);
  },
  output(g, I) {
    console && console[g] && console[g].apply(console, I);
  }
};
class Kg {
  constructor(I) {
    let c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(I, c);
  }
  init(I) {
    let c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = c.prefix || "i18next:", this.logger = I || UC, this.options = c, this.debug = c.debug;
  }
  log() {
    for (var I = arguments.length, c = new Array(I), e = 0; e < I; e++)
      c[e] = arguments[e];
    return this.forward(c, "log", "", !0);
  }
  warn() {
    for (var I = arguments.length, c = new Array(I), e = 0; e < I; e++)
      c[e] = arguments[e];
    return this.forward(c, "warn", "", !0);
  }
  error() {
    for (var I = arguments.length, c = new Array(I), e = 0; e < I; e++)
      c[e] = arguments[e];
    return this.forward(c, "error", "");
  }
  deprecate() {
    for (var I = arguments.length, c = new Array(I), e = 0; e < I; e++)
      c[e] = arguments[e];
    return this.forward(c, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(I, c, e, l) {
    return l && !this.debug ? null : (N(I[0]) && (I[0] = `${e}${this.prefix} ${I[0]}`), this.logger[c](I));
  }
  create(I) {
    return new Kg(this.logger, {
      prefix: `${this.prefix}:${I}:`,
      ...this.options
    });
  }
  clone(I) {
    return I = I || this.options, I.prefix = I.prefix || this.prefix, new Kg(this.logger, I);
  }
}
var O = new Kg();
class nI {
  constructor() {
    this.observers = {};
  }
  on(I, c) {
    return I.split(" ").forEach((e) => {
      this.observers[e] || (this.observers[e] = /* @__PURE__ */ new Map());
      const l = this.observers[e].get(c) || 0;
      this.observers[e].set(c, l + 1);
    }), this;
  }
  off(I, c) {
    if (this.observers[I]) {
      if (!c) {
        delete this.observers[I];
        return;
      }
      this.observers[I].delete(c);
    }
  }
  emit(I) {
    for (var c = arguments.length, e = new Array(c > 1 ? c - 1 : 0), l = 1; l < c; l++)
      e[l - 1] = arguments[l];
    this.observers[I] && Array.from(this.observers[I].entries()).forEach((t) => {
      let [n, C] = t;
      for (let b = 0; b < C; b++)
        n(...e);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((t) => {
      let [n, C] = t;
      for (let b = 0; b < C; b++)
        n.apply(n, [I, ...e]);
    });
  }
}
class zc extends nI {
  constructor(I) {
    let c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = I || {}, this.options = c, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(I) {
    this.options.ns.indexOf(I) < 0 && this.options.ns.push(I);
  }
  removeNamespaces(I) {
    const c = this.options.ns.indexOf(I);
    c > -1 && this.options.ns.splice(c, 1);
  }
  getResource(I, c, e) {
    let l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = l.keySeparator !== void 0 ? l.keySeparator : this.options.keySeparator, t = l.ignoreJSONStructure !== void 0 ? l.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let n;
    I.indexOf(".") > -1 ? n = I.split(".") : (n = [I, c], e && (Array.isArray(e) ? n.push(...e) : N(e) && i ? n.push(...e.split(i)) : n.push(e)));
    const C = Qg(this.data, n);
    return !C && !c && !e && I.indexOf(".") > -1 && (I = n[0], c = n[1], e = n.slice(2).join(".")), C || !t || !N(e) ? C : vI(this.data && this.data[I] && this.data[I][c], e, i);
  }
  addResource(I, c, e, l) {
    let i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const t = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator;
    let n = [I, c];
    e && (n = n.concat(t ? e.split(t) : e)), I.indexOf(".") > -1 && (n = I.split("."), l = c, c = n[1]), this.addNamespaces(c), fc(this.data, n, l), i.silent || this.emit("added", I, c, e, l);
  }
  addResources(I, c, e) {
    let l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const i in e)
      (N(e[i]) || Array.isArray(e[i])) && this.addResource(I, c, i, e[i], {
        silent: !0
      });
    l.silent || this.emit("added", I, c, e);
  }
  addResourceBundle(I, c, e, l, i) {
    let t = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, n = [I, c];
    I.indexOf(".") > -1 && (n = I.split("."), l = e, e = c, c = n[1]), this.addNamespaces(c);
    let C = Qg(this.data, n) || {};
    t.skipCopy || (e = JSON.parse(JSON.stringify(e))), l ? Oe(C, e, i) : C = {
      ...C,
      ...e
    }, fc(this.data, n, C), t.silent || this.emit("added", I, c, e);
  }
  removeResourceBundle(I, c) {
    this.hasResourceBundle(I, c) && delete this.data[I][c], this.removeNamespaces(c), this.emit("removed", I, c);
  }
  hasResourceBundle(I, c) {
    return this.getResource(I, c) !== void 0;
  }
  getResourceBundle(I, c) {
    return c || (c = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(I, c)
    } : this.getResource(I, c);
  }
  getDataByLanguage(I) {
    return this.data[I];
  }
  hasLanguageSomeTranslations(I) {
    const c = this.getDataByLanguage(I);
    return !!(c && Object.keys(c) || []).find((l) => c[l] && Object.keys(c[l]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var Ee = {
  processors: {},
  addPostProcessor(g) {
    this.processors[g.name] = g;
  },
  handle(g, I, c, e, l) {
    return g.forEach((i) => {
      this.processors[i] && (I = this.processors[i].process(I, c, e, l));
    }), I;
  }
};
const Sc = {};
class _g extends nI {
  constructor(I) {
    let c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), vC(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], I, this), this.options = c, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = O.create("translator");
  }
  changeLanguage(I) {
    I && (this.language = I);
  }
  exists(I) {
    let c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (I == null)
      return !1;
    const e = this.resolve(I, c);
    return e && e.res !== void 0;
  }
  extractFromKey(I, c) {
    let e = c.nsSeparator !== void 0 ? c.nsSeparator : this.options.nsSeparator;
    e === void 0 && (e = ":");
    const l = c.keySeparator !== void 0 ? c.keySeparator : this.options.keySeparator;
    let i = c.ns || this.options.defaultNS || [];
    const t = e && I.indexOf(e) > -1, n = !this.options.userDefinedKeySeparator && !c.keySeparator && !this.options.userDefinedNsSeparator && !c.nsSeparator && !wC(I, e, l);
    if (t && !n) {
      const C = I.match(this.interpolator.nestingRegexp);
      if (C && C.length > 0)
        return {
          key: I,
          namespaces: i
        };
      const b = I.split(e);
      (e !== l || e === l && this.options.ns.indexOf(b[0]) > -1) && (i = b.shift()), I = b.join(l);
    }
    return N(i) && (i = [i]), {
      key: I,
      namespaces: i
    };
  }
  translate(I, c, e) {
    if (typeof c != "object" && this.options.overloadTranslationOptionHandler && (c = this.options.overloadTranslationOptionHandler(arguments)), typeof c == "object" && (c = {
      ...c
    }), c || (c = {}), I == null)
      return "";
    Array.isArray(I) || (I = [String(I)]);
    const l = c.returnDetails !== void 0 ? c.returnDetails : this.options.returnDetails, i = c.keySeparator !== void 0 ? c.keySeparator : this.options.keySeparator, {
      key: t,
      namespaces: n
    } = this.extractFromKey(I[I.length - 1], c), C = n[n.length - 1], b = c.lng || this.language, a = c.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (b && b.toLowerCase() === "cimode") {
      if (a) {
        const d = c.nsSeparator || this.options.nsSeparator;
        return l ? {
          res: `${C}${d}${t}`,
          usedKey: t,
          exactUsedKey: t,
          usedLng: b,
          usedNS: C,
          usedParams: this.getUsedParamsDetails(c)
        } : `${C}${d}${t}`;
      }
      return l ? {
        res: t,
        usedKey: t,
        exactUsedKey: t,
        usedLng: b,
        usedNS: C,
        usedParams: this.getUsedParamsDetails(c)
      } : t;
    }
    const u = this.resolve(I, c);
    let A = u && u.res;
    const G = u && u.usedKey || t, m = u && u.exactUsedKey || t, V = Object.prototype.toString.apply(A), R = ["[object Number]", "[object Function]", "[object RegExp]"], y = c.joinArrays !== void 0 ? c.joinArrays : this.options.joinArrays, s = !this.i18nFormat || this.i18nFormat.handleAsObject, r = !N(A) && typeof A != "boolean" && typeof A != "number";
    if (s && A && r && R.indexOf(V) < 0 && !(N(y) && Array.isArray(A))) {
      if (!c.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const d = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(G, A, {
          ...c,
          ns: n
        }) : `key '${t} (${this.language})' returned an object instead of string.`;
        return l ? (u.res = d, u.usedParams = this.getUsedParamsDetails(c), u) : d;
      }
      if (i) {
        const d = Array.isArray(A), o = d ? [] : {}, X = d ? m : G;
        for (const x in A)
          if (Object.prototype.hasOwnProperty.call(A, x)) {
            const h = `${X}${i}${x}`;
            o[x] = this.translate(h, {
              ...c,
              joinArrays: !1,
              ns: n
            }), o[x] === h && (o[x] = A[x]);
          }
        A = o;
      }
    } else if (s && N(y) && Array.isArray(A))
      A = A.join(y), A && (A = this.extendTranslation(A, I, c, e));
    else {
      let d = !1, o = !1;
      const X = c.count !== void 0 && !N(c.count), x = _g.hasDefaultValue(c), h = X ? this.pluralResolver.getSuffix(b, c.count, c) : "", J = c.ordinal && X ? this.pluralResolver.getSuffix(b, c.count, {
        ordinal: !1
      }) : "", T = X && !c.ordinal && c.count === 0 && this.pluralResolver.shouldUseIntlApi(), Y = T && c[`defaultValue${this.options.pluralSeparator}zero`] || c[`defaultValue${h}`] || c[`defaultValue${J}`] || c.defaultValue;
      !this.isValidLookup(A) && x && (d = !0, A = Y), this.isValidLookup(A) || (o = !0, A = t);
      const cl = (c.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && o ? void 0 : A, sg = x && Y !== A && this.options.updateMissing;
      if (o || d || sg) {
        if (this.logger.log(sg ? "updateKey" : "missingKey", b, C, t, sg ? Y : A), i) {
          const H = this.resolve(t, {
            ...c,
            keySeparator: !1
          });
          H && H.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let Ag = [];
        const Fg = this.languageUtils.getFallbackCodes(this.options.fallbackLng, c.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && Fg && Fg[0])
          for (let H = 0; H < Fg.length; H++)
            Ag.push(Fg[H]);
        else
          this.options.saveMissingTo === "all" ? Ag = this.languageUtils.toResolveHierarchy(c.lng || this.language) : Ag.push(c.lng || this.language);
        const $I = (H, M, ug) => {
          const gc = x && ug !== A ? ug : cl;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(H, C, M, gc, sg, c) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(H, C, M, gc, sg, c), this.emit("missingKey", H, C, M, A);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && X ? Ag.forEach((H) => {
          const M = this.pluralResolver.getSuffixes(H, c);
          T && c[`defaultValue${this.options.pluralSeparator}zero`] && M.indexOf(`${this.options.pluralSeparator}zero`) < 0 && M.push(`${this.options.pluralSeparator}zero`), M.forEach((ug) => {
            $I([H], t + ug, c[`defaultValue${ug}`] || Y);
          });
        }) : $I(Ag, t, Y));
      }
      A = this.extendTranslation(A, I, c, u, e), o && A === t && this.options.appendNamespaceToMissingKey && (A = `${C}:${t}`), (o || d) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? A = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${C}:${t}` : t, d ? A : void 0) : A = this.options.parseMissingKeyHandler(A));
    }
    return l ? (u.res = A, u.usedParams = this.getUsedParamsDetails(c), u) : A;
  }
  extendTranslation(I, c, e, l, i) {
    var t = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      I = this.i18nFormat.parse(I, {
        ...this.options.interpolation.defaultVariables,
        ...e
      }, e.lng || this.language || l.usedLng, l.usedNS, l.usedKey, {
        resolved: l
      });
    else if (!e.skipInterpolation) {
      e.interpolation && this.interpolator.init({
        ...e,
        interpolation: {
          ...this.options.interpolation,
          ...e.interpolation
        }
      });
      const b = N(I) && (e && e.interpolation && e.interpolation.skipOnVariables !== void 0 ? e.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let a;
      if (b) {
        const A = I.match(this.interpolator.nestingRegexp);
        a = A && A.length;
      }
      let u = e.replace && !N(e.replace) ? e.replace : e;
      if (this.options.interpolation.defaultVariables && (u = {
        ...this.options.interpolation.defaultVariables,
        ...u
      }), I = this.interpolator.interpolate(I, u, e.lng || this.language || l.usedLng, e), b) {
        const A = I.match(this.interpolator.nestingRegexp), G = A && A.length;
        a < G && (e.nest = !1);
      }
      !e.lng && this.options.compatibilityAPI !== "v1" && l && l.res && (e.lng = this.language || l.usedLng), e.nest !== !1 && (I = this.interpolator.nest(I, function() {
        for (var A = arguments.length, G = new Array(A), m = 0; m < A; m++)
          G[m] = arguments[m];
        return i && i[0] === G[0] && !e.context ? (t.logger.warn(`It seems you are nesting recursively key: ${G[0]} in key: ${c[0]}`), null) : t.translate(...G, c);
      }, e)), e.interpolation && this.interpolator.reset();
    }
    const n = e.postProcess || this.options.postProcess, C = N(n) ? [n] : n;
    return I != null && C && C.length && e.applyPostProcessor !== !1 && (I = Ee.handle(C, I, c, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...l,
        usedParams: this.getUsedParamsDetails(e)
      },
      ...e
    } : e, this)), I;
  }
  resolve(I) {
    let c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, e, l, i, t, n;
    return N(I) && (I = [I]), I.forEach((C) => {
      if (this.isValidLookup(e))
        return;
      const b = this.extractFromKey(C, c), a = b.key;
      l = a;
      let u = b.namespaces;
      this.options.fallbackNS && (u = u.concat(this.options.fallbackNS));
      const A = c.count !== void 0 && !N(c.count), G = A && !c.ordinal && c.count === 0 && this.pluralResolver.shouldUseIntlApi(), m = c.context !== void 0 && (N(c.context) || typeof c.context == "number") && c.context !== "", V = c.lngs ? c.lngs : this.languageUtils.toResolveHierarchy(c.lng || this.language, c.fallbackLng);
      u.forEach((R) => {
        this.isValidLookup(e) || (n = R, !Sc[`${V[0]}-${R}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(n) && (Sc[`${V[0]}-${R}`] = !0, this.logger.warn(`key "${l}" for languages "${V.join(", ")}" won't get resolved as namespace "${n}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), V.forEach((y) => {
          if (this.isValidLookup(e))
            return;
          t = y;
          const s = [a];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(s, a, y, R, c);
          else {
            let d;
            A && (d = this.pluralResolver.getSuffix(y, c.count, c));
            const o = `${this.options.pluralSeparator}zero`, X = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (A && (s.push(a + d), c.ordinal && d.indexOf(X) === 0 && s.push(a + d.replace(X, this.options.pluralSeparator)), G && s.push(a + o)), m) {
              const x = `${a}${this.options.contextSeparator}${c.context}`;
              s.push(x), A && (s.push(x + d), c.ordinal && d.indexOf(X) === 0 && s.push(x + d.replace(X, this.options.pluralSeparator)), G && s.push(x + o));
            }
          }
          let r;
          for (; r = s.pop(); )
            this.isValidLookup(e) || (i = r, e = this.getResource(y, R, r, c));
        }));
      });
    }), {
      res: e,
      usedKey: l,
      exactUsedKey: i,
      usedLng: t,
      usedNS: n
    };
  }
  isValidLookup(I) {
    return I !== void 0 && !(!this.options.returnNull && I === null) && !(!this.options.returnEmptyString && I === "");
  }
  getResource(I, c, e) {
    let l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(I, c, e, l) : this.resourceStore.getResource(I, c, e, l);
  }
  getUsedParamsDetails() {
    let I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const c = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], e = I.replace && !N(I.replace);
    let l = e ? I.replace : I;
    if (e && typeof I.count < "u" && (l.count = I.count), this.options.interpolation.defaultVariables && (l = {
      ...this.options.interpolation.defaultVariables,
      ...l
    }), !e) {
      l = {
        ...l
      };
      for (const i of c)
        delete l[i];
    }
    return l;
  }
  static hasDefaultValue(I) {
    const c = "defaultValue";
    for (const e in I)
      if (Object.prototype.hasOwnProperty.call(I, e) && c === e.substring(0, c.length) && I[e] !== void 0)
        return !0;
    return !1;
  }
}
const dI = (g) => g.charAt(0).toUpperCase() + g.slice(1);
class Tc {
  constructor(I) {
    this.options = I, this.supportedLngs = this.options.supportedLngs || !1, this.logger = O.create("languageUtils");
  }
  getScriptPartFromCode(I) {
    if (I = Mg(I), !I || I.indexOf("-") < 0)
      return null;
    const c = I.split("-");
    return c.length === 2 || (c.pop(), c[c.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(c.join("-"));
  }
  getLanguagePartFromCode(I) {
    if (I = Mg(I), !I || I.indexOf("-") < 0)
      return I;
    const c = I.split("-");
    return this.formatLanguageCode(c[0]);
  }
  formatLanguageCode(I) {
    if (N(I) && I.indexOf("-") > -1) {
      if (typeof Intl < "u" && typeof Intl.getCanonicalLocales < "u")
        try {
          let l = Intl.getCanonicalLocales(I)[0];
          if (l && this.options.lowerCaseLng && (l = l.toLowerCase()), l)
            return l;
        } catch {
        }
      const c = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let e = I.split("-");
      return this.options.lowerCaseLng ? e = e.map((l) => l.toLowerCase()) : e.length === 2 ? (e[0] = e[0].toLowerCase(), e[1] = e[1].toUpperCase(), c.indexOf(e[1].toLowerCase()) > -1 && (e[1] = dI(e[1].toLowerCase()))) : e.length === 3 && (e[0] = e[0].toLowerCase(), e[1].length === 2 && (e[1] = e[1].toUpperCase()), e[0] !== "sgn" && e[2].length === 2 && (e[2] = e[2].toUpperCase()), c.indexOf(e[1].toLowerCase()) > -1 && (e[1] = dI(e[1].toLowerCase())), c.indexOf(e[2].toLowerCase()) > -1 && (e[2] = dI(e[2].toLowerCase()))), e.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? I.toLowerCase() : I;
  }
  isSupportedCode(I) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (I = this.getLanguagePartFromCode(I)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(I) > -1;
  }
  getBestMatchFromCodes(I) {
    if (!I)
      return null;
    let c;
    return I.forEach((e) => {
      if (c)
        return;
      const l = this.formatLanguageCode(e);
      (!this.options.supportedLngs || this.isSupportedCode(l)) && (c = l);
    }), !c && this.options.supportedLngs && I.forEach((e) => {
      if (c)
        return;
      const l = this.getLanguagePartFromCode(e);
      if (this.isSupportedCode(l))
        return c = l;
      c = this.options.supportedLngs.find((i) => {
        if (i === l)
          return i;
        if (!(i.indexOf("-") < 0 && l.indexOf("-") < 0) && (i.indexOf("-") > 0 && l.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === l || i.indexOf(l) === 0 && l.length > 1))
          return i;
      });
    }), c || (c = this.getFallbackCodes(this.options.fallbackLng)[0]), c;
  }
  getFallbackCodes(I, c) {
    if (!I)
      return [];
    if (typeof I == "function" && (I = I(c)), N(I) && (I = [I]), Array.isArray(I))
      return I;
    if (!c)
      return I.default || [];
    let e = I[c];
    return e || (e = I[this.getScriptPartFromCode(c)]), e || (e = I[this.formatLanguageCode(c)]), e || (e = I[this.getLanguagePartFromCode(c)]), e || (e = I.default), e || [];
  }
  toResolveHierarchy(I, c) {
    const e = this.getFallbackCodes(c || this.options.fallbackLng || [], I), l = [], i = (t) => {
      t && (this.isSupportedCode(t) ? l.push(t) : this.logger.warn(`rejecting language code not found in supportedLngs: ${t}`));
    };
    return N(I) && (I.indexOf("-") > -1 || I.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && i(this.formatLanguageCode(I)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && i(this.getScriptPartFromCode(I)), this.options.load !== "currentOnly" && i(this.getLanguagePartFromCode(I))) : N(I) && i(this.formatLanguageCode(I)), e.forEach((t) => {
      l.indexOf(t) < 0 && i(this.formatLanguageCode(t));
    }), l;
  }
}
let LC = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], OC = {
  1: (g) => +(g > 1),
  2: (g) => +(g != 1),
  3: (g) => 0,
  4: (g) => g % 10 == 1 && g % 100 != 11 ? 0 : g % 10 >= 2 && g % 10 <= 4 && (g % 100 < 10 || g % 100 >= 20) ? 1 : 2,
  5: (g) => g == 0 ? 0 : g == 1 ? 1 : g == 2 ? 2 : g % 100 >= 3 && g % 100 <= 10 ? 3 : g % 100 >= 11 ? 4 : 5,
  6: (g) => g == 1 ? 0 : g >= 2 && g <= 4 ? 1 : 2,
  7: (g) => g == 1 ? 0 : g % 10 >= 2 && g % 10 <= 4 && (g % 100 < 10 || g % 100 >= 20) ? 1 : 2,
  8: (g) => g == 1 ? 0 : g == 2 ? 1 : g != 8 && g != 11 ? 2 : 3,
  9: (g) => +(g >= 2),
  10: (g) => g == 1 ? 0 : g == 2 ? 1 : g < 7 ? 2 : g < 11 ? 3 : 4,
  11: (g) => g == 1 || g == 11 ? 0 : g == 2 || g == 12 ? 1 : g > 2 && g < 20 ? 2 : 3,
  12: (g) => +(g % 10 != 1 || g % 100 == 11),
  13: (g) => +(g !== 0),
  14: (g) => g == 1 ? 0 : g == 2 ? 1 : g == 3 ? 2 : 3,
  15: (g) => g % 10 == 1 && g % 100 != 11 ? 0 : g % 10 >= 2 && (g % 100 < 10 || g % 100 >= 20) ? 1 : 2,
  16: (g) => g % 10 == 1 && g % 100 != 11 ? 0 : g !== 0 ? 1 : 2,
  17: (g) => g == 1 || g % 10 == 1 && g % 100 != 11 ? 0 : 1,
  18: (g) => g == 0 ? 0 : g == 1 ? 1 : 2,
  19: (g) => g == 1 ? 0 : g == 0 || g % 100 > 1 && g % 100 < 11 ? 1 : g % 100 > 10 && g % 100 < 20 ? 2 : 3,
  20: (g) => g == 1 ? 0 : g == 0 || g % 100 > 0 && g % 100 < 20 ? 1 : 2,
  21: (g) => g % 100 == 1 ? 1 : g % 100 == 2 ? 2 : g % 100 == 3 || g % 100 == 4 ? 3 : 0,
  22: (g) => g == 1 ? 0 : g == 2 ? 1 : (g < 0 || g > 10) && g % 10 == 0 ? 2 : 3
};
const EC = ["v1", "v2", "v3"], jC = ["v4"], Hc = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, DC = () => {
  const g = {};
  return LC.forEach((I) => {
    I.lngs.forEach((c) => {
      g[c] = {
        numbers: I.nr,
        plurals: OC[I.fc]
      };
    });
  }), g;
};
class PC {
  constructor(I) {
    let c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = I, this.options = c, this.logger = O.create("pluralResolver"), (!this.options.compatibilityJSON || jC.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = DC(), this.pluralRulesCache = {};
  }
  addRule(I, c) {
    this.rules[I] = c;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(I) {
    let c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi())
      try {
        const e = Mg(I === "dev" ? "en" : I), l = c.ordinal ? "ordinal" : "cardinal", i = JSON.stringify({
          cleanedCode: e,
          type: l
        });
        if (i in this.pluralRulesCache)
          return this.pluralRulesCache[i];
        const t = new Intl.PluralRules(e, {
          type: l
        });
        return this.pluralRulesCache[i] = t, t;
      } catch {
        return;
      }
    return this.rules[I] || this.rules[this.languageUtils.getLanguagePartFromCode(I)];
  }
  needsPlural(I) {
    let c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const e = this.getRule(I, c);
    return this.shouldUseIntlApi() ? e && e.resolvedOptions().pluralCategories.length > 1 : e && e.numbers.length > 1;
  }
  getPluralFormsOfKey(I, c) {
    let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(I, e).map((l) => `${c}${l}`);
  }
  getSuffixes(I) {
    let c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const e = this.getRule(I, c);
    return e ? this.shouldUseIntlApi() ? e.resolvedOptions().pluralCategories.sort((l, i) => Hc[l] - Hc[i]).map((l) => `${this.options.prepend}${c.ordinal ? `ordinal${this.options.prepend}` : ""}${l}`) : e.numbers.map((l) => this.getSuffix(I, l, c)) : [];
  }
  getSuffix(I, c) {
    let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const l = this.getRule(I, e);
    return l ? this.shouldUseIntlApi() ? `${this.options.prepend}${e.ordinal ? `ordinal${this.options.prepend}` : ""}${l.select(c)}` : this.getSuffixRetroCompatible(l, c) : (this.logger.warn(`no plural rule found for: ${I}`), "");
  }
  getSuffixRetroCompatible(I, c) {
    const e = I.noAbs ? I.plurals(c) : I.plurals(Math.abs(c));
    let l = I.numbers[e];
    this.options.simplifyPluralSuffix && I.numbers.length === 2 && I.numbers[0] === 1 && (l === 2 ? l = "plural" : l === 1 && (l = ""));
    const i = () => this.options.prepend && l.toString() ? this.options.prepend + l.toString() : l.toString();
    return this.options.compatibilityJSON === "v1" ? l === 1 ? "" : typeof l == "number" ? `_plural_${l.toString()}` : i() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && I.numbers.length === 2 && I.numbers[0] === 1 ? i() : this.options.prepend && e.toString() ? this.options.prepend + e.toString() : e.toString();
  }
  shouldUseIntlApi() {
    return !EC.includes(this.options.compatibilityJSON);
  }
}
const wc = function(g, I, c) {
  let e = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", l = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, i = YC(g, I, c);
  return !i && l && N(c) && (i = vI(g, c, e), i === void 0 && (i = vI(I, c, e))), i;
}, rI = (g) => g.replace(/\$/g, "$$$$");
class kC {
  constructor() {
    let I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = O.create("interpolator"), this.options = I, this.format = I.interpolation && I.interpolation.format || ((c) => c), this.init(I);
  }
  init() {
    let I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    I.interpolation || (I.interpolation = {
      escapeValue: !0
    });
    const {
      escape: c,
      escapeValue: e,
      useRawValueToEscape: l,
      prefix: i,
      prefixEscaped: t,
      suffix: n,
      suffixEscaped: C,
      formatSeparator: b,
      unescapeSuffix: a,
      unescapePrefix: u,
      nestingPrefix: A,
      nestingPrefixEscaped: G,
      nestingSuffix: m,
      nestingSuffixEscaped: V,
      nestingOptionsSeparator: R,
      maxReplaces: y,
      alwaysFormat: s
    } = I.interpolation;
    this.escape = c !== void 0 ? c : zC, this.escapeValue = e !== void 0 ? e : !0, this.useRawValueToEscape = l !== void 0 ? l : !1, this.prefix = i ? gg(i) : t || "{{", this.suffix = n ? gg(n) : C || "}}", this.formatSeparator = b || ",", this.unescapePrefix = a ? "" : u || "-", this.unescapeSuffix = this.unescapePrefix ? "" : a || "", this.nestingPrefix = A ? gg(A) : G || gg("$t("), this.nestingSuffix = m ? gg(m) : V || gg(")"), this.nestingOptionsSeparator = R || ",", this.maxReplaces = y || 1e3, this.alwaysFormat = s !== void 0 ? s : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const I = (c, e) => c && c.source === e ? (c.lastIndex = 0, c) : new RegExp(e, "g");
    this.regexp = I(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = I(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = I(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(I, c, e, l) {
    let i, t, n;
    const C = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, b = (G) => {
      if (G.indexOf(this.formatSeparator) < 0) {
        const y = wc(c, C, G, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(y, void 0, e, {
          ...l,
          ...c,
          interpolationkey: G
        }) : y;
      }
      const m = G.split(this.formatSeparator), V = m.shift().trim(), R = m.join(this.formatSeparator).trim();
      return this.format(wc(c, C, V, this.options.keySeparator, this.options.ignoreJSONStructure), R, e, {
        ...l,
        ...c,
        interpolationkey: V
      });
    };
    this.resetRegExp();
    const a = l && l.missingInterpolationHandler || this.options.missingInterpolationHandler, u = l && l.interpolation && l.interpolation.skipOnVariables !== void 0 ? l.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (G) => rI(G)
    }, {
      regex: this.regexp,
      safeValue: (G) => this.escapeValue ? rI(this.escape(G)) : rI(G)
    }].forEach((G) => {
      for (n = 0; i = G.regex.exec(I); ) {
        const m = i[1].trim();
        if (t = b(m), t === void 0)
          if (typeof a == "function") {
            const R = a(I, i, l);
            t = N(R) ? R : "";
          } else if (l && Object.prototype.hasOwnProperty.call(l, m))
            t = "";
          else if (u) {
            t = i[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${m} for interpolating ${I}`), t = "";
        else
          !N(t) && !this.useRawValueToEscape && (t = Bc(t));
        const V = G.safeValue(t);
        if (I = I.replace(i[0], V), u ? (G.regex.lastIndex += t.length, G.regex.lastIndex -= i[0].length) : G.regex.lastIndex = 0, n++, n >= this.maxReplaces)
          break;
      }
    }), I;
  }
  nest(I, c) {
    let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, l, i, t;
    const n = (C, b) => {
      const a = this.nestingOptionsSeparator;
      if (C.indexOf(a) < 0)
        return C;
      const u = C.split(new RegExp(`${a}[ ]*{`));
      let A = `{${u[1]}`;
      C = u[0], A = this.interpolate(A, t);
      const G = A.match(/'/g), m = A.match(/"/g);
      (G && G.length % 2 === 0 && !m || m.length % 2 !== 0) && (A = A.replace(/'/g, '"'));
      try {
        t = JSON.parse(A), b && (t = {
          ...b,
          ...t
        });
      } catch (V) {
        return this.logger.warn(`failed parsing options string in nesting for key ${C}`, V), `${C}${a}${A}`;
      }
      return t.defaultValue && t.defaultValue.indexOf(this.prefix) > -1 && delete t.defaultValue, C;
    };
    for (; l = this.nestingRegexp.exec(I); ) {
      let C = [];
      t = {
        ...e
      }, t = t.replace && !N(t.replace) ? t.replace : t, t.applyPostProcessor = !1, delete t.defaultValue;
      let b = !1;
      if (l[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(l[1])) {
        const a = l[1].split(this.formatSeparator).map((u) => u.trim());
        l[1] = a.shift(), C = a, b = !0;
      }
      if (i = c(n.call(this, l[1].trim(), t), t), i && l[0] === I && !N(i))
        return i;
      N(i) || (i = Bc(i)), i || (this.logger.warn(`missed to resolve ${l[1]} for nesting ${I}`), i = ""), b && (i = C.reduce((a, u) => this.format(a, u, e.lng, {
        ...e,
        interpolationkey: l[1].trim()
      }), i.trim())), I = I.replace(l[0], i), this.regexp.lastIndex = 0;
    }
    return I;
  }
}
const QC = (g) => {
  let I = g.toLowerCase().trim();
  const c = {};
  if (g.indexOf("(") > -1) {
    const e = g.split("(");
    I = e[0].toLowerCase().trim();
    const l = e[1].substring(0, e[1].length - 1);
    I === "currency" && l.indexOf(":") < 0 ? c.currency || (c.currency = l.trim()) : I === "relativetime" && l.indexOf(":") < 0 ? c.range || (c.range = l.trim()) : l.split(";").forEach((t) => {
      if (t) {
        const [n, ...C] = t.split(":"), b = C.join(":").trim().replace(/^'+|'+$/g, ""), a = n.trim();
        c[a] || (c[a] = b), b === "false" && (c[a] = !1), b === "true" && (c[a] = !0), isNaN(b) || (c[a] = parseInt(b, 10));
      }
    });
  }
  return {
    formatName: I,
    formatOptions: c
  };
}, Ig = (g) => {
  const I = {};
  return (c, e, l) => {
    let i = l;
    l && l.interpolationkey && l.formatParams && l.formatParams[l.interpolationkey] && l[l.interpolationkey] && (i = {
      ...i,
      [l.interpolationkey]: void 0
    });
    const t = e + JSON.stringify(i);
    let n = I[t];
    return n || (n = g(Mg(e), l), I[t] = n), n(c);
  };
};
class MC {
  constructor() {
    let I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = O.create("formatter"), this.options = I, this.formats = {
      number: Ig((c, e) => {
        const l = new Intl.NumberFormat(c, {
          ...e
        });
        return (i) => l.format(i);
      }),
      currency: Ig((c, e) => {
        const l = new Intl.NumberFormat(c, {
          ...e,
          style: "currency"
        });
        return (i) => l.format(i);
      }),
      datetime: Ig((c, e) => {
        const l = new Intl.DateTimeFormat(c, {
          ...e
        });
        return (i) => l.format(i);
      }),
      relativetime: Ig((c, e) => {
        const l = new Intl.RelativeTimeFormat(c, {
          ...e
        });
        return (i) => l.format(i, e.range || "day");
      }),
      list: Ig((c, e) => {
        const l = new Intl.ListFormat(c, {
          ...e
        });
        return (i) => l.format(i);
      })
    }, this.init(I);
  }
  init(I) {
    let c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = c.interpolation.formatSeparator || ",";
  }
  add(I, c) {
    this.formats[I.toLowerCase().trim()] = c;
  }
  addCached(I, c) {
    this.formats[I.toLowerCase().trim()] = Ig(c);
  }
  format(I, c, e) {
    let l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = c.split(this.formatSeparator);
    if (i.length > 1 && i[0].indexOf("(") > 1 && i[0].indexOf(")") < 0 && i.find((n) => n.indexOf(")") > -1)) {
      const n = i.findIndex((C) => C.indexOf(")") > -1);
      i[0] = [i[0], ...i.splice(1, n)].join(this.formatSeparator);
    }
    return i.reduce((n, C) => {
      const {
        formatName: b,
        formatOptions: a
      } = QC(C);
      if (this.formats[b]) {
        let u = n;
        try {
          const A = l && l.formatParams && l.formatParams[l.interpolationkey] || {}, G = A.locale || A.lng || l.locale || l.lng || e;
          u = this.formats[b](n, G, {
            ...a,
            ...l,
            ...A
          });
        } catch (A) {
          this.logger.warn(A);
        }
        return u;
      } else
        this.logger.warn(`there was no format function for ${b}`);
      return n;
    }, I);
  }
}
const KC = (g, I) => {
  g.pending[I] !== void 0 && (delete g.pending[I], g.pendingCount--);
};
class _C extends nI {
  constructor(I, c, e) {
    let l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = I, this.store = c, this.services = e, this.languageUtils = e.languageUtils, this.options = l, this.logger = O.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = l.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = l.maxRetries >= 0 ? l.maxRetries : 5, this.retryTimeout = l.retryTimeout >= 1 ? l.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(e, l.backend, l);
  }
  queueLoad(I, c, e, l) {
    const i = {}, t = {}, n = {}, C = {};
    return I.forEach((b) => {
      let a = !0;
      c.forEach((u) => {
        const A = `${b}|${u}`;
        !e.reload && this.store.hasResourceBundle(b, u) ? this.state[A] = 2 : this.state[A] < 0 || (this.state[A] === 1 ? t[A] === void 0 && (t[A] = !0) : (this.state[A] = 1, a = !1, t[A] === void 0 && (t[A] = !0), i[A] === void 0 && (i[A] = !0), C[u] === void 0 && (C[u] = !0)));
      }), a || (n[b] = !0);
    }), (Object.keys(i).length || Object.keys(t).length) && this.queue.push({
      pending: t,
      pendingCount: Object.keys(t).length,
      loaded: {},
      errors: [],
      callback: l
    }), {
      toLoad: Object.keys(i),
      pending: Object.keys(t),
      toLoadLanguages: Object.keys(n),
      toLoadNamespaces: Object.keys(C)
    };
  }
  loaded(I, c, e) {
    const l = I.split("|"), i = l[0], t = l[1];
    c && this.emit("failedLoading", i, t, c), !c && e && this.store.addResourceBundle(i, t, e, void 0, void 0, {
      skipCopy: !0
    }), this.state[I] = c ? -1 : 2, c && e && (this.state[I] = 0);
    const n = {};
    this.queue.forEach((C) => {
      FC(C.loaded, [i], t), KC(C, I), c && C.errors.push(c), C.pendingCount === 0 && !C.done && (Object.keys(C.loaded).forEach((b) => {
        n[b] || (n[b] = {});
        const a = C.loaded[b];
        a.length && a.forEach((u) => {
          n[b][u] === void 0 && (n[b][u] = !0);
        });
      }), C.done = !0, C.errors.length ? C.callback(C.errors) : C.callback());
    }), this.emit("loaded", n), this.queue = this.queue.filter((C) => !C.done);
  }
  read(I, c, e) {
    let l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, t = arguments.length > 5 ? arguments[5] : void 0;
    if (!I.length)
      return t(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: I,
        ns: c,
        fcName: e,
        tried: l,
        wait: i,
        callback: t
      });
      return;
    }
    this.readingCalls++;
    const n = (b, a) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const u = this.waitingReads.shift();
        this.read(u.lng, u.ns, u.fcName, u.tried, u.wait, u.callback);
      }
      if (b && a && l < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, I, c, e, l + 1, i * 2, t);
        }, i);
        return;
      }
      t(b, a);
    }, C = this.backend[e].bind(this.backend);
    if (C.length === 2) {
      try {
        const b = C(I, c);
        b && typeof b.then == "function" ? b.then((a) => n(null, a)).catch(n) : n(null, b);
      } catch (b) {
        n(b);
      }
      return;
    }
    return C(I, c, n);
  }
  prepareLoading(I, c) {
    let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, l = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), l && l();
    N(I) && (I = this.languageUtils.toResolveHierarchy(I)), N(c) && (c = [c]);
    const i = this.queueLoad(I, c, e, l);
    if (!i.toLoad.length)
      return i.pending.length || l(), null;
    i.toLoad.forEach((t) => {
      this.loadOne(t);
    });
  }
  load(I, c, e) {
    this.prepareLoading(I, c, {}, e);
  }
  reload(I, c, e) {
    this.prepareLoading(I, c, {
      reload: !0
    }, e);
  }
  loadOne(I) {
    let c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const e = I.split("|"), l = e[0], i = e[1];
    this.read(l, i, "read", void 0, void 0, (t, n) => {
      t && this.logger.warn(`${c}loading namespace ${i} for language ${l} failed`, t), !t && n && this.logger.log(`${c}loaded namespace ${i} for language ${l}`, n), this.loaded(I, t, n);
    });
  }
  saveMissing(I, c, e, l, i) {
    let t = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, n = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(c)) {
      this.logger.warn(`did not save key "${e}" as the namespace "${c}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(e == null || e === "")) {
      if (this.backend && this.backend.create) {
        const C = {
          ...t,
          isUpdate: i
        }, b = this.backend.create.bind(this.backend);
        if (b.length < 6)
          try {
            let a;
            b.length === 5 ? a = b(I, c, e, l, C) : a = b(I, c, e, l), a && typeof a.then == "function" ? a.then((u) => n(null, u)).catch(n) : n(null, a);
          } catch (a) {
            n(a);
          }
        else
          b(I, c, e, l, n, C);
      }
      !I || !I[0] || this.store.addResource(I[0], c, e, l);
    }
  }
}
const Uc = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (g) => {
    let I = {};
    if (typeof g[1] == "object" && (I = g[1]), N(g[1]) && (I.defaultValue = g[1]), N(g[2]) && (I.tDescription = g[2]), typeof g[2] == "object" || typeof g[3] == "object") {
      const c = g[3] || g[2];
      Object.keys(c).forEach((e) => {
        I[e] = c[e];
      });
    }
    return I;
  },
  interpolation: {
    escapeValue: !0,
    format: (g) => g,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), Lc = (g) => (N(g.ns) && (g.ns = [g.ns]), N(g.fallbackLng) && (g.fallbackLng = [g.fallbackLng]), N(g.fallbackNS) && (g.fallbackNS = [g.fallbackNS]), g.supportedLngs && g.supportedLngs.indexOf("cimode") < 0 && (g.supportedLngs = g.supportedLngs.concat(["cimode"])), g), Sg = () => {
}, qC = (g) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(g)).forEach((c) => {
    typeof g[c] == "function" && (g[c] = g[c].bind(g));
  });
};
class pg extends nI {
  constructor() {
    let I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, c = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = Lc(I), this.services = {}, this.logger = O, this.modules = {
      external: []
    }, qC(this), c && !this.isInitialized && !I.isClone) {
      if (!this.options.initImmediate)
        return this.init(I, c), this;
      setTimeout(() => {
        this.init(I, c);
      }, 0);
    }
  }
  init() {
    var I = this;
    let c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof c == "function" && (e = c, c = {}), !c.defaultNS && c.defaultNS !== !1 && c.ns && (N(c.ns) ? c.defaultNS = c.ns : c.ns.indexOf("translation") < 0 && (c.defaultNS = c.ns[0]));
    const l = Uc();
    this.options = {
      ...l,
      ...this.options,
      ...Lc(c)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...l.interpolation,
      ...this.options.interpolation
    }), c.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = c.keySeparator), c.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = c.nsSeparator);
    const i = (a) => a ? typeof a == "function" ? new a() : a : null;
    if (!this.options.isClone) {
      this.modules.logger ? O.init(i(this.modules.logger), this.options) : O.init(null, this.options);
      let a;
      this.modules.formatter ? a = this.modules.formatter : typeof Intl < "u" && (a = MC);
      const u = new Tc(this.options);
      this.store = new zc(this.options.resources, this.options);
      const A = this.services;
      A.logger = O, A.resourceStore = this.store, A.languageUtils = u, A.pluralResolver = new PC(u, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), a && (!this.options.interpolation.format || this.options.interpolation.format === l.interpolation.format) && (A.formatter = i(a), A.formatter.init(A, this.options), this.options.interpolation.format = A.formatter.format.bind(A.formatter)), A.interpolator = new kC(this.options), A.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, A.backendConnector = new _C(i(this.modules.backend), A.resourceStore, A, this.options), A.backendConnector.on("*", function(G) {
        for (var m = arguments.length, V = new Array(m > 1 ? m - 1 : 0), R = 1; R < m; R++)
          V[R - 1] = arguments[R];
        I.emit(G, ...V);
      }), this.modules.languageDetector && (A.languageDetector = i(this.modules.languageDetector), A.languageDetector.init && A.languageDetector.init(A, this.options.detection, this.options)), this.modules.i18nFormat && (A.i18nFormat = i(this.modules.i18nFormat), A.i18nFormat.init && A.i18nFormat.init(this)), this.translator = new _g(this.services, this.options), this.translator.on("*", function(G) {
        for (var m = arguments.length, V = new Array(m > 1 ? m - 1 : 0), R = 1; R < m; R++)
          V[R - 1] = arguments[R];
        I.emit(G, ...V);
      }), this.modules.external.forEach((G) => {
        G.init && G.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, e || (e = Sg), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const a = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      a.length > 0 && a[0] !== "dev" && (this.options.lng = a[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((a) => {
      this[a] = function() {
        return I.store[a](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((a) => {
      this[a] = function() {
        return I.store[a](...arguments), I;
      };
    });
    const C = rg(), b = () => {
      const a = (u, A) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), C.resolve(A), e(u, A);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized)
        return a(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, a);
    };
    return this.options.resources || !this.options.initImmediate ? b() : setTimeout(b, 0), C;
  }
  loadResources(I) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Sg;
    const l = N(I) ? I : this.language;
    if (typeof I == "function" && (e = I), !this.options.resources || this.options.partialBundledLanguages) {
      if (l && l.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0))
        return e();
      const i = [], t = (n) => {
        if (!n || n === "cimode")
          return;
        this.services.languageUtils.toResolveHierarchy(n).forEach((b) => {
          b !== "cimode" && i.indexOf(b) < 0 && i.push(b);
        });
      };
      l ? t(l) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((C) => t(C)), this.options.preload && this.options.preload.forEach((n) => t(n)), this.services.backendConnector.load(i, this.options.ns, (n) => {
        !n && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), e(n);
      });
    } else
      e(null);
  }
  reloadResources(I, c, e) {
    const l = rg();
    return typeof I == "function" && (e = I, I = void 0), typeof c == "function" && (e = c, c = void 0), I || (I = this.languages), c || (c = this.options.ns), e || (e = Sg), this.services.backendConnector.reload(I, c, (i) => {
      l.resolve(), e(i);
    }), l;
  }
  use(I) {
    if (!I)
      throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!I.type)
      throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return I.type === "backend" && (this.modules.backend = I), (I.type === "logger" || I.log && I.warn && I.error) && (this.modules.logger = I), I.type === "languageDetector" && (this.modules.languageDetector = I), I.type === "i18nFormat" && (this.modules.i18nFormat = I), I.type === "postProcessor" && Ee.addPostProcessor(I), I.type === "formatter" && (this.modules.formatter = I), I.type === "3rdParty" && this.modules.external.push(I), this;
  }
  setResolvedLanguage(I) {
    if (!(!I || !this.languages) && !(["cimode", "dev"].indexOf(I) > -1))
      for (let c = 0; c < this.languages.length; c++) {
        const e = this.languages[c];
        if (!(["cimode", "dev"].indexOf(e) > -1) && this.store.hasLanguageSomeTranslations(e)) {
          this.resolvedLanguage = e;
          break;
        }
      }
  }
  changeLanguage(I, c) {
    var e = this;
    this.isLanguageChangingTo = I;
    const l = rg();
    this.emit("languageChanging", I);
    const i = (C) => {
      this.language = C, this.languages = this.services.languageUtils.toResolveHierarchy(C), this.resolvedLanguage = void 0, this.setResolvedLanguage(C);
    }, t = (C, b) => {
      b ? (i(b), this.translator.changeLanguage(b), this.isLanguageChangingTo = void 0, this.emit("languageChanged", b), this.logger.log("languageChanged", b)) : this.isLanguageChangingTo = void 0, l.resolve(function() {
        return e.t(...arguments);
      }), c && c(C, function() {
        return e.t(...arguments);
      });
    }, n = (C) => {
      !I && !C && this.services.languageDetector && (C = []);
      const b = N(C) ? C : this.services.languageUtils.getBestMatchFromCodes(C);
      b && (this.language || i(b), this.translator.language || this.translator.changeLanguage(b), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(b)), this.loadResources(b, (a) => {
        t(a, b);
      });
    };
    return !I && this.services.languageDetector && !this.services.languageDetector.async ? n(this.services.languageDetector.detect()) : !I && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(n) : this.services.languageDetector.detect(n) : n(I), l;
  }
  getFixedT(I, c, e) {
    var l = this;
    const i = function(t, n) {
      let C;
      if (typeof n != "object") {
        for (var b = arguments.length, a = new Array(b > 2 ? b - 2 : 0), u = 2; u < b; u++)
          a[u - 2] = arguments[u];
        C = l.options.overloadTranslationOptionHandler([t, n].concat(a));
      } else
        C = {
          ...n
        };
      C.lng = C.lng || i.lng, C.lngs = C.lngs || i.lngs, C.ns = C.ns || i.ns, C.keyPrefix !== "" && (C.keyPrefix = C.keyPrefix || e || i.keyPrefix);
      const A = l.options.keySeparator || ".";
      let G;
      return C.keyPrefix && Array.isArray(t) ? G = t.map((m) => `${C.keyPrefix}${A}${m}`) : G = C.keyPrefix ? `${C.keyPrefix}${A}${t}` : t, l.t(G, C);
    };
    return N(I) ? i.lng = I : i.lngs = I, i.ns = c, i.keyPrefix = e, i;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(I) {
    this.options.defaultNS = I;
  }
  hasLoadedNamespace(I) {
    let c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const e = c.lng || this.resolvedLanguage || this.languages[0], l = this.options ? this.options.fallbackLng : !1, i = this.languages[this.languages.length - 1];
    if (e.toLowerCase() === "cimode")
      return !0;
    const t = (n, C) => {
      const b = this.services.backendConnector.state[`${n}|${C}`];
      return b === -1 || b === 0 || b === 2;
    };
    if (c.precheck) {
      const n = c.precheck(this, t);
      if (n !== void 0)
        return n;
    }
    return !!(this.hasResourceBundle(e, I) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || t(e, I) && (!l || t(i, I)));
  }
  loadNamespaces(I, c) {
    const e = rg();
    return this.options.ns ? (N(I) && (I = [I]), I.forEach((l) => {
      this.options.ns.indexOf(l) < 0 && this.options.ns.push(l);
    }), this.loadResources((l) => {
      e.resolve(), c && c(l);
    }), e) : (c && c(), Promise.resolve());
  }
  loadLanguages(I, c) {
    const e = rg();
    N(I) && (I = [I]);
    const l = this.options.preload || [], i = I.filter((t) => l.indexOf(t) < 0 && this.services.languageUtils.isSupportedCode(t));
    return i.length ? (this.options.preload = l.concat(i), this.loadResources((t) => {
      e.resolve(), c && c(t);
    }), e) : (c && c(), Promise.resolve());
  }
  dir(I) {
    if (I || (I = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !I)
      return "rtl";
    const c = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], e = this.services && this.services.languageUtils || new Tc(Uc());
    return c.indexOf(e.getLanguagePartFromCode(I)) > -1 || I.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, c = arguments.length > 1 ? arguments[1] : void 0;
    return new pg(I, c);
  }
  cloneInstance() {
    let I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Sg;
    const e = I.forkResourceStore;
    e && delete I.forkResourceStore;
    const l = {
      ...this.options,
      ...I,
      isClone: !0
    }, i = new pg(l);
    return (I.debug !== void 0 || I.prefix !== void 0) && (i.logger = i.logger.clone(I)), ["store", "services", "language"].forEach((n) => {
      i[n] = this[n];
    }), i.services = {
      ...this.services
    }, i.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, e && (i.store = new zc(this.store.data, l), i.services.resourceStore = i.store), i.translator = new _g(i.services, l), i.translator.on("*", function(n) {
      for (var C = arguments.length, b = new Array(C > 1 ? C - 1 : 0), a = 1; a < C; a++)
        b[a - 1] = arguments[a];
      i.emit(n, ...b);
    }), i.init(l, c), i.translator.options = l, i.translator.backendConnector.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, i;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const F = pg.createInstance();
F.createInstance = pg.createInstance;
F.createInstance;
F.dir;
F.init;
F.loadResources;
F.reloadResources;
F.use;
F.changeLanguage;
F.getFixedT;
F.t;
F.exists;
F.setDefaultNamespace;
F.hasLoadedNamespace;
F.loadNamespaces;
F.loadLanguages;
const {
  slice: $C,
  forEach: ga
} = [];
function Ia(g) {
  return ga.call($C.call(arguments, 1), (I) => {
    if (I)
      for (const c in I)
        g[c] === void 0 && (g[c] = I[c]);
  }), g;
}
const Oc = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/, ca = (g, I, c) => {
  const e = c || {};
  e.path = e.path || "/";
  const l = encodeURIComponent(I);
  let i = `${g}=${l}`;
  if (e.maxAge > 0) {
    const t = e.maxAge - 0;
    if (Number.isNaN(t))
      throw new Error("maxAge should be a Number");
    i += `; Max-Age=${Math.floor(t)}`;
  }
  if (e.domain) {
    if (!Oc.test(e.domain))
      throw new TypeError("option domain is invalid");
    i += `; Domain=${e.domain}`;
  }
  if (e.path) {
    if (!Oc.test(e.path))
      throw new TypeError("option path is invalid");
    i += `; Path=${e.path}`;
  }
  if (e.expires) {
    if (typeof e.expires.toUTCString != "function")
      throw new TypeError("option expires is invalid");
    i += `; Expires=${e.expires.toUTCString()}`;
  }
  if (e.httpOnly && (i += "; HttpOnly"), e.secure && (i += "; Secure"), e.sameSite)
    switch (typeof e.sameSite == "string" ? e.sameSite.toLowerCase() : e.sameSite) {
      case !0:
        i += "; SameSite=Strict";
        break;
      case "lax":
        i += "; SameSite=Lax";
        break;
      case "strict":
        i += "; SameSite=Strict";
        break;
      case "none":
        i += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  return i;
}, Ec = {
  create(g, I, c, e) {
    let l = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      path: "/",
      sameSite: "strict"
    };
    c && (l.expires = /* @__PURE__ */ new Date(), l.expires.setTime(l.expires.getTime() + c * 60 * 1e3)), e && (l.domain = e), document.cookie = ca(g, encodeURIComponent(I), l);
  },
  read(g) {
    const I = `${g}=`, c = document.cookie.split(";");
    for (let e = 0; e < c.length; e++) {
      let l = c[e];
      for (; l.charAt(0) === " "; )
        l = l.substring(1, l.length);
      if (l.indexOf(I) === 0)
        return l.substring(I.length, l.length);
    }
    return null;
  },
  remove(g) {
    this.create(g, "", -1);
  }
};
var ea = {
  name: "cookie",
  // Deconstruct the options object and extract the lookupCookie property
  lookup(g) {
    let {
      lookupCookie: I
    } = g;
    if (I && typeof document < "u")
      return Ec.read(I) || void 0;
  },
  // Deconstruct the options object and extract the lookupCookie, cookieMinutes, cookieDomain, and cookieOptions properties
  cacheUserLanguage(g, I) {
    let {
      lookupCookie: c,
      cookieMinutes: e,
      cookieDomain: l,
      cookieOptions: i
    } = I;
    c && typeof document < "u" && Ec.create(c, g, e, l, i);
  }
}, la = {
  name: "querystring",
  // Deconstruct the options object and extract the lookupQuerystring property
  lookup(g) {
    var e;
    let {
      lookupQuerystring: I
    } = g, c;
    if (typeof window < "u") {
      let {
        search: l
      } = window.location;
      !window.location.search && ((e = window.location.hash) == null ? void 0 : e.indexOf("?")) > -1 && (l = window.location.hash.substring(window.location.hash.indexOf("?")));
      const t = l.substring(1).split("&");
      for (let n = 0; n < t.length; n++) {
        const C = t[n].indexOf("=");
        C > 0 && t[n].substring(0, C) === I && (c = t[n].substring(C + 1));
      }
    }
    return c;
  }
};
let og = null;
const jc = () => {
  if (og !== null)
    return og;
  try {
    og = window !== "undefined" && window.localStorage !== null;
    const g = "i18next.translate.boo";
    window.localStorage.setItem(g, "foo"), window.localStorage.removeItem(g);
  } catch {
    og = !1;
  }
  return og;
};
var ia = {
  name: "localStorage",
  // Deconstruct the options object and extract the lookupLocalStorage property
  lookup(g) {
    let {
      lookupLocalStorage: I
    } = g;
    if (I && jc())
      return window.localStorage.getItem(I) || void 0;
  },
  // Deconstruct the options object and extract the lookupLocalStorage property
  cacheUserLanguage(g, I) {
    let {
      lookupLocalStorage: c
    } = I;
    c && jc() && window.localStorage.setItem(c, g);
  }
};
let Gg = null;
const Dc = () => {
  if (Gg !== null)
    return Gg;
  try {
    Gg = window !== "undefined" && window.sessionStorage !== null;
    const g = "i18next.translate.boo";
    window.sessionStorage.setItem(g, "foo"), window.sessionStorage.removeItem(g);
  } catch {
    Gg = !1;
  }
  return Gg;
};
var ta = {
  name: "sessionStorage",
  lookup(g) {
    let {
      lookupSessionStorage: I
    } = g;
    if (I && Dc())
      return window.sessionStorage.getItem(I) || void 0;
  },
  cacheUserLanguage(g, I) {
    let {
      lookupSessionStorage: c
    } = I;
    c && Dc() && window.sessionStorage.setItem(c, g);
  }
}, na = {
  name: "navigator",
  lookup(g) {
    const I = [];
    if (typeof navigator < "u") {
      const {
        languages: c,
        userLanguage: e,
        language: l
      } = navigator;
      if (c)
        for (let i = 0; i < c.length; i++)
          I.push(c[i]);
      e && I.push(e), l && I.push(l);
    }
    return I.length > 0 ? I : void 0;
  }
}, ba = {
  name: "htmlTag",
  // Deconstruct the options object and extract the htmlTag property
  lookup(g) {
    let {
      htmlTag: I
    } = g, c;
    const e = I || (typeof document < "u" ? document.documentElement : null);
    return e && typeof e.getAttribute == "function" && (c = e.getAttribute("lang")), c;
  }
}, Ca = {
  name: "path",
  // Deconstruct the options object and extract the lookupFromPathIndex property
  lookup(g) {
    var l;
    let {
      lookupFromPathIndex: I
    } = g;
    if (typeof window > "u")
      return;
    const c = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
    return Array.isArray(c) ? (l = c[typeof I == "number" ? I : 0]) == null ? void 0 : l.replace("/", "") : void 0;
  }
}, aa = {
  name: "subdomain",
  lookup(g) {
    var l, i;
    let {
      lookupFromSubdomainIndex: I
    } = g;
    const c = typeof I == "number" ? I + 1 : 1, e = typeof window < "u" && ((i = (l = window.location) == null ? void 0 : l.hostname) == null ? void 0 : i.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i));
    if (e)
      return e[c];
  }
};
function sa() {
  return {
    order: ["querystring", "cookie", "localStorage", "sessionStorage", "navigator", "htmlTag"],
    lookupQuerystring: "lng",
    lookupCookie: "i18next",
    lookupLocalStorage: "i18nextLng",
    lookupSessionStorage: "i18nextLng",
    // cache user language
    caches: ["localStorage"],
    excludeCacheFor: ["cimode"],
    // cookieMinutes: 10,
    // cookieDomain: 'myDomain'
    convertDetectedLanguage: (g) => g
  };
}
class je {
  constructor(I) {
    let c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.type = "languageDetector", this.detectors = {}, this.init(I, c);
  }
  init(I) {
    let c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    this.services = I || {
      languageUtils: {}
    }, this.options = Ia(c, this.options || {}, sa()), typeof this.options.convertDetectedLanguage == "string" && this.options.convertDetectedLanguage.indexOf("15897") > -1 && (this.options.convertDetectedLanguage = (l) => l.replace("-", "_")), this.options.lookupFromUrlIndex && (this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex), this.i18nOptions = e, this.addDetector(ea), this.addDetector(la), this.addDetector(ia), this.addDetector(ta), this.addDetector(na), this.addDetector(ba), this.addDetector(Ca), this.addDetector(aa);
  }
  addDetector(I) {
    return this.detectors[I.name] = I, this;
  }
  detect(I) {
    I || (I = this.options.order);
    let c = [];
    return I.forEach((e) => {
      if (this.detectors[e]) {
        let l = this.detectors[e].lookup(this.options);
        l && typeof l == "string" && (l = [l]), l && (c = c.concat(l));
      }
    }), c = c.map((e) => this.options.convertDetectedLanguage(e)), this.services.languageUtils.getBestMatchFromCodes ? c : c.length > 0 ? c[0] : null;
  }
  cacheUserLanguage(I, c) {
    c || (c = this.options.caches), c && (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(I) > -1 || c.forEach((e) => {
      this.detectors[e] && this.detectors[e].cacheUserLanguage(I, this.options);
    }));
  }
}
je.type = "languageDetector";
const Aa = {
  "(주)인프랩": "Inflab Co., Ltd.",
  "(주)인프랩 사업자 정보": "Inflab Co., Ltd. Business Information",
  "3동 5층": "Republic of Korea",
  "IT 인재 채용 서비스": "IT talents recruiting service",
  "MY 카테고리": "My category",
  "With us": "With us",
  "{{category.title}} > 전체": "{{category.title}} > All",
  "{{name}}님 인프런과 함께 해주셔서 감사해요. 😊": "{{name}}, thank you for being with Inflearn. 😊",
  "{{name}}님의 첫 도약을 응원하고 있어요. 🙌": "{{name}}, we’re cheering for your first step forward. 🙌",
  "{{name}}님의 커리어를 응원하고 있어요. 👏": "{{name}}, we’re cheering for your career growth. 👏",
  "{{profile?.name}}님의 프로필 이미지": "{{profile?.name}}’s profile image",
  "{{provider}}-로그인-버튼": "{{provider}}-Login-Button",
  "{{socialProviderNameMap[provider]}}로 로그인": "Log in with {{socialProviderNameMap[provider]}}",
  "“인프런 비즈니스” 를 통해 모든 팀원이 인프런의 강의를": "With 'Inflearn Business,' you can provide an environment where all team members can",
  "가입 이메일 인증이 필요합니다.": "Email verification is required for registration.",
  "이메일 인증이 필요한 계정입니다.\n24시간 후 재시도하거나 고객센터에 문의해주세요.": `This account requires email verification.
Please try again after 24 hours or contact customer support.`,
  "간편 로그인": "Social login",
  강의: "Course",
  "강의 · 기능요청": "Ask for course/function",
  "강의/강사명을 입력해주세요": "Enter the course/instructor name",
  "강의리스트 보기": "View course list",
  개: "ea",
  "개인정보보호책임자: 이동욱": "CPO: Lee Dongwook",
  개인정보처리방침: "Privacy Policy",
  검색: "Search",
  "검색바.01": "What are you interested in now?",
  "검색바.02": "Enter a keyword you’re exploring.",
  "검색바.03": "Which skill are you exploring now?",
  "검색바.04": "Discover courses for your next step.",
  "검색바.05": "Looking for something specific?",
  "검색바.06": "Type a course, topic, or keyword.",
  "검색바.07": "What do you want to learn today?",
  "검색바.08": "Search for anything.",
  "검색바.09": "What are you interested in now?",
  "검색바.10": "What do you want to learn today?",
  "검색바.11": "Which skill are you exploring now?",
  "검색할 강의 입력": "Enter course name",
  "경기도 성남시 분당구 판교로289번길 20": "5F, Bldg #3, 20, Pangyo-ro 289beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do,",
  "경제적 보상을 받아보세요.": "and get financial rewards.",
  "계정 설정": "Account Settings",
  고객센터: "Customer Services",
  고민있어요: "I need help",
  공지사항: "Notice",
  교육: "Training",
  구글: "Google",
  "구매 / 혜택": "Purchase / Benefits",
  "구매 내역": "Purchase history",
  국비지원교육: "Government-sponsored courses",
  기업: "Business",
  "기업 교육을 위한 인프런": "Inflearn for business education",
  깃허브: "GitHub",
  "나를 성장 시켜줄 좋은 지식들을 찾아보세요.": "Search for great pieces of knowledge that’ll help you grow.",
  "나의 진짜 성장을 도와줄 실무 강의를 찾아보세요": "Find practical courses that can actually help you grow.",
  난이도: "Level",
  "난이도 선택": "Select Level",
  "난이도 옵션": "Level Options",
  "난이도 초기화": "Reset Level",
  "나한테 딱 맞는 걸 찾고 싶다면": "Looking for the perfect match?",
  "어떤 강의가 나한테 맞을까?": "Which course is right for me?",
  "목표와 관심사에 맞는 인기 강의를 찾아드릴게요": "Find courses for your goals",
  "지금 많이 듣는 강의 확인해보세요": "Check out the most popular courses right now",
  "남았어요.": "left.",
  "내 학습": "My learning",
  "네이버에서 구글 로그인을 지원하지 않습니다.": "Naver does not support Google Login.",
  "누구나 들을 수 있는": "Open to everyone",
  "다른 모바일 브라우져(Chrome, Safari)를 이용해 주세요.": "Please use a different mobile browser (Chrome, Safari).",
  닫기: "Close",
  "담긴 강의가 없습니다.": "No courses in cart.",
  대시보드: "Dashboard",
  "대표자: 이형주": "CEO: Lee Hyeongjoo",
  더보기: "More",
  둘러보기: "Explore",
  "딱 맞는 강의가 기다리고 있어요.": "The perfect course for you awaits.",
  "랠릿 서비스 링크": "Rallit service link",
  로그아웃: "Log out",
  로그인: "Sign in",
  "로그인 또는 회원가입": "Log In or Sign Up",
  "로그인이 필요한 요청입니다.": "You need to log in to make this request.",
  로드맵: "Roadmap",
  "마음에 드는 강의를 수강해보세요!": "Take the course that draws your attention!",
  "많은 사람들에게 배움의 기회를 주고,": "Provide an opportunity to learn",
  "메인 페이지로 이동하기": "Go to main page",
  멘토링: "Mentoring",
  "멘토링 소개": "About mentoring",
  "멘토링 후기": "Mentoring Reviews",
  "모임/부트캠프": "Clubs/Bootcamp",
  "문제가 발생했습니다.": "An issue has occurred.",
  보관함: "Storage",
  분: "min",
  블로그: "Blog",
  비밀번호: "Password",
  "비밀번호 찾기": "Find my password",
  "비밀번호를 입력해주세요.": "Enter your password.",
  비즈니스: "Business",
  "비즈니스 브랜드 로고": "Business brand logo",
  "비즈니스 수강내역": "Business course history",
  "사업자 정보 확인": "Check business information",
  "사업자번호: 499-81-00612": "Business Registration No.: 499-81-00612",
  "사용자 대시보드 페이지로 이동": "Go to user dashboard page",
  "사용자 알림 페이지로 이동": "Go to user notification page",
  서비스: "Service",
  "서비스 언어를 선택하세요.": "Select the service language.",
  "선수 지식이 필요한": "Prerequisite knowledge required",
  설정: "Settings",
  수강바구니: "Cart",
  "수강바구니에서 전체보기": "Go to cart",
  "수강코드 등록": "Register course code",
  수강평: "Review",
  "수강평 모아보기": "See all reviews",
  "수료증 확인": "See certificate",
  스터디: "Study Clubs",
  시간: "hr",
  신청하기: "Apply",
  "아이디(이메일) 찾기": "Find my ID (email)",
  애플: "Apple",
  어드민: "Admin",
  "언어 변경": "Change Language",
  "언어 설정": "Language Settings",
  원: "$",
  "유저 대시보드로 이동": "Go to user dashboard",
  "이 공지를 그만 볼래요": "Don't show me this notice",
  이메일: "Email",
  "이메일 또는 비밀번호를 확인해주세요.": "Check your email or password again.",
  "이메일 형식이 올바르지 않습니다.": "Invalid email format",
  "이메일을 입력해주세요.": "Enter your email.",
  "이어서 학습하기": "Continue learning",
  이용약관: "Terms of Use",
  인프랩: "Inflab",
  "인프랩 스토리": "Inflab story",
  "인프랩 실Log": "Inflab Log",
  "인프랩 테크": "Inflab tech",
  인프런: "Inflearn",
  "인프런 네이버 블로그 바로가기": "Go to Inflearn’s Naver blog",
  "인프런 네이버 포스트 바로가기": "Go to Inflearn’s Naver post",
  "인프런 메인 페이지로 이동": "Go to Inflearn main page",
  "인프런 브랜드 로고": "Inflearn brand logo",
  "인프런 비즈니스": "Inflearn business",
  "인프런 소개": "About Inflearn",
  "인프런 영문 브랜드 로고": "Inflearn English brand logo",
  "인프런 유튜브 바로가기": "Go to Inflearn’s YouTube channel",
  "인프런 인스타그램 바로가기": "Go to Inflearn’s Instagram",
  "인프런 제휴": "Inflearn partners",
  "인프런 통합 검색": "Search in Inflearn",
  "인프런 트위터 바로가기": "Go to Inflearn’s X (Twitter)",
  "인프런 페이스북 바로가기": "Go to Inflearn’s Facebook",
  "인프런 피드": "Inflearn feed",
  "인프런으로 이동하기": "Go to Inflearn",
  입문: "Beginner",
  잎: "leaf",
  "자유롭게 학습하는 환경을 제공하세요.": "learn all they want through Inflearn’s courses.",
  "자주묻는 질문": "FAQ",
  "작성한 게시글": "Written posts",
  "장바구니 페이지로 이동": "Go to cart page",
  "저작권 신고센터": "Report copyright issues",
  "전문성을 높이는": "Enhancing expertise",
  전체: "All",
  "전체 강의": "All courses",
  "전화번호: 070-4948-1181": "Phone: 070-4948-1181",
  좋아요: "Likes",
  주소: "Address",
  중급이상: "Intermediate",
  "지금 둘러 보기": "Check out now",
  지식공유: "Instructor",
  "지식공유 참여": "Teach on Inflearn",
  지식공유자: "Instructors",
  "지식공유자 되기": "Teach on Inflearn",
  지식공유참여: "Teach on Inflearn",
  지식공유하기: "Share Knowledge",
  "질문 & 답변": "QnA",
  "질문 게시판": "Questions",
  "채널톡 아이콘": "ChannelTalk icon",
  챌린지: "Challenge",
  "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.": "Something went wrong. Please try again later.",
  "청강대 게임스쿨": "Chungkang College Game School",
  초: "sec",
  초급: "Basic",
  "총 결제금액": "Total amount",
  "최근 강의 바로가기": "Go to recent course",
  "최근 로그인": "Recent login",
  카카오: "Kakao",
  "카카오톡에서 구글 로그인을 지원하지 않습니다.": "KakaoTalk does not support Google Login.",
  "카테고리 설정": "Set category",
  커리어: "Career",
  커뮤니티: "Community",
  "코드 등록": "Register Code",
  쿠폰: "Coupon",
  "통신판매업: 2018-성남분당B-0062": "E-Commerce Business: 2018-SeongnamBundangB-0062",
  "특정 상거래법": "",
  "팀 프로젝트": "Team Projects",
  파트너스: "Partners",
  포인트: "Points",
  "포인트코드 등록": "Register point code",
  학생: "Student",
  "할인 종료까지": "Discount ends in",
  홈: "Home",
  확인: "OK",
  회원가입: "Sign up",
  "🎁 깜짝 감사 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 Surprise! Enjoy a special {{discountPercent}}% thank-you discount on our courses – don’t miss out!",
  "🎁 신규 가입 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 A special discount for new members has been applied to courses, so don’t wait and grab it now!",
  "🎁 첫 구매 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 Your first-purchase discount ({{discountPercent}}%) is already applied — start learning now!"
}, ua = {
  "(주)인프랩": "株式会社インフラップ",
  "(주)인프랩 사업자 정보": "株式会社インフラップ事業者情報",
  "3동 5층": "3棟5階",
  "IT 인재 채용 서비스": "IT人材採用サービス",
  "MY 카테고리": "私のカテゴリ",
  "With us": "ウィズアス",
  "{{category.title}} > 전체": "{{category.title}} > 全体",
  "{{name}}님 인프런과 함께 해주셔서 감사해요. 😊": "{{name}}さん、インフランと一緒にいてくれてありがとう。😊",
  "{{name}}님의 첫 도약을 응원하고 있어요. 🙌": "{{name}}さんの初飛躍を応援しています。🙌",
  "{{name}}님의 커리어를 응원하고 있어요. 👏": "{{name}}さんのキャリアを応援しています。👏",
  "{{profile?.name}}님의 프로필 이미지": "{{profile?.name}}さんのプロフィール画像",
  "{{provider}}-로그인-버튼": "{{provider}}-ログイン-ボタン",
  "{{socialProviderNameMap[provider]}}로 로그인": "{{socialProviderNameMap[provider]}}でログイン",
  "“인프런 비즈니스” 를 통해 모든 팀원이 인프런의 강의를": "「インフラントビジネス」を通じてすべてのチームメンバーがインフランの講義を",
  "가입 이메일 인증이 필요합니다.": "登録メールの認証が必要です。",
  "이메일 인증이 필요한 계정입니다.\n24시간 후 재시도하거나 고객센터에 문의해주세요.": `メール認証が必要なアカウントです。
24時間後に再度お試しいただくか、カスタマーサポートへお問い合わせください。`,
  "간편 로그인": "簡単ログイン",
  강의: "講義",
  "강의 · 기능요청": "講義・機能リクエスト",
  "강의/강사명을 입력해주세요": "講義/講師名を入力してください",
  "강의리스트 보기": "講義リストを見る",
  개: "個",
  "개인정보보호책임자: 이동욱": "個人情報保護責任者：イ・ドンウク",
  개인정보처리방침: "個人情報処理方針",
  검색: "検索",
  "검색바.01": "今日は何を学びますか？",
  "검색바.02": "今すぐ検索",
  "검색바.03": "キーワード入力",
  "검색바.04": "今学びたいことは何ですか？",
  "검색바.05": "「プログラミング」で検索",
  "검색바.06": "「Python」で検索",
  "검색바.07": "「デザイン」で検索",
  "검색바.08": "新しい学び、新しい未来ーインフラン",
  "검색바.09": "今日は何を学びますか？",
  "검색바.10": "「デザイン」で検索",
  "검색바.11": "キーワード入力",
  "검색할 강의 입력": "講義名を入力",
  "경기도 성남시 분당구 판교로289번길 20": "京畿道城南市盆唐区パンギョ路289番道20",
  "경제적 보상을 받아보세요.": "経済的な報酬を受け取ってください。",
  "계정 설정": "アカウント設定",
  고객센터: "カスタマーセンター",
  고민있어요: "悩みがありますか",
  공지사항: "お知らせ",
  교육: "教育",
  구글: "グーグル",
  "구매 / 혜택": "購入 / 特典",
  "구매 내역": "購入履歴",
  국비지원교육: "国費支援教育",
  기업: "企業",
  "기업 교육을 위한 인프런": "企業教育のためのインフラン",
  깃허브: "ギットハブ",
  "나를 성장 시켜줄 좋은 지식들을 찾아보세요.": "私を成長させてくれる良い知識を探してみてください。",
  "나의 진짜 성장을 도와줄 실무 강의를 찾아보세요": "私の本当の成長を助ける実務講義を探してみてください",
  난이도: "レベル",
  "난이도 선택": "レベルを選択",
  "난이도 옵션": "レベルオプション",
  "난이도 초기화": "レベルをリセット",
  "나한테 딱 맞는 걸 찾고 싶다면": "ぴったりな講座をお探しなら",
  "어떤 강의가 나한테 맞을까?": "自分に合う講座はどれ？",
  "목표와 관심사에 맞는 인기 강의를 찾아드릴게요": "目標に合った講座を見つける",
  "지금 많이 듣는 강의 확인해보세요": "今人気の講座をチェックしてみましょう",
  "남았어요.": "残っています。",
  "내 학습": "私の学習",
  "네이버에서 구글 로그인을 지원하지 않습니다.": "ネイバーではグーグルログインをサポートしていません。",
  "누구나 들을 수 있는": "誰でも受講できる",
  "다른 모바일 브라우져(Chrome, Safari)를 이용해 주세요.": "他のモバイルブラウザ（Chrome、Safari）をご利用ください。",
  닫기: "閉じる",
  "담긴 강의가 없습니다.": "含まれている講義はありません。",
  대시보드: "ダッシュボード",
  "대표자: 이형주": "代表者：イ・ヒョンジュ",
  더보기: "もっと見る",
  둘러보기: "閲覧",
  "딱 맞는 강의가 기다리고 있어요.": "ぴったりの講義が待っています。",
  "랠릿 서비스 링크": "レリットサービスリンク",
  로그아웃: "ログアウト",
  로그인: "ログイン",
  "로그인 또는 회원가입": "ログインまたは新規登録",
  "로그인이 필요한 요청입니다.": "ログインが必要なリクエストです。",
  로드맵: "ロードマップ",
  "마음에 드는 강의를 수강해보세요!": "気に入った講義を受けてみてください！",
  "많은 사람들에게 배움의 기회를 주고,": "多くの人々に学習の機会を与え、",
  "메인 페이지로 이동하기": "メインページに移動する",
  멘토링: "メンタリング",
  "멘토링 소개": "メンタリング紹介",
  "멘토링 후기": "メンタリング後記",
  "모임/부트캠프": "集まり/ブートキャンプ",
  "문제가 발생했습니다.": "問題が発生しました。",
  보관함: "保管箱",
  분: "分",
  블로그: "ブログ",
  비밀번호: "パスワード",
  "비밀번호 찾기": "パスワード探し",
  "비밀번호를 입력해주세요.": "パスワードを入力してください。",
  비즈니스: "ビジネス",
  "비즈니스 브랜드 로고": "ビジネスブランドロゴ",
  "비즈니스 수강내역": "ビジネス受講履歴",
  "사업자 정보 확인": "事業者情報確認",
  "사업자번호: 499-81-00612": "事業者番号：499-81-00612",
  "사용자 대시보드 페이지로 이동": "ユーザーダッシュボードページに移動",
  "사용자 알림 페이지로 이동": "ユーザー通知ページに移動",
  서비스: "サービス",
  "서비스 언어를 선택하세요.": "サービス言語を選択してください。",
  "선수 지식이 필요한": "前提知識が必要な",
  설정: "設定",
  수강바구니: "受講カート",
  "수강바구니에서 전체보기": "受講カートで全体を見る",
  "수강코드 등록": "受講コード登録",
  수강평: "受講評価",
  "수강평 모아보기": "受講評価をまとめて見る",
  "수료증 확인": "修了証確認",
  스터디: "スタディ",
  시간: "時間",
  신청하기: "申し込む",
  "아이디(이메일) 찾기": "ID（メール）検索",
  애플: "アップル",
  어드민: "アドミン",
  "언어 변경": "言語変更",
  "언어 설정": "言語設定",
  원: "ウォン",
  "유저 대시보드로 이동": "ユーザーダッシュボードに移動",
  "이 공지를 그만 볼래요": "この通知をもう見たくない",
  이메일: "メール",
  "이메일 또는 비밀번호를 확인해주세요.": "メールまたはパスワードを確認してください。",
  "이메일 형식이 올바르지 않습니다.": "メールアドレスの形式が正しくありません。",
  "이메일을 입력해주세요.": "メールを入力してください。",
  "이어서 학습하기": "続けて学習する",
  이용약관: "利用約款",
  인프랩: "インフラップ",
  "인프랩 스토리": "インフラップストーリー",
  "인프랩 실Log": "インフラップ実ログ",
  "인프랩 테크": "インフラップテック",
  인프런: "インフラン",
  "인프런 네이버 블로그 바로가기": "インフランネイバーブログ直接リンク",
  "인프런 네이버 포스트 바로가기": "インフランネイバーポスト直接リンク",
  "인프런 메인 페이지로 이동": "インフランメインページに移動",
  "인프런 브랜드 로고": "インフランブランドロゴ",
  "인프런 비즈니스": "インフランビジネス",
  "인프런 소개": "インフラン紹介",
  "인프런 영문 브랜드 로고": "インフラン英文ブランドロゴ",
  "인프런 유튜브 바로가기": "インフランユーチューブ直接リンク",
  "인프런 인스타그램 바로가기": "インフランインスタグラム直接リンク",
  "인프런 제휴": "インフラン提携",
  "인프런 통합 검색": "インフラン統合検索",
  "인프런 트위터 바로가기": "インフラントゥイッター直接リンク",
  "인프런 페이스북 바로가기": "インフランフェイスブック直接リンク",
  "인프런 피드": "インフランフィード",
  "인프런으로 이동하기": "インフランへ移動する",
  입문: "入門",
  잎: "リーフ",
  "자유롭게 학습하는 환경을 제공하세요.": "自由に学習できる環境を提供してください。",
  "자주묻는 질문": "よくある質問",
  "작성한 게시글": "作成した投稿",
  "장바구니 페이지로 이동": "カートページに移動",
  "저작권 신고센터": "著作権通報センター",
  "전문성을 높이는": "専門性を高める",
  전체: "全体",
  "전체 강의": "全体講義",
  "전화번호: 070-4948-1181": "電話番号：070-4948-1181",
  좋아요: "いいね",
  주소: "住所",
  중급이상: "中級以上",
  "지금 둘러 보기": "今すぐ見る",
  지식공유: "知識共有",
  "지식공유 참여": "知識共有参加",
  지식공유자: "知識共有者",
  "지식공유자 되기": "知識共有者になる",
  지식공유참여: "知識共有参加",
  지식공유하기: "知識を共有",
  "질문 & 답변": "質問と回答",
  "질문 게시판": "質問掲示板",
  "채널톡 아이콘": "チャンネルトークアイコン",
  챌린지: "Challenge",
  "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.": "処理中にエラーが発生しました。しばらくしてから再試行してください。",
  "청강대 게임스쿨": "青江大ゲームスクール",
  초: "秒",
  초급: "初級",
  "총 결제금액": "総決済金額",
  "최근 강의 바로가기": "最近の講義への直接リンク",
  "최근 로그인": "最近のログイン",
  카카오: "カカオ",
  "카카오톡에서 구글 로그인을 지원하지 않습니다.": "カカオトークではグーグルログインをサポートしていません。",
  "카테고리 설정": "カテゴリ設定",
  커리어: "キャリア",
  커뮤니티: "コミュニティ",
  "코드 등록": "コード登録",
  쿠폰: "クーポン",
  "통신판매업: 2018-성남분당B-0062": "通信販売業：2018-城南盆唐B-0062",
  "특정 상거래법": "特定商取引法",
  "팀 프로젝트": "チームプロジェクト",
  파트너스: "パートナーズ",
  포인트: "ポイント",
  "포인트코드 등록": "ポイントコード登録",
  학생: "学生",
  "할인 종료까지": "割引終了まで",
  홈: "ホーム",
  확인: "確認",
  회원가입: "会員登録",
  "🎁 깜짝 감사 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 サプライズ感謝割引({{discountPercent}}%)が講義に適用されていますので、今すぐ購入してみてください！",
  "🎁 신규 가입 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 新規登録割引({{discountPercent}}%)が講義に適用されていますので、今すぐ購入してみてください！",
  "🎁 첫 구매 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 初購入割引({{discountPercent}}%)が講義に適用されていますので、今すぐ購入してみてください！"
}, da = {
  "(주)인프랩": "(주)인프랩",
  "(주)인프랩 사업자 정보": "(주)인프랩 사업자 정보",
  "3동 5층": "3동 5층",
  "IT 인재 채용 서비스": "IT 인재 채용 서비스",
  "MY 카테고리": "MY 카테고리",
  "With us": "With us",
  "{{category.title}} > 전체": "{{category.title}} > 전체",
  "{{name}}님 인프런과 함께 해주셔서 감사해요. 😊": "{{name}}님 인프런과 함께 해주셔서 감사해요.😊",
  "{{name}}님의 첫 도약을 응원하고 있어요. 🙌": "{{name}}님의 첫 도약을 응원하고 있어요. 🙌",
  "{{name}}님의 커리어를 응원하고 있어요. 👏": "{{name}}님의 커리어를 응원하고 있어요. 👏",
  "{{profile?.name}}님의 프로필 이미지": "{{profile?.name}}님의 프로필 이미지",
  "{{provider}}-로그인-버튼": "{{provider}}-로그인-버튼",
  "{{socialProviderNameMap[provider]}}로 로그인": "{{socialProviderNameMap[provider]}}로 로그인",
  "“인프런 비즈니스” 를 통해 모든 팀원이 인프런의 강의를": "“인프런 비즈니스” 를 통해 모든 팀원이 인프런의 강의를",
  "가입 이메일 인증이 필요합니다.": "가입 이메일 인증이 필요합니다.",
  "이메일 인증이 필요한 계정입니다.\n24시간 후 재시도하거나 고객센터에 문의해주세요.": `이메일 인증이 필요한 계정입니다.
24시간 후 재시도하거나 고객센터에 문의해주세요.`,
  "간편 로그인": "간편 로그인",
  강의: "강의",
  "강의 · 기능요청": "강의 · 기능요청",
  "강의/강사명을 입력해주세요": "강의/강사명을 입력해주세요",
  "강의리스트 보기": "강의리스트 보기",
  개: "개",
  "개인정보보호책임자: 이동욱": "개인정보보호책임자: 이동욱",
  개인정보처리방침: "개인정보처리방침",
  검색: "검색",
  "검색바.01": "우리는 성장 기회의 평등을 추구합니다.",
  "검색바.02": "요즘 관심 있는 주제나 기술이 있나요?",
  "검색바.03": "진짜 성장을 도와줄 강의를 찾아보세요.",
  "검색바.04": "실전에서 쓸 지식을 지금 배워보세요.",
  "검색바.05": "인프런에서 성장 여정을 시작해보세요.",
  "검색바.06": "성장을 위한 콘텐츠가 여기 있어요.",
  "검색바.07": "AI 시대에 필요한 무기, 지금 배워보세요.",
  "검색바.08": "지금 배우고싶은 지식을 찾아보세요.",
  "검색바.09": "우리는 성장 기회의 평등을 추구합니다.",
  "검색바.10": "성장하는 모든 사람을 응원합니다.",
  "검색바.11": "실전에 필요한 지식을 지금 배워보세요.",
  "검색할 강의 입력": "검색할 강의 입력",
  "경기도 성남시 분당구 판교로289번길 20": "경기도 성남시 분당구 판교로289번길 20",
  "경제적 보상을 받아보세요.": "경제적 보상을 받아보세요.",
  "계정 설정": "계정 설정",
  고객센터: "고객센터",
  고민있어요: "고민있어요",
  공지사항: "공지사항",
  교육: "교육",
  구글: "구글",
  "구매 / 혜택": "구매 / 혜택",
  "구매 내역": "구매 내역",
  국비지원교육: "국비지원교육",
  기업: "기업",
  "기업 교육을 위한 인프런": "기업 교육을 위한 인프런",
  깃허브: "깃허브",
  "나를 성장 시켜줄 좋은 지식들을 찾아보세요.": "나를 성장 시켜줄 좋은 지식들을 찾아보세요.",
  "나의 진짜 성장을 도와줄 실무 강의를 찾아보세요": "나의 진짜 성장을 도와줄 실무 강의를 찾아보세요",
  "나한테 딱 맞는 걸 찾고 싶다면": "나한테 딱 맞는 걸 찾고 싶다면",
  "어떤 강의가 나한테 맞을까?": "어떤 강의가 나한테 맞을까?",
  "목표와 관심사에 맞는 인기 강의를 찾아드릴게요": "목표·관심사에 맞는 인기 강의를 찾아드릴게요",
  "지금 많이 듣는 강의 확인해보세요": "지금 많이 듣는 강의 확인해보세요",
  난이도: "난이도",
  "난이도 선택": "난이도 선택",
  "난이도 옵션": "난이도 옵션",
  "난이도 초기화": "난이도 초기화",
  "남았어요.": "남았어요.",
  "내 학습": "내 학습",
  "네이버에서 구글 로그인을 지원하지 않습니다.": "네이버에서 구글 로그인을 지원하지 않습니다.",
  "누구나 들을 수 있는": "누구나 들을 수 있는",
  "다른 모바일 브라우져(Chrome, Safari)를 이용해 주세요.": "다른 모바일 브라우져(Chrome, Safari)를 이용해 주세요.",
  닫기: "닫기",
  "담긴 강의가 없습니다.": "담긴 강의가 없습니다.",
  대시보드: "대시보드",
  "대표자: 이형주": "대표자: 이형주",
  더보기: "더보기",
  둘러보기: "둘러보기",
  "딱 맞는 강의가 기다리고 있어요.": "딱 맞는 강의가 기다리고 있어요.",
  "랠릿 서비스 링크": "랠릿 서비스 링크",
  로그아웃: "로그아웃",
  로그인: "로그인",
  "로그인 또는 회원가입": "로그인 또는 회원가입",
  "로그인이 필요한 요청입니다.": "로그인이 필요한 요청입니다.",
  로드맵: "로드맵",
  "마음에 드는 강의를 수강해보세요!": "마음에 드는 강의를 수강해보세요!",
  "많은 사람들에게 배움의 기회를 주고,": "많은 사람들에게 배움의 기회를 주고,",
  "메인 페이지로 이동하기": "메인 페이지로 이동하기",
  멘토링: "멘토링",
  "멘토링 소개": "멘토링 소개",
  "멘토링 후기": "멘토링 후기",
  모의면접: "모의면접",
  "모임/부트캠프": "모임/부트캠프",
  "문제가 발생했습니다.": "문제가 발생했습니다.",
  보관함: "보관함",
  분: "분",
  블로그: "블로그",
  비밀번호: "비밀번호",
  "비밀번호 찾기": "비밀번호 찾기",
  "비밀번호를 입력해주세요.": "비밀번호를 입력해주세요.",
  비즈니스: "비즈니스",
  "비즈니스 브랜드 로고": "비즈니스 브랜드 로고",
  "비즈니스 수강내역": "비즈니스 수강내역",
  "사업자 정보 확인": "사업자 정보 확인",
  "사업자번호: 499-81-00612": "사업자번호: 499-81-00612",
  "사용자 대시보드 페이지로 이동": "사용자 대시보드 페이지로 이동",
  "사용자 알림 페이지로 이동": "사용자 알림 페이지로 이동",
  서비스: "서비스",
  "서비스 언어를 선택하세요.": "서비스 언어를 선택하세요.",
  "선수 지식이 필요한": "선수 지식이 필요한",
  설정: "설정",
  수강바구니: "수강바구니",
  "수강바구니에서 전체보기": "수강바구니에서 전체보기",
  "수강코드 등록": "수강코드 등록",
  수강평: "수강평",
  "수강평 모아보기": "수강평 모아보기",
  "수료증 확인": "수료증 확인",
  스터디: "스터디",
  시간: "시간",
  신청하기: "신청하기",
  "아이디(이메일) 찾기": "아이디(이메일) 찾기",
  애플: "애플",
  어드민: "어드민",
  "언어 변경": "언어 변경",
  "언어 설정": "언어 설정",
  원: "원",
  "유저 대시보드로 이동": "유저 대시보드로 이동",
  "이 공지를 그만 볼래요": "이 공지를 그만 볼래요",
  이메일: "이메일",
  "이메일 또는 비밀번호를 확인해주세요.": "이메일 또는 비밀번호를 확인해주세요.",
  "이메일 형식이 올바르지 않습니다.": "이메일 형식이 올바르지 않습니다.",
  "이메일을 입력해주세요.": "이메일을 입력해주세요.",
  "이어서 학습하기": "이어서 학습하기",
  이용약관: "이용약관",
  인프랩: "인프랩",
  "인프랩 스토리": "인프랩 스토리",
  "인프랩 실Log": "인프랩 실Log",
  "인프랩 테크": "인프랩 테크",
  인프런: "인프런",
  "인프런 네이버 블로그 바로가기": "인프런 네이버 블로그 바로가기",
  "인프런 네이버 포스트 바로가기": "인프런 네이버 포스트 바로가기",
  "인프런 메인 페이지로 이동": "인프런 메인 페이지로 이동",
  "인프런 브랜드 로고": "인프런 브랜드 로고",
  "인프런 비즈니스": "인프런 비즈니스",
  "인프런 소개": "인프런 소개",
  "인프런 영문 브랜드 로고": "인프런 영문 브랜드 로고",
  "인프런 유튜브 바로가기": "인프런 유튜브 바로가기",
  "인프런 인스타그램 바로가기": "인프런 인스타그램 바로가기",
  "인프런 제휴": "인프런 제휴",
  "인프런 통합 검색": "인프런 통합 검색",
  "인프런 트위터 바로가기": "인프런 트위터 바로가기",
  "인프런 페이스북 바로가기": "인프런 페이스북 바로가기",
  "인프런 피드": "인프런 피드",
  "인프런으로 이동하기": "인프런으로 이동하기",
  입문: "입문",
  잎: "잎",
  "자유롭게 학습하는 환경을 제공하세요.": "자유롭게 학습하는 환경을 제공하세요.",
  "자주묻는 질문": "자주묻는 질문",
  "작성한 게시글": "작성한 게시글",
  "장바구니 페이지로 이동": "장바구니 페이지로 이동",
  "저작권 신고센터": "저작권 신고센터",
  "전문성을 높이는": "전문성을 높이는",
  전체: "전체",
  "전체 강의": "전체 강의",
  "전화번호: 070-4948-1181": "전화번호: 070-4948-1181",
  좋아요: "좋아요",
  주소: "주소",
  중급이상: "중급이상",
  "지금 둘러 보기": "지금 둘러 보기",
  지식공유: "지식공유",
  "지식공유 참여": "지식공유 참여",
  지식공유자: "지식공유자",
  "지식공유자 되기": "지식공유자 되기",
  지식공유참여: "지식공유참여",
  지식공유하기: "지식공유하기",
  "질문 & 답변": "질문 & 답변",
  "질문 게시판": "질문 게시판",
  "채널톡 아이콘": "채널톡 아이콘",
  챌린지: "챌린지",
  "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.": "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
  "청강대 게임스쿨": "청강대 게임스쿨",
  초: "초",
  초급: "초급",
  "총 결제금액": "총 결제금액",
  "최근 강의 바로가기": "최근 강의 바로가기",
  "최근 로그인": "최근 로그인",
  카카오: "카카오",
  "카카오톡에서 구글 로그인을 지원하지 않습니다.": "카카오톡에서 구글 로그인을 지원하지 않습니다.",
  "카테고리 설정": "카테고리 설정",
  커리어: "커리어",
  커뮤니티: "커뮤니티",
  "코드 등록": "코드 등록",
  쿠폰: "쿠폰",
  "통신판매업: 2018-성남분당B-0062": "통신판매업: 2018-성남분당B-0062",
  "특정 상거래법": "",
  "팀 프로젝트": "팀 프로젝트",
  파트너스: "파트너스",
  포인트: "포인트",
  "포인트코드 등록": "포인트코드 등록",
  학생: "학생",
  "할인 종료까지": "할인 종료까지",
  홈: "홈",
  확인: "확인",
  회원가입: "회원가입",
  "🎁 깜짝 감사 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 깜짝 감사 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!",
  "🎁 신규 가입 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 신규 가입 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!",
  "🎁 첫 구매 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 첫 구매 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!"
}, ra = {
  "(주)인프랩": "Công ty TNHH Inflab",
  "(주)인프랩 사업자 정보": "Thông tin doanh nghiệp Công ty TNHH Inflab",
  "3동 5층": "Đại Hàn Dân Quốc",
  "IT 인재 채용 서비스": "Dịch vụ tuyển dụng nhân tài IT",
  "MY 카테고리": "Danh mục của tôi",
  "With us": "Cùng chúng tôi",
  "{{category.title}} > 전체": "{{category.title}} > Tất cả",
  "{{name}}님 인프런과 함께 해주셔서 감사해요. 😊": "{{name}}, cảm ơn bạn đã đồng hành cùng Inflearn 😊",
  "{{name}}님의 첫 도약을 응원하고 있어요. 🙌": "{{name}}, chúng tôi cổ vũ bước tiến đầu tiên của bạn 🙌",
  "{{name}}님의 커리어를 응원하고 있어요. 👏": "{{name}}, chúng tôi cổ vũ cho sự nghiệp của bạn 👏",
  "{{profile?.name}}님의 프로필 이미지": "Hình ảnh hồ sơ của {{profile?.name}}",
  "{{provider}}-로그인-버튼": "Nút đăng nhập {{provider}}",
  "{{socialProviderNameMap[provider]}}로 로그인": "Đăng nhập với {{socialProviderNameMap[provider]}}",
  "“인프런 비즈니스” 를 통해 모든 팀원이 인프런의 강의를": "Với 'Inflearn Business', tất cả thành viên trong đội có thể tham gia các khóa học của Inflearn",
  "가입 이메일 인증이 필요합니다.": "Cần xác thực email để đăng ký.",
  "이메일 인증이 필요한 계정입니다.\n24시간 후 재시도하거나 고객센터에 문의해주세요.": `Tài khoản này cần xác thực email.
Vui lòng thử lại sau 24 giờ hoặc liên hệ bộ phận hỗ trợ khách hàng.`,
  "간편 로그인": "Đăng nhập nhanh",
  강의: "Khóa học",
  "강의 · 기능요청": "Yêu cầu khóa học/tính năng",
  "강의/강사명을 입력해주세요": "Vui lòng nhập tên khóa học/giảng viên",
  "강의리스트 보기": "Xem danh sách khóa học",
  개: "cái",
  "개인정보보호책임자: 이동욱": "Người phụ trách bảo mật thông tin cá nhân: Lee Dongwook",
  개인정보처리방침: "Chính sách bảo mật",
  검색: "Tìm kiếm",
  "검색바.01": "Bạn quan tâm gì hôm nay?",
  "검색바.02": "Nhập từ khóa bạn muốn.",
  "검색바.03": "Đang tìm gì cụ thể?",
  "검색바.04": "Nhập tên khóa học hoặc chủ đề.",
  "검색바.05": "Đang tìm khóa học Python?",
  "검색바.06": "Hãy thử gõ “Python”.",
  "검색바.07": "Bạn muốn rèn kỹ năng nào?",
  "검색바.08": "Khám phá khóa học mới.",
  "검색바.09": "Bạn quan tâm gì hôm nay?",
  "검색바.10": "Bạn muốn rèn kỹ năng nào?",
  "검색바.11": "Đang tìm gì cụ thể?",
  "검색할 강의 입력": "Nhập tên khóa học",
  "경기도 성남시 분당구 판교로289번길 20": "Tầng 5, Tòa nhà số 3, 20, Pangyo-ro 289beon-gil, Quận Bundang, Thành phố Seongnam, Gyeonggi-do",
  "경제적 보상을 받아보세요.": "Hãy nhận phần thưởng tài chính.",
  "계정 설정": "Cài đặt tài khoản",
  고객센터: "Trung tâm khách hàng",
  고민있어요: "Tôi cần giúp đỡ",
  공지사항: "Thông báo",
  교육: "Đào tạo",
  구글: "Google",
  "구매 / 혜택": "Mua hàng / Ưu đãi ",
  "구매 내역": "Lịch sử mua hàng",
  국비지원교육: "Khóa học được hỗ trợ bởi nhà nước",
  기업: "Doanh nghiệp",
  "기업 교육을 위한 인프런": "Inflearn cho giáo dục doanh nghiệp",
  깃허브: "GitHub",
  "나를 성장 시켜줄 좋은 지식들을 찾아보세요.": "Hãy tìm kiếm những kiến thức tuyệt vời giúp bạn phát triển.",
  "나의 진짜 성장을 도와줄 실무 강의를 찾아보세요": "Tìm các khóa học thực tiễn giúp bạn thực sự phát triển.",
  난이도: "Cấp độ",
  "난이도 선택": "Chọn cấp độ",
  "난이도 옵션": "Tùy chọn cấp độ",
  "난이도 초기화": "Đặt lại cấp độ",
  "나한테 딱 맞는 걸 찾고 싶다면": "Bạn muốn tìm khóa học phù hợp?",
  "어떤 강의가 나한테 맞을까?": "Khóa học nào phù hợp với tôi?",
  "목표와 관심사에 맞는 인기 강의를 찾아드릴게요": "Tìm khóa học cho mục tiêu của bạn",
  "지금 많이 듣는 강의 확인해보세요": "Xem ngay những khóa học đang được học nhiều nhất",
  "남았어요.": "còn lại.",
  "내 학습": "Học tập của tôi",
  "네이버에서 구글 로그인을 지원하지 않습니다.": "Naver không hỗ trợ đăng nhập bằng Google.",
  "누구나 들을 수 있는": "Mở cho tất cả mọi người",
  "다른 모바일 브라우져(Chrome, Safari)를 이용해 주세요.": "Vui lòng sử dụng trình duyệt di động khác (Chrome, Safari).",
  닫기: "Đóng",
  "담긴 강의가 없습니다.": "Không có khóa học nào trong giỏ hàng.",
  대시보드: "Bảng điều khiển",
  "대표자: 이형주": "Người đại diện: Lee Hyeongjoo",
  더보기: "Xem thêm",
  둘러보기: "Khám phá",
  "딱 맞는 강의가 기다리고 있어요.": "Khóa học phù hợp nhất đang chờ bạn.",
  "랠릿 서비스 링크": "Liên kết dịch vụ Rallit",
  로그아웃: "Đăng xuất",
  로그인: "Đăng nhập",
  "로그인 또는 회원가입": "Đăng nhập hoặc Đăng ký",
  "로그인이 필요한 요청입니다.": "Bạn cần đăng nhập để thực hiện yêu cầu này.",
  로드맵: "Lộ trình",
  "마음에 드는 강의를 수강해보세요!": "Hãy tham gia khóa học bạn yêu thích!",
  "많은 사람들에게 배움의 기회를 주고,": "Mang lại cơ hội học tập cho nhiều người,",
  "메인 페이지로 이동하기": "Đi đến trang chính",
  멘토링: "Mentoring",
  "멘토링 소개": "Giới thiệu mentoring",
  "멘토링 후기": "Đánh giá mentoring",
  "모임/부트캠프": "Câu lạc bộ/Bootcamp",
  "문제가 발생했습니다.": "Đã xảy ra sự cố.",
  보관함: "Kho lưu trữ",
  분: "phút",
  블로그: "Blog",
  비밀번호: "Mật khẩu",
  "비밀번호 찾기": "Tìm mật khẩu",
  "비밀번호를 입력해주세요.": "Vui lòng nhập mật khẩu.",
  비즈니스: "Doanh nghiệp",
  "비즈니스 브랜드 로고": "Logo thương hiệu doanh nghiệp",
  "비즈니스 수강내역": "Lịch sử khóa học doanh nghiệp",
  "사업자 정보 확인": "Kiểm tra thông tin doanh nghiệp",
  "사업자번호: 499-81-00612": "Mã số kinh doanh: 499-81-00612",
  "사용자 대시보드 페이지로 이동": "Đi đến trang bảng điều khiển người dùng",
  "사용자 알림 페이지로 이동": "Đi đến trang thông báo của người dùng",
  서비스: "Dịch vụ",
  "서비스 언어를 선택하세요.": "Vui lòng chọn ngôn ngữ dịch vụ.",
  "선수 지식이 필요한": "Yêu cầu kiến thức nền tảng",
  설정: "Cài đặt",
  수강바구니: "Giỏ khóa học",
  "수강바구니에서 전체보기": "Xem toàn bộ trong giỏ khóa học",
  "수강코드 등록": "Đăng ký mã khóa học",
  수강평: "Đánh giá khóa học",
  "수강평 모아보기": "Xem tất cả đánh giá",
  "수료증 확인": "Xem chứng chỉ hoàn thành",
  스터디: "Câu lạc bộ học tập",
  시간: "giờ",
  신청하기: "Đăng ký",
  "아이디(이메일) 찾기": "Tìm ID (email)",
  애플: "Apple",
  어드민: "Quản trị viên",
  "언어 변경": "Thay đổi ngôn ngữ",
  "언어 설정": "Cài đặt ngôn ngữ",
  원: "₫",
  "유저 대시보드로 이동": "Đi đến bảng điều khiển người dùng",
  "이 공지를 그만 볼래요": "Không muốn thấy thông báo này nữa",
  이메일: "Email",
  "이메일 또는 비밀번호를 확인해주세요.": "Vui lòng kiểm tra lại email hoặc mật khẩu.",
  "이메일 형식이 올바르지 않습니다.": "Định dạng email không hợp lệ.",
  "이메일을 입력해주세요.": "Vui lòng nhập email.",
  "이어서 학습하기": "Tiếp tục học",
  이용약관: "Điều khoản sử dụng",
  인프랩: "Inflab",
  "인프랩 스토리": "Câu chuyện về Inflab",
  "인프랩 실Log": "Nhật ký của Inflab",
  "인프랩 테크": "Công nghệ của Inflab",
  인프런: "Inflearn",
  "인프런 네이버 블로그 바로가기": "Đi đến blog Naver của Inflearn",
  "인프런 네이버 포스트 바로가기": "Đi đến bài viết Naver của Inflearn",
  "인프런 메인 페이지로 이동": "Đi đến trang chính của Inflearn",
  "인프런 브랜드 로고": "Logo thương hiệu Inflearn",
  "인프런 비즈니스": "Inflearn doanh nghiệp",
  "인프런 소개": "Giới thiệu Inflearn",
  "인프런 영문 브랜드 로고": "Logo thương hiệu tiếng Anh của Inflearn",
  "인프런 유튜브 바로가기": "Đi đến kênh YouTube của Inflearn",
  "인프런 인스타그램 바로가기": "Đi đến Instagram của Inflearn",
  "인프런 제휴": "Đối tác Inflearn",
  "인프런 통합 검색": "Tìm kiếm trong Inflearn",
  "인프런 트위터 바로가기": "Đi đến X (Twitter) của Inflearn",
  "인프런 페이스북 바로가기": "Đi đến Facebook của Inflearn",
  "인프런 피드": "Bảng tin Inflearn",
  "인프런으로 이동하기": "Đi đến Inflearn",
  입문: "Nhập môn",
  잎: "lá",
  "자유롭게 학습하는 환경을 제공하세요.": "Hãy cung cấp một môi trường học tập tự do.",
  "자주묻는 질문": "Câu hỏi thường gặp",
  "작성한 게시글": "Bài viết đã tạo",
  "장바구니 페이지로 이동": "Đi đến trang giỏ hàng",
  "저작권 신고센터": "Trung tâm báo cáo vi phạm bản quyền",
  "전문성을 높이는": "Nâng cao chuyên môn",
  전체: "Tất cả",
  "전체 강의": "Tất cả khóa học",
  "전화번호: 070-4948-1181": "Số điện thoại: 070-4948-1181",
  좋아요: "Thích",
  주소: "Địa chỉ",
  중급이상: "Trung cấp trở lên",
  "지금 둘러 보기": "Xem ngay bây giờ",
  지식공유: "Chia sẻ kiến thức",
  "지식공유 참여": "Tham gia chia sẻ kiến thức",
  지식공유자: "Người chia sẻ kiến thức",
  "지식공유자 되기": "Trở thành người chia sẻ kiến thức",
  지식공유참여: "Tham gia chia sẻ kiến thức",
  지식공유하기: "Chia sẻ kiến thức",
  "질문 & 답변": "Hỏi & Đáp",
  "질문 게시판": "Bảng câu hỏi",
  "채널톡 아이콘": "Biểu tượng ChannelTalk",
  챌린지: "Challenge",
  "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.": "Đã xảy ra lỗi trong quá trình xử lý. Vui lòng thử lại sau.",
  "청강대 게임스쿨": "Trường Game Chungkang",
  초: "giây",
  초급: "Cơ bản",
  "총 결제금액": "Tổng số tiền thanh toán",
  "최근 강의 바로가기": "Đi đến khóa học gần đây",
  "최근 로그인": "Đăng nhập gần đây",
  카카오: "Kakao",
  "카카오톡에서 구글 로그인을 지원하지 않습니다.": "KakaoTalk không hỗ trợ đăng nhập bằng Google.",
  "카테고리 설정": "Cài đặt danh mục",
  커리어: "Sự nghiệp",
  커뮤니티: "Cộng đồng",
  "코드 등록": "Đăng ký mã",
  쿠폰: "Coupon",
  "통신판매업: 2018-성남분당B-0062": "Ngành bán hàng trực tuyến: 2018-SeongnamBundangB-0062",
  "특정 상거래법": "",
  "팀 프로젝트": "Dự án nhóm",
  파트너스: "Đối tác",
  포인트: "Điểm",
  "포인트코드 등록": "Đăng ký mã điểm",
  학생: "Học sinh",
  "할인 종료까지": "Kết thúc giảm giá trong",
  홈: "Trang chủ",
  확인: "Xác nhận",
  회원가입: "Đăng ký thành viên",
  "🎁 깜짝 감사 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 Giảm giá cảm ơn bất ngờ ({{discountPercent}}%) đã được áp dụng cho khóa học, hãy mua ngay!",
  "🎁 신규 가입 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 Giảm giá cho thành viên mới ({{discountPercent}}%) đã được áp dụng cho khóa học, hãy mua ngay!",
  "🎁 첫 구매 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 Giảm giá lần mua đầu tiên ({{discountPercent}}%) đã được áp dụng cho khóa học, hãy mua ngay!"
}, De = {
  ko: {
    appShell: da
  },
  en: {
    appShell: Aa
  },
  vi: {
    appShell: ra
  },
  ja: {
    appShell: ua
  }
}, Pe = Object.keys(De), qg = F.createInstance();
qg.use(je).use(gb).init({
  defaultNS: "appShell",
  fallbackLng: lg,
  supportedLngs: Pe,
  detection: {
    order: ["path"]
  },
  interpolation: {
    escapeValue: !1
  },
  debug: !1,
  cleanCode: !0,
  // e.g. EN -> en
  resources: De
});
function oa(g) {
  return !!Pe.find((I) => I === g);
}
function ig() {
  return oa(qg.language) ? qg.language : lg;
}
function ke() {
  return ig() === lg;
}
function Qs(g, I) {
  return () => qg.t(g, I) ?? "";
}
function Ms(g, I = ig()) {
  return E.stringifyUrl({
    url: g,
    query: {
      lang: I
    }
  });
}
const j = {
  EMAIL: "info@inflearn.com",
  SITE: jI,
  MEMBER_HISTORY: "https://doc.clickup.com/d/3gfz7-5843/log/3gfz7-75205/%EC%9D%B8%ED%94%84%EB%9E%A9-%EC%8B%A4-log",
  STORY: "https://story.inflab.com/",
  TECH_BLOG: "https://tech.inflab.com/",
  RALLIT_BUSINESS: "https://business.rallit.com/"
};
function Ga() {
  return ke() ? j.SITE : `${j.SITE}/${ig()}`;
}
function Z(g, I) {
  const c = I ?? (rb === "localhost" ? "" : j.SITE), e = g.startsWith("/") ? g : `/${g}`;
  return ke() ? `${c}${e}` : `${c}/${ig()}${e}`;
}
const Ks = {
  INFO_PRIVACY: Z("/policy/privacy", j.SITE),
  INFO_TERMS: Z("/policy/terms-of-service", j.SITE),
  BIZ_INFO: "http://www.ftc.go.kr/bizCommPop.do?wrkr_no=4998100612",
  INF_EMAIL: `mailto:${j.EMAIL}`
}, _s = {
  SPECIFIED_COMMERCIAL_TRANSACTIONS: `${j.SITE}/ja/policy/specified-commercial-transactions`
}, qs = {
  RALLIT_SITE: Wc,
  RALLIT_MY_LOG: `${Wc}/my/log`
}, $s = `${j.SITE}/channeltalk`, Q = {
  CHALLENGES: Z("/challenges"),
  MAIN: Ga(),
  WITH_US: Z("/pages/withus", j.SITE),
  INSTRUCTOR: Z(ig() === lg ? "/instructor" : "/instructor/courses"),
  INSTRUCTOR_ABROAD: Z("/instructor/courses"),
  APPLY_INSTRUCTOR: Z("/instructor/application"),
  APPLY_B2B: Z("/intro-group"),
  SIGN_UP: Z("/signup"),
  SIGN_IN: Z("/signin"),
  SIGNUP_EMAIL_REVERIFY: Z("/signup/email/reverify"),
  INTRO_GROUP: Z("/intro-group"),
  COURSES: (g) => {
    const I = g != null && g.category ? `/${g == null ? void 0 : g.category}` : "", c = g != null && g.subCategory ? `/${g == null ? void 0 : g.subCategory}` : "", e = ((g == null ? void 0 : g.searchKeyword) ?? "").trim();
    return e ? Q.SEARCH({
      order: g == null ? void 0 : g.order,
      types: g == null ? void 0 : g.types,
      skill: g == null ? void 0 : g.skill,
      searchKeyword: e,
      completionAttributionToken: g == null ? void 0 : g.completionAttributionToken,
      selectedSuggestion: g == null ? void 0 : g.selectedSuggestion,
      selectedPosition: g == null ? void 0 : g.selectedPosition,
      levels: g == null ? void 0 : g.levels,
      tab: g == null ? void 0 : g.tab
    }) : E.stringifyUrl({
      url: Z(`/courses${I}${c}`),
      query: {
        order: g == null ? void 0 : g.order,
        types: g == null ? void 0 : g.types,
        skill: g == null ? void 0 : g.skill,
        s: e,
        completionAttributionToken: g == null ? void 0 : g.completionAttributionToken,
        selectedSuggestion: g == null ? void 0 : g.selectedSuggestion,
        selectedPosition: g == null ? void 0 : g.selectedPosition,
        levels: g == null ? void 0 : g.levels,
        onboarding: g == null ? void 0 : g.onboarding,
        redirectTo: g == null ? void 0 : g.redirectTo
      }
    }, {
      skipNull: !0,
      skipEmptyString: !0
    });
  },
  SEARCH: (g) => E.stringifyUrl({
    url: Z("/search"),
    query: {
      order: g == null ? void 0 : g.order,
      types: g == null ? void 0 : g.types,
      skill: g == null ? void 0 : g.skill,
      s: g == null ? void 0 : g.searchKeyword,
      completionAttributionToken: g == null ? void 0 : g.completionAttributionToken,
      selectedSuggestion: g == null ? void 0 : g.selectedSuggestion,
      selectedPosition: g == null ? void 0 : g.selectedPosition,
      levels: g == null ? void 0 : g.levels,
      tab: g == null ? void 0 : g.tab
    }
  }, {
    skipNull: !0,
    skipEmptyString: !0
  }),
  COMMUNITY: Z("/community"),
  COMMUNITY_USER_POSTS: Z("/my/posts/question"),
  COMMUNITY_WITH_SEARCH: ({
    keyword: g
  }) => E.stringifyUrl({
    url: Z("/community"),
    query: {
      s: g
    }
  }, {
    skipNull: !0,
    skipEmptyString: !0
  }),
  ROADMAPS: Z("/roadmaps"),
  ROADMAPS_WITH_SEARCH: ({
    keyword: g,
    sort: I,
    pageNumber: c
  }) => E.stringifyUrl({
    url: Z("/roadmaps"),
    query: {
      s: g,
      sort: I,
      page_number: c
    }
  }, {
    skipNull: !0,
    skipEmptyString: !0
  }),
  ENROLLED_ROADMAPS: Z("/user/roadmaps/enrolled"),
  MENTORS: Z("/mentors", Dg),
  MENTORING_WITH_SEARCH: ({
    keyword: g
  }) => E.stringifyUrl({
    url: Z("/mentors", Dg),
    query: {
      s: g
    }
  }, {
    skipNull: !0,
    skipEmptyString: !0
  }),
  COMMUNITY_QUESTION: Z("/community/questions"),
  COMMUNITY_REVIEWS: Z("/community/reviews"),
  BLOGS: Z("/blogs"),
  COMMUNITY_STUDIES: Z("/community/studies"),
  COMMUNITY_CHATS: Z("/community/chats"),
  COMMUNITY_PROJECTS: Z("/community/projects"),
  COMMUNITY_MENTORINGS_REVIEWS: Z("/community/mentorings-reviews"),
  NOTICE_LIST: Z("/notices"),
  STORIES: Z("/pages"),
  INFLEARN: Z("/inflearn"),
  REQUEST_TO_INFLEARN: Z("/request-to-inflearn"),
  ACCOUNT_DASHBOARD: Z("/users/me/dashboard"),
  ACCOUNT_SETTING: Z("/my/settings/account"),
  CARTS: Z("/carts"),
  MESSAGE_LIST: Z("/user/messages"),
  EVENTS: Z("/pages?type=event"),
  LOGOUT: (g) => E.stringifyUrl({
    url: `${jI}/signout`,
    query: {
      lang: ig(),
      redirectTo: g.redirectTo
    }
  }),
  LECTURE_LAST_VOUCHER: (g, I) => Z(`/course/${g}/unit/${I}`),
  FIND_ID: Z("/signin/find/id"),
  청강대게임스쿨: Z("/tag-curation/tag/18123"),
  FIND_PW: Z("/signin/find/password"),
  USER_MENTORINGS: Z("/my/mentorings"),
  USER_POSTS: Z("/my/posts"),
  MY_PARTNERS: Z("/my/partners"),
  MY_PARTNERS_LINKS: Z("/my/partners-links"),
  PARTNERS_NEW: Z("/partners/new"),
  USER_INQUIRIES: Z("/user/inquiries"),
  USER_LIKES: Z("/my/likes"),
  USER_SETTINGS_ACCOUNT: Z("/my/settings/account"),
  USER_COURSES: Z("/my/courses"),
  MY_RECEIVED_GIFTS: Z("/my/gifts/received"),
  USER_POINT: Z("/user/points"),
  USER_COUPONS: Z("/user/coupons"),
  FAQ: Z("/faq"),
  KDT: Z("/tag-curation/common_tag/kdt"),
  PARTNERS_LANDING: Z("/pages/partners"),
  BUSINESS: (g) => `${Fe}/new/groups/${g}/dashboard`,
  BUSINESS_ENROLMENTS: Z("/biz-enrolments"),
  USER_PROFILE: (g, I) => Z(I ? `/users/${g}/@${I}` : `/users/${g}`),
  ORDERS: Z("/my/orders"),
  AI_INTERVIEWS: ({
    from: g
  }) => E.stringifyUrl({
    url: Z("/ai-interviews"),
    query: {
      from: g
    }
  }),
  FIND_RECOMMEND_COURSES: Z("/courses?charge=free&order=seq"),
  CERTIFICATE: Z("/certificate"),
  COURSE_DETAIL: (g) => Z(`/course/${g}`),
  CLIPS: Z("/clips"),
  CLIPS_WITH_SEARCH: ({
    searchKeyword: g,
    sort: I
  }) => E.stringifyUrl({
    url: Z("/clips"),
    query: {
      s: g,
      sort: I
    }
  }, {
    skipNull: !0,
    skipEmptyString: !0
  })
}, gA = {
  MY_CATEGORY: "my-category"
}, oI = {
  /** 푸터 등은 `/intro-group`(리다이렉트)을 쓰지만 여기는 비즈니스 도메인을 직접 가리킨다 */
  B2B: `${Fe}/intro`,
  LIFELONG_VOUCHER: Z("/pages/lifelongvoucher_2026"),
  /** ?from=header 는 트래킹용 파라미터  */
  AI_REFUND: `${Z("/pages/company_pre_b")}?from=header`
}, IA = {
  INTRO: Z("/inflearn"),
  FEED: Z("/pages"),
  OPEN_KNOWLEDGE: Z("/open-knowledge"),
  MENTORS_INTRO: Z("/mentors-intro"),
  INTRO_GROUP: Z("/intro-group"),
  PARTNERS: Z("/partners"),
  COURSE_CODE: Z("/course-code"),
  POINT_CODE: Z("/point-code"),
  COPYRIGHT: Z("/copyright"),
  REQUEST_TO_INFLEARN: Z("/request-to-inflearn")
}, cA = {
  NAVER_BLOG: "https://blog.naver.com/inflearn",
  INSTAGRAM: "https://www.instagram.com/inflearn__official",
  YOUTUBE: "https://www.youtube.com/channel/UC0Y0T9JpgIBbyGDjvy9PbOg",
  FACEBOOK: "https://www.facebook.com/inflearn",
  TWITTER: "https://twitter.com/inflearn",
  THREADS: "https://www.threads.com/@inflearn__official"
}, eA = {
  AI_CHAT: "https://www.inflearn.com/chat/set-cookie"
};
function Xa() {
  const g = ul(), {
    analytics: I
  } = Al(), c = () => {
    var l, i;
    try {
      const t = g.getQueryData([pI.CLIENT_V2_ACCOUNTS_PROFILE]);
      if (!(t != null && t.data))
        return {
          user_id: null,
          user_name: null,
          user_email: null,
          user_group_id: null,
          user_group_subscription_id: null,
          role_b2b: !1,
          role_b2c: !1,
          role_admin: !1,
          role_instructor: !1
        };
      const {
        id: n,
        name: C,
        email: b
      } = t.data;
      return {
        user_id: n,
        user_name: C,
        user_email: b,
        user_group_id: (l = t.data.group) == null ? void 0 : l.id,
        user_group_subscription_id: (i = t.data.group) == null ? void 0 : i.groupSubscriptionId,
        role_b2b: JI(t.data),
        role_b2c: !JI(t.data),
        role_admin: t.data.isAdmin,
        role_instructor: t.data.isInstructor
      };
    } catch {
      return {
        user_id: null,
        user_name: null,
        user_email: null,
        user_group_id: null,
        user_group_subscription_id: null,
        role_b2b: !1,
        role_b2c: !1,
        role_admin: !1,
        role_instructor: !1
      };
    }
  };
  return {
    trackEvent: (l, i) => I.track(l, {
      mixpanelToken: Gb,
      userId: c().user_id,
      mxp___user: c(),
      ...i
    })
  };
}
function Za() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const lA = process.env.NODE_ENV === "production" ? {
  name: "lidyt8",
  styles: "*{box-sizing:border-box;}a{text-decoration:none;}.hidden{display:none;}.disabledScroll{overflow:hidden;}"
} : {
  name: "ncoqxb-globals",
  styles: "*{box-sizing:border-box;}a{text-decoration:none;}.hidden{display:none;}.disabledScroll{overflow:hidden;};label:globals;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9zdHlsZXMvZ2xvYmFscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFbUIiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvZmUtc2hhcmVkL2ZlLXNoYXJlZC9wYWNrYWdlcy9hcHAtc2hlbGwvc3JjL3N0eWxlcy9nbG9iYWxzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5jb25zdCBnbG9iYWxzID0gY3NzYFxuICAqIHtcbiAgICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICB9XG5cbiAgYSB7XG4gICAgdGV4dC1kZWNvcmF0aW9uOiBub25lO1xuICB9XG5cbiAgLmhpZGRlbiB7XG4gICAgZGlzcGxheTogbm9uZTtcbiAgfVxuXG4gIC5kaXNhYmxlZFNjcm9sbCB7XG4gICAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgfVxuYDtcblxuZXhwb3J0IGRlZmF1bHQgZ2xvYmFscztcbiJdfQ== */",
  toString: Za
}, iA = {
  mobile: 768,
  tablet: 1024,
  laptop: 1365,
  desktop: 1920
}, Tg = {
  desktop: "@media (max-width: 1200px)",
  tablet: "@media (max-width: 1024px)",
  mobile: "@media (max-width: 768px)",
  smallMobile: "@media (max-width: 480px)"
};
function U(g) {
  return g === "mobile" ? Tg.mobile : g === "tablet" ? Tg.tablet : Tg.desktop;
}
const QI = (g = !1) => ({
  HEADER: g ? 72 : 200,
  HEADER_NOTICE: g ? 73 : 201,
  SCRIM: g ? 10 : 200,
  // NOTE: drawer overlay
  MOBILE_ASIDE: g ? 76 : 201,
  // NOTE: drawer
  BOTTOM_NAVIGATION: g ? 74 : 200,
  MOVE_TOP: g ? 9 : 200,
  // NOTE: 모달  dimmed 영역의 zIndex 201보다 작아야 함
  POPOVER: g ? 10 : 15,
  SEARCHBAR_MODAL: 202
}), Wa = {
  CHILDREN_WRAPPER: "children-wrapper",
  HEADER_DIVIDER_DESKTOP: "header-divider-desktop",
  HEADER_DIVIDER_MOBILE: "header-divider-mobile",
  HEADER_CONTAINER_DESKTOP: "header-container-desktop",
  HEADER_CONTAINER_MOBILE: "header-container-mobile",
  /**
   * @NOTE
   * 헤더 아래로 돌출되는 검색바 영역을 실제 레이아웃 공간으로 확보하는 스페이서.
   * main/footer 를 transform 으로 밀어내던 방식은 스크롤 중 콘텐츠가 움직이는
   * 체감 CLS(드득거림)를 유발해서 flow 상의 공간 확보로 대체함
   */
  HEADER_SEARCH_BAR_SPACER: "header-search-bar-spacer",
  FOOTER_CONTAINER: "footer-container",
  /**
   * @NOTE
   * 아래로 스크롤 했을 때 모바일 헤더 가려지게 하기 위한 식별자
   */
  HEADER_MOBILE_TOP: "header-mobile-top",
  /**
   * @NOTE
   * 아래로 스크롤 했을 때 바텀 네비 가려지게 하기 위한 식별자
   * 앤트맨에서 참조하기 위해 사용
   */
  HEADER_MOBILE_BOTTOM: "header-mobile-bottom",
  HEADER_INTEGRATED: "header-integrated"
}, Pc = {
  DESKTOP: 37,
  MOBILE: 34
}, Qe = {
  DESKTOP: {
    DEFAULT: 65,
    SEARCH_BAR: 80
  },
  MOBILE: {
    DEFAULT: 50,
    /** searchBarStyles 의 상단 패딩 4 + 검색바 46 + 하단 패딩 10 */
    SEARCH_BAR: 60
  }
}, Me = Qe.DESKTOP.DEFAULT, tA = Qe.MOBILE.DEFAULT, ha = /* @__PURE__ */ S({
  position: "relative",
  display: "flex",
  alignItems: "center",
  height: Me,
  padding: "0 32px",
  maxWidth: 1440,
  width: "100%",
  minHeight: "unset",
  [U("tablet")]: {
    padding: "0 32px",
    height: "auto"
  },
  [U("mobile")]: {
    padding: "0 16px",
    height: "auto"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:styleHeaderContent;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), Va = /* @__PURE__ */ S({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  height: Pc.DESKTOP,
  padding: "0 32px",
  maxWidth: 1440,
  width: "100%",
  [U("tablet")]: {
    height: Pc.MOBILE
  },
  [U("mobile")]: {
    padding: "0 16px"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:styleIntegratedHeaderContent;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function xa() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const ma = [{
  label: "기업 교육",
  href: oI.B2B,
  value: "integrated_b2b"
}, {
  label: "평생교육이용권",
  href: oI.LIFELONG_VOUCHER,
  value: "integrated_lifelong_voucher"
}, {
  label: "AI 교육 90% 환급",
  href: oI.AI_REFUND,
  value: "integrated_ai_refund"
}], Na = ({
  onLinkClick: g,
  containerStyles: I
}) => /* @__PURE__ */ W(w, { css: [Va, I, process.env.NODE_ENV === "production" ? "" : ";label:IntegratedHeaderLinks;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: /* @__PURE__ */ W(v, { spacing: 12, align: "center", noWrap: !0, children: ma.map(({
  label: c,
  href: e,
  value: l
}, i) => /* @__PURE__ */ z(v, { spacing: 12, align: "center", noWrap: !0, children: [
  i !== 0 && /* @__PURE__ */ W(w, { css: pa }),
  /* @__PURE__ */ W(FI, { href: e, underline: !1, onClick: () => g == null ? void 0 : g(l), children: /* @__PURE__ */ W(BI, { css: Ja, children: c }) })
] }, l)) }) }), Ra = process.env.NODE_ENV === "production" ? {
  name: "nr8bfq",
  styles: "display:flex;justify-content:center;width:100%;background-color:white"
} : {
  name: "knl97s-styleIntegratedHeaderRoot",
  styles: "display:flex;justify-content:center;width:100%;background-color:white;label:styleIntegratedHeaderRoot;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: xa
}, Ja = /* @__PURE__ */ S({
  color: yg.gray[7],
  fontSize: 14,
  fontWeight: 500,
  lineHeight: 1.5,
  whiteSpace: "nowrap",
  [U("tablet")]: {
    fontSize: 12
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:styleIntegratedHeaderLinkText;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), pa = /* @__PURE__ */ S({
  width: 1,
  height: 12,
  backgroundColor: yg.gray[3]
}, process.env.NODE_ENV === "production" ? "" : ";label:styleIntegratedHeaderDivider;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9jb21wb25lbnRzL25leHQvSGVhZGVyL2NvbXBvbmVudHMvaW50ZWdyYXRlZEhlYWRlckNvbnRlbnQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWtFcUMiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvZmUtc2hhcmVkL2ZlLXNoYXJlZC9wYWNrYWdlcy9hcHAtc2hlbGwvc3JjL2NvbXBvbmVudHMvbmV4dC9IZWFkZXIvY29tcG9uZW50cy9pbnRlZ3JhdGVkSGVhZGVyQ29udGVudC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdHlwZSB7IEludGVycG9sYXRpb24sIFRoZW1lIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgQW5jaG9yLCBCb3gsIENPTE9SX1BBTEVUVEUsIEdyb3VwLCBUZXh0IH0gZnJvbSAnQGluZmxlYXJuL2RzLXJlYWN0JztcblxuaW1wb3J0IHsgSU5URUdSQVRFRF9IRUFERVJfVVJMIH0gZnJvbSAnLi4vLi4vLi4vLi4vY29uc3RhbnRzL3VybHMnO1xuaW1wb3J0IHsgbWVkaWFRdWVyaWVzIH0gZnJvbSAnLi4vLi4vLi4vLi4vc3R5bGVzJztcbmltcG9ydCB7IHN0eWxlSW50ZWdyYXRlZEhlYWRlckNvbnRlbnQgfSBmcm9tICcuLi9zdHlsZXMnO1xuXG4vKipcbiAqIEludGVncmF0ZWRIZWFkZXIg7JmAIFNTUiDsiqTsvIjroIjthqTsnbQg6rO17Jyg7ZWY64qUIO2RnO2YhCDqs4TsuLUuXG4gKiBza2VsZXRvbiDsl5TtirjrpqzqsIAgYW5hbHl0aWNzL3JlYWN0LXF1ZXJ5IOulvCDrsojrk6Tsl5Ag64GM7Ja07Jik7KeAIOyViuuPhOuhnSDtm4Ug7J2Y7KG07J2EIOuRkOyngCDslYrripTri6QuXG4gKi9cbmV4cG9ydCBjb25zdCBJTlRFR1JBVEVEX0hFQURFUl9MSU5LUyA9IFtcbiAgeyBsYWJlbDogJ+q4sOyXhSDqtZDsnKEnLCBocmVmOiBJTlRFR1JBVEVEX0hFQURFUl9VUkwuQjJCLCB2YWx1ZTogJ2ludGVncmF0ZWRfYjJiJyB9LFxuICB7XG4gICAgbGFiZWw6ICftj4nsg53qtZDsnKHsnbTsmqnqtownLFxuICAgIGhyZWY6IElOVEVHUkFURURfSEVBREVSX1VSTC5MSUZFTE9OR19WT1VDSEVSLFxuICAgIHZhbHVlOiAnaW50ZWdyYXRlZF9saWZlbG9uZ192b3VjaGVyJyxcbiAgfSxcbiAge1xuICAgIGxhYmVsOiAnQUkg6rWQ7JyhIDkwJSDtmZjquIknLFxuICAgIGhyZWY6IElOVEVHUkFURURfSEVBREVSX1VSTC5BSV9SRUZVTkQsXG4gICAgdmFsdWU6ICdpbnRlZ3JhdGVkX2FpX3JlZnVuZCcsXG4gIH0sXG5dIGFzIGNvbnN0O1xuXG5leHBvcnQgY29uc3QgSW50ZWdyYXRlZEhlYWRlckxpbmtzID0gKHtcbiAgb25MaW5rQ2xpY2ssXG4gIGNvbnRhaW5lclN0eWxlcyxcbn06IHtcbiAgb25MaW5rQ2xpY2s/OiAodmFsdWU6IHN0cmluZykgPT4gdm9pZDtcbiAgY29udGFpbmVyU3R5bGVzPzogSW50ZXJwb2xhdGlvbjxUaGVtZT47XG59KSA9PiAoXG4gIDxCb3ggY3NzPXtbc3R5bGVJbnRlZ3JhdGVkSGVhZGVyQ29udGVudCwgY29udGFpbmVyU3R5bGVzXX0+XG4gICAgPEdyb3VwPCdkaXYnPiBzcGFjaW5nPXsxMn0gYWxpZ249XCJjZW50ZXJcIiBub1dyYXA+XG4gICAgICB7SU5URUdSQVRFRF9IRUFERVJfTElOS1MubWFwKCh7IGxhYmVsLCBocmVmLCB2YWx1ZSB9LCBpbmRleCkgPT4gKFxuICAgICAgICA8R3JvdXA8J2Rpdic+IGtleT17dmFsdWV9IHNwYWNpbmc9ezEyfSBhbGlnbj1cImNlbnRlclwiIG5vV3JhcD5cbiAgICAgICAgICB7aW5kZXggIT09IDAgJiYgPEJveCBjc3M9e3N0eWxlSW50ZWdyYXRlZEhlYWRlckRpdmlkZXJ9IC8+fVxuICAgICAgICAgIDxBbmNob3IgaHJlZj17aHJlZn0gdW5kZXJsaW5lPXtmYWxzZX0gb25DbGljaz17KCkgPT4gb25MaW5rQ2xpY2s/Lih2YWx1ZSl9PlxuICAgICAgICAgICAgPFRleHQgY3NzPXtzdHlsZUludGVncmF0ZWRIZWFkZXJMaW5rVGV4dH0+e2xhYmVsfTwvVGV4dD5cbiAgICAgICAgICA8L0FuY2hvcj5cbiAgICAgICAgPC9Hcm91cD5cbiAgICAgICkpfVxuICAgIDwvR3JvdXA+XG4gIDwvQm94PlxuKTtcblxuZXhwb3J0IGNvbnN0IHN0eWxlSW50ZWdyYXRlZEhlYWRlclJvb3QgPSBjc3Moe1xuICBkaXNwbGF5OiAnZmxleCcsXG4gIGp1c3RpZnlDb250ZW50OiAnY2VudGVyJyxcbiAgd2lkdGg6ICcxMDAlJyxcbiAgYmFja2dyb3VuZENvbG9yOiAnd2hpdGUnLFxufSk7XG5cbmNvbnN0IHN0eWxlSW50ZWdyYXRlZEhlYWRlckxpbmtUZXh0ID0gY3NzKHtcbiAgY29sb3I6IENPTE9SX1BBTEVUVEUuZ3JheVs3XSxcbiAgZm9udFNpemU6IDE0LFxuICBmb250V2VpZ2h0OiA1MDAsXG4gIGxpbmVIZWlnaHQ6IDEuNSxcbiAgd2hpdGVTcGFjZTogJ25vd3JhcCcsXG5cbiAgW21lZGlhUXVlcmllcygndGFibGV0JyldOiB7XG4gICAgZm9udFNpemU6IDEyLFxuICB9LFxufSk7XG5cbmNvbnN0IHN0eWxlSW50ZWdyYXRlZEhlYWRlckRpdmlkZXIgPSBjc3Moe1xuICB3aWR0aDogMSxcbiAgaGVpZ2h0OiAxMixcbiAgYmFja2dyb3VuZENvbG9yOiBDT0xPUl9QQUxFVFRFLmdyYXlbM10sXG59KTtcbiJdfQ== */"), nA = ({
  styles: g
}) => /* @__PURE__ */ W(w, { component: "header", id: Wa.HEADER_INTEGRATED, css: [Ra, g == null ? void 0 : g.root, process.env.NODE_ENV === "production" ? "" : ";label:IntegratedHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9jb21wb25lbnRzL25leHQvU2tlbGV0b24vSW50ZWdyYXRlZEhlYWRlclNrZWxldG9uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF3QkkiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvZmUtc2hhcmVkL2ZlLXNoYXJlZC9wYWNrYWdlcy9hcHAtc2hlbGwvc3JjL2NvbXBvbmVudHMvbmV4dC9Ta2VsZXRvbi9JbnRlZ3JhdGVkSGVhZGVyU2tlbGV0b24udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHR5cGUgeyBJbnRlcnBvbGF0aW9uLCBUaGVtZSB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IEJveCB9IGZyb20gJ0BpbmZsZWFybi9kcy1yZWFjdCc7XG5cbmltcG9ydCB7XG4gIEludGVncmF0ZWRIZWFkZXJMaW5rcyxcbiAgc3R5bGVJbnRlZ3JhdGVkSGVhZGVyUm9vdCxcbn0gZnJvbSAnLi4vSGVhZGVyL2NvbXBvbmVudHMvaW50ZWdyYXRlZEhlYWRlckNvbnRlbnQnO1xuaW1wb3J0IHsgSEVBREVSX0VMRU1FTlRfSURTIH0gZnJvbSAnLi4vSGVhZGVyL3N0eWxlcyc7XG5cbi8qKlxuICog7Ya17ZWpIO2XpOuNlOydmCBTU1IvU3VzcGVuc2Ug7Iqk7LyI66CI7YakLlxuICog7ZWY7J2065Oc66CI7J207IWYIOyghOydtOudvCBLb09ubHkg66W8IOyTuCDsiJgg7JeG7Ja07IScIOuFuOy2nCDtjJDri6jsnYAg7Zi47Lac67aA7JeQIOunoeq4tOuLpC5cbiAqL1xuZXhwb3J0IGNvbnN0IEludGVncmF0ZWRIZWFkZXJTa2VsZXRvbiA9ICh7XG4gIHN0eWxlcyxcbn06IHtcbiAgc3R5bGVzPzoge1xuICAgIHJvb3Q/OiBJbnRlcnBvbGF0aW9uPFRoZW1lPjtcbiAgICBjb250YWluZXI/OiBJbnRlcnBvbGF0aW9uPFRoZW1lPjtcbiAgfTtcbn0pID0+IChcbiAgPEJveFxuICAgIGNvbXBvbmVudD1cImhlYWRlclwiXG4gICAgaWQ9e0hFQURFUl9FTEVNRU5UX0lEUy5IRUFERVJfSU5URUdSQVRFRH1cbiAgICBjc3M9e1tzdHlsZUludGVncmF0ZWRIZWFkZXJSb290LCBzdHlsZXM/LnJvb3RdfT5cbiAgICA8SW50ZWdyYXRlZEhlYWRlckxpbmtzIGNvbnRhaW5lclN0eWxlcz17c3R5bGVzPy5jb250YWluZXJ9IC8+XG4gIDwvQm94PlxuKTtcbiJdfQ== */"], children: /* @__PURE__ */ W(Na, { containerStyles: g == null ? void 0 : g.container }) });
var Ke = {}, MI = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "fas", c = "globe", e = 512, l = 512, i = [127760], t = "f0ac", n = "M352 256c0 22.2-1.2 43.6-3.3 64H163.3c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64H348.7c2.2 20.4 3.3 41.8 3.3 64zm28.8-64H503.9c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0H167.7c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7zm-209 0H18.6C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192H131.2c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64H8.1C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.6-26-20.9-58.2-27-94.6H344.3c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352H135.3zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6H493.4z";
  g.definition = {
    prefix: I,
    iconName: c,
    icon: [
      e,
      l,
      i,
      t,
      n
    ]
  }, g.faGlobe = g.definition, g.prefix = I, g.iconName = c, g.width = e, g.height = l, g.ligatures = i, g.unicode = t, g.svgPathData = n, g.aliases = i;
})(MI);
var _e = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "fas", c = "grid", e = 448, l = 512, i = ["grid-3"], t = "e195", n = "M0 72C0 49.9 17.9 32 40 32H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V72zM0 232c0-22.1 17.9-40 40-40H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V232zM128 392v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40H88c22.1 0 40 17.9 40 40zM160 72c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V72zM288 232v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V232c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40zM160 392c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V392zM448 72v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V72c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40zM320 232c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V232zM448 392v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40z";
  g.definition = {
    prefix: I,
    iconName: c,
    icon: [
      e,
      l,
      i,
      t,
      n
    ]
  }, g.faGrid = g.definition, g.prefix = I, g.iconName = c, g.width = e, g.height = l, g.ligatures = i, g.unicode = t, g.svgPathData = n, g.aliases = i;
})(_e);
const ya = (g) => {
  const I = SI(g);
  I.current = g, eg(() => {
    let c = window.location.href;
    const e = () => {
      c = window.location.href, I.current();
    };
    function l() {
      const t = window.location.href;
      c !== t && (c = t, e());
    }
    window.addEventListener("popstate", e);
    const i = setInterval(l, 100);
    return () => {
      window.removeEventListener("popstate", e), clearInterval(i);
    };
  }, []);
}, bA = {
  COURSES: "COURSES",
  CHALLENGES: "CHALLENGES",
  MENTORING: "MENTORING",
  CLIPS: "CLIPS",
  ROADMAPS: "ROADMAPS",
  COMMUNITY: "COMMUNITY"
}, KI = 285, va = 25 * 3, GI = {
  COURSES: {
    icon: "course",
    text: "강의",
    href: Q.COURSES()
  },
  CHALLENGES: {
    icon: "challenge",
    text: "챌린지",
    href: Q.CHALLENGES
  },
  MENTORING: {
    icon: "mentoring",
    text: "멘토링",
    href: Q.MENTORS
  },
  ROADMAPS: {
    icon: "roadmap",
    text: "로드맵",
    href: Q.ROADMAPS
  },
  COMMUNITY: {
    icon: "community",
    text: "커뮤니티",
    href: Q.COMMUNITY
  },
  CLIPS: {
    icon: "clip",
    text: "클립",
    href: Q.CLIPS
  }
}, qe = {
  // 검색바 내부 요소들
  SEARCH_MENU_DROPDOWN: 1,
  // 메뉴 드롭다운
  SEARCH_INPUT: 2,
  // 검색 입력 필드
  EXPLORE_ITEM: 2,
  // 검색 입력 필드의 둘러보기 아이템
  SEARCH_BUTTON: 3,
  // 검색 버튼
  // 메인 GNB 요소들
  BRAND_LOGO: 10,
  // 브랜드 로고
  MENU_LIST: 20,
  // 메뉴 리스트
  // 플로팅 버튼들
  MOVE_TOP: 30,
  // 맨 위로 이동 버튼
  // 제외할 요소들
  HIDDEN: -1
  // 탭 포커스에서 제외
};
function _I() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Ba = process.env.NODE_ENV === "production" ? {
  name: "1bmnxg7",
  styles: "white-space:nowrap"
} : {
  name: "1hwwzz7-menuLabel",
  styles: "white-space:nowrap;label:menuLabel;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _I
}, Fa = process.env.NODE_ENV === "production" ? {
  name: "1j389vi",
  styles: "font-weight:700"
} : {
  name: "l85uma-MenuItemWithIcon",
  styles: "font-weight:700;label:MenuItemWithIcon;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _I
};
const Ya = ({
  type: g,
  label: I,
  showIndicator: c = !1,
  onClick: e,
  skeletonType: l
}) => {
  const i = /* @__PURE__ */ W(v, { w: 32, h: 32, align: "center", position: "center", children: /* @__PURE__ */ W(qc, { src: `${EI}/assets/images/header/${GI[g].icon}.png`, alt: GI[g].text, w: va, width: 32, height: 32 }) }), t = /* @__PURE__ */ W(za, { type: g, isSkeleton: !!l, children: /* @__PURE__ */ W(BI, { size: 16, color: "gray.9", fw: 700, className: l ? `class-label-${l.toLowerCase()}` : "", css: Ba, children: !l && I }) });
  return /* @__PURE__ */ W(FI, { h: 44, py: 6, px: 10, href: g ? GI[g].href : void 0, tabIndex: qe.MENU_LIST, display: "flex", css: /* @__PURE__ */ S({
    flexShrink: 0,
    "&:hover": {
      textDecoration: "none",
      borderRadius: 50,
      backgroundColor: yg.gray[0]
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:MenuItemWithIcon;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), onClick: e, children: c ? /* @__PURE__ */ W(bl, { size: 16, radius: "xl", label: "N", position: "top-end", color: "red", offset: 3, inline: !0, children: /* @__PURE__ */ z(v, { align: "center", spacing: 4, noWrap: !0, children: [
    i,
    t
  ] }) }) : /* @__PURE__ */ z(v, { align: "center", spacing: 4, css: Fa, noWrap: !0, children: [
    i,
    t
  ] }) });
};
var fa = process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "1y6y0da-MenuListActiveWrapper",
  styles: "position:relative;label:MenuListActiveWrapper;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _I
};
const za = ({
  type: g,
  children: I,
  isSkeleton: c = !1
}) => {
  const [e, l] = zI(() => c ? !1 : Nc(g)), i = Ug(() => {
    if (c)
      return;
    const t = Nc(g);
    l(t);
  }, [g, c]);
  return ya(i), /* @__PURE__ */ z(w, { css: fa, children: [
    I,
    e && /* @__PURE__ */ W(w, { w: "100%", h: 3, css: /* @__PURE__ */ S({
      position: "absolute",
      bottom: -2,
      left: "50%",
      transform: "translateX(-50%)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:MenuListActiveWrapper;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: /* @__PURE__ */ W(w, { w: "100%", h: 2, css: /* @__PURE__ */ S({
      borderRadius: 8,
      backgroundColor: yg.infgreen[7]
    }, process.env.NODE_ENV === "production" ? "" : ";label:MenuListActiveWrapper;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */") }) })
  ] });
}, kc = 20, Qc = 4, Mc = 10, Sa = (g) => g ? 58 : 46, Ta = ({
  showMenuList: g,
  isAntMan: I
}) => /* @__PURE__ */ S({
  width: 520,
  zIndex: QI(I).HEADER,
  position: "absolute",
  paddingTop: kc,
  top: g ? "auto" : 28,
  height: g ? `calc(58px + ${kc}px)` : "auto",
  transform: "translateX(-50%)",
  left: "50%",
  transition: "top 0.2s ease-out, padding-top 0.2s ease-out, height 0.2s ease-out",
  [U("tablet")]: {
    display: "none"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:styleAppShellSearchBarWrapper;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), $e = ({
  showMenuList: g,
  isFocused: I,
  isMobile: c
}) => /* @__PURE__ */ S({
  width: c ? "100%" : g ? 518 : 420,
  height: Sa(g),
  paddingLeft: g ? 8 : 7,
  paddingRight: g ? 8 : 7,
  transition: "width 0.2s ease-out, height 0.2s ease-out, border-radius 0.2s ease-out, border 0.2s ease-out, box-shadow 0.2s ease-out",
  borderRadius: 50,
  border: `1px solid ${yg.gray[I ? 9 : 3]}`,
  backgroundColor: "white",
  boxShadow: !c && I ? "0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 36px 28px -7px rgba(0, 0, 0, 0.05), 0 17px 17px -7px rgba(0, 0, 0, 0.04)" : "none"
}, process.env.NODE_ENV === "production" ? "" : ";label:styleAppShellSearchBarInnerWrapper;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), Ha = ({
  showMenuList: g
}) => /* @__PURE__ */ S({
  display: "none",
  zIndex: QI(!0).HEADER,
  top: g ? "auto" : 12,
  height: "auto",
  backgroundColor: "white",
  transition: "top 0.2s ease-out, padding-top 0.2s ease-out, height 0.2s ease-out",
  [U("tablet")]: {
    display: "flex",
    margin: "0 -32px",
    padding: `${Qc}px 32px ${Mc}px`
  },
  [U("mobile")]: {
    margin: "0 -16px",
    padding: `${Qc}px 16px ${Mc}px`
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:styleAppShellSearchBarMobileWrapper;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), gl = YI({
  profile: void 0,
  isLoading: !1
}), CA = ({
  children: g
}) => {
  const {
    data: I,
    isLoading: c,
    error: e
  } = rC();
  GC(e);
  const l = Lg(() => ({
    profile: I ? {
      ...I,
      isB2b: JI(I),
      isGroupManager: bC(I),
      isGroupUser: nC(I),
      isPartner: CC(I)
    } : void 0,
    isLoading: c
  }), [I, c]);
  return /* @__PURE__ */ W(gl.Provider, { value: l, children: g });
}, wa = () => {
  const g = fI(gl);
  if (!g)
    throw new Error("useProfileContext must be used within a ProfileProvider");
  return g;
};
function Il() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const Ua = `${EI}/assets/images/header/inflearn_logo_business.svg`, La = `${EI}/assets/brand/logo.png?t=1`, Kc = 48, _c = 42, aA = ({
  isMobile: g = !1
}) => {
  var C;
  const {
    getSnapshot: I,
    setSnapshot: c
  } = tC(), {
    trackEvent: e
  } = Xa(), {
    profile: l
  } = wa(), t = (l == null ? void 0 : l.isB2b) ? ((C = l == null ? void 0 : l.group) == null ? void 0 : C.logoUrl) ?? Ua : La, n = I();
  return eg(() => {
    (!n || n.logo !== t) && c({
      logo: t
    });
  }, [t, c, I, n]), /* @__PURE__ */ W(Ea, { url: t, onClick: () => {
    e(mC.CLICK_LOGO_AT_HEADER);
  }, isMobile: g });
}, qI = ({
  onClick: g,
  children: I
}) => {
  const {
    t: c
  } = ve();
  return /* @__PURE__ */ W(FI, { href: Q.MAIN, "aria-label": c("인프런 메인 페이지로 이동"), tabIndex: qe.BRAND_LOGO, css: ja, onClick: g, children: I });
};
var Oa = process.env.NODE_ENV === "production" ? {
  name: "1qesdsb",
  styles: "background-color:white"
} : {
  name: "uzjx03-HeaderBrandLogoImage",
  styles: "background-color:white;label:HeaderBrandLogoImage;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: Il
};
const Ea = ({
  url: g,
  onClick: I,
  isMobile: c
}) => {
  const [e, l] = zI(!1);
  return /* @__PURE__ */ W($g, { pos: "relative", children: /* @__PURE__ */ z(qI, { onClick: I, children: [
    /* @__PURE__ */ W($c, { h: c ? _c : Kc, children: /* @__PURE__ */ W(qc, { w: 201, height: c ? _c : Kc, src: g, alt: "inflearn logo", onLoad: () => {
      l(!0);
    } }) }),
    !e && /* @__PURE__ */ W(w, { pos: "absolute", top: 0, left: 0, w: "auto", h: "auto", css: Oa, children: /* @__PURE__ */ W(w, { className: "class-logo" }) })
  ] }) });
}, ja = process.env.NODE_ENV === "production" ? {
  name: "1eingpo",
  styles: "display:flex;height:100%;align-items:center;& picture{display:flex;width:100%;height:100%;}"
} : {
  name: "1qgh1ec-styleHeaderBrandLogo",
  styles: "display:flex;height:100%;align-items:center;& picture{display:flex;width:100%;height:100%;};label:styleHeaderBrandLogo;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: Il
};
function Da() {
  return /* @__PURE__ */ W(v, { w: KI, mt: -4, children: /* @__PURE__ */ W(v, { className: "class-show-logo", children: /* @__PURE__ */ W(qI, { children: /* @__PURE__ */ W(w, { className: "class-logo" }) }) }) });
}
function Pa() {
  return /* @__PURE__ */ W(v, { w: KI, mt: -4, children: /* @__PURE__ */ W(v, { className: "class-show-logo", children: /* @__PURE__ */ W(qI, { children: /* @__PURE__ */ W(w, { className: "class-logo" }) }) }) });
}
function bI() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function sA({
  styles: g,
  isAntMan: I,
  showLanguageSectionButton: c = !0
}) {
  var e, l, i, t;
  return /* @__PURE__ */ W($c, { component: "header", className: "class-show-search-bar-header", css: [/* @__PURE__ */ S({
    position: "sticky",
    top: 0,
    left: 0,
    right: 0,
    width: "100%",
    backgroundColor: "#fff",
    zIndex: QI(I).HEADER,
    alignItems: "flex-start",
    justifyContent: "center",
    [U("tablet")]: {
      height: 50
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:StickyHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), (e = g == null ? void 0 : g.header) == null ? void 0 : e.root, process.env.NODE_ENV === "production" ? "" : ";label:StickyHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: /* @__PURE__ */ z(v, { css: [ha, es, (l = g == null ? void 0 : g.header) == null ? void 0 : l.container, process.env.NODE_ENV === "production" ? "" : ";label:StickyHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: [
    /* @__PURE__ */ W(Qa, { styles: (i = g == null ? void 0 : g.header) == null ? void 0 : i.desktop, isAntMan: I, showLanguageSectionButton: c }),
    /* @__PURE__ */ W(gs, { styles: (t = g == null ? void 0 : g.header) == null ? void 0 : t.mobile, showLanguageSectionButton: c })
  ] }) });
}
var ka = process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "1gwiwrs-DesktopHeaderSkeleton",
  styles: "position:relative;label:DesktopHeaderSkeleton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: bI
};
const Qa = ({
  styles: g,
  isAntMan: I,
  showLanguageSectionButton: c
}) => /* @__PURE__ */ W($g, { justify: "start", align: "center", w: "100%", className: "class-show-search-bar-wrapper", css: /* @__PURE__ */ S({
  backgroundColor: "white",
  [U("tablet")]: {
    height: "auto"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:DesktopHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: /* @__PURE__ */ z(v, { position: "apart", align: "center", spacing: 0, w: "100%", h: Me, noWrap: !0, css: [/* @__PURE__ */ S({
  [U("tablet")]: {
    display: "none"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:DesktopHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), g == null ? void 0 : g.root, process.env.NODE_ENV === "production" ? "" : ";label:DesktopHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: [
  /* @__PURE__ */ W(Da, {}),
  /* @__PURE__ */ z(w, { css: ka, children: [
    /* @__PURE__ */ W(qa, {}),
    /* @__PURE__ */ W(_a, { isAntMan: I })
  ] }),
  /* @__PURE__ */ W(Ma, { showLanguageSectionButton: c })
] }) }), Ma = ({
  showLanguageSectionButton: g
}) => /* @__PURE__ */ z(v, { w: KI, spacing: 10, position: "right", children: [
  /* @__PURE__ */ W(xg, { variant: "light", size: "n-md", color: "gray", radius: "xl", disabled: !0, children: /* @__PURE__ */ W(mg, { icon: _e.faGrid }) }),
  g && /* @__PURE__ */ W(xg, { variant: "light", size: "n-md", color: "gray", radius: "xl", disabled: !0, children: /* @__PURE__ */ W(mg, { icon: MI.faGlobe }) }),
  /* @__PURE__ */ W(ge, { width: 92, height: 42, radius: "xl" })
] });
var Ka = process.env.NODE_ENV === "production" ? {
  name: "82a6rk",
  styles: "flex:1"
} : {
  name: "184j5yn-SearchBarSkeleton",
  styles: "flex:1;label:SearchBarSkeleton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9jb21wb25lbnRzL25leHQvSGVhZGVyL1N0aWNreUhlYWRlclNrZWxldG9uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUErSlciLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvZmUtc2hhcmVkL2ZlLXNoYXJlZC9wYWNrYWdlcy9hcHAtc2hlbGwvc3JjL2NvbXBvbmVudHMvbmV4dC9IZWFkZXIvU3RpY2t5SGVhZGVyU2tlbGV0b24udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHR5cGUgeyBJbnRlcnBvbGF0aW9uLCBUaGVtZSB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IEFjdGlvbkljb24sIEJveCwgRmxleCwgR3JvdXAsIEljb24sIFNrZWxldG9uLCBTdGFjayB9IGZyb20gJ0BpbmZsZWFybi9kcy1yZWFjdCc7XG5pbXBvcnQgeyBzb2xpZCB9IGZyb20gJ0BpbmZsZWFybi9mb250YXdlc29tZS1zdmctY29yZS9pbXBvcnQubWFjcm8nO1xuXG5pbXBvcnQgeyBNZW51SXRlbVdpdGhJY29uIH0gZnJvbSAnLi9jb21wb25lbnRzL01lbnVJdGVtV2l0aEljb24nO1xuaW1wb3J0IHR5cGUgeyBNRU5VX0lURU1TIH0gZnJvbSAnLi9jb25zdGFudHMvbWVudUl0ZW1zJztcbmltcG9ydCB7IEdOQl9TSURFX1dJRFRIIH0gZnJvbSAnLi9jb25zdGFudHMvbWVudUl0ZW1zJztcbmltcG9ydCB7IEhFQURFUl9IRUlHSFQsIHN0eWxlSGVhZGVyQ29udGVudCB9IGZyb20gJy4vc3R5bGVzJztcbmltcG9ydCB7IGdldFpJbmRleCwgbWVkaWFRdWVyaWVzIH0gZnJvbSAnLi4vLi4vLi4vc3R5bGVzJztcbmltcG9ydCB7XG4gIHN0eWxlQXBwU2hlbGxTZWFyY2hCYXJJbm5lcldyYXBwZXIsXG4gIHN0eWxlQXBwU2hlbGxTZWFyY2hCYXJNb2JpbGVXcmFwcGVyLFxuICBzdHlsZUFwcFNoZWxsU2VhcmNoQmFyV3JhcHBlcixcbn0gZnJvbSAnLi4vU2VhcmNoQmFyL3NlYXJjaEJhclN0eWxlcyc7XG5pbXBvcnQge1xuICBIZWFkZXJCcmFuZExvZ29Ta2VsZXRvbixcbiAgSGVhZGVyQnJhbmRMb2dvU2tlbGV0b25Nb2JpbGUsXG59IGZyb20gJy4uL1NrZWxldG9uL0hlYWRlckJyYW5kTG9nb1NrZWxldG9uJztcblxudHlwZSBTdGlja3lIZWFkZXJTa2VsZXRvblByb3BzID0ge1xuICBpc0FudE1hbjogYm9vbGVhbjtcbiAgLyoqXG4gICAqIOyLpOygnCDtl6TrjZQoUmlnaHRTZWN0aW9uKeyZgCDqsJnsnYAg7KGw6rG07Jy866GcIOyWuOyWtCDrsoTtirwg7J6Q66as66W8IOyeoeyVhOyVvCDtlZzri6QuXG4gICAqIO2YuOyKpO2KuOqwgCBTa2VsZXRvbkhlYWRlciDrpbwg7KeB7KCRIOyTsOuKlCDqsr3smrDrpbwg7JyE7ZW0IOq4sOuzuOqwkuydgCDrhbjstpwodHJ1ZSkuXG4gICAqL1xuICBzaG93TGFuZ3VhZ2VTZWN0aW9uQnV0dG9uPzogYm9vbGVhbjtcbiAgc3R5bGVzPzoge1xuICAgIGhlYWRlcj86IHtcbiAgICAgIHJvb3Q/OiBJbnRlcnBvbGF0aW9uPFRoZW1lPjtcbiAgICAgIGNvbnRhaW5lcj86IEludGVycG9sYXRpb248VGhlbWU+O1xuICAgICAgbW9iaWxlPzoge1xuICAgICAgICByb290PzogSW50ZXJwb2xhdGlvbjxUaGVtZT47XG4gICAgICB9O1xuICAgICAgZGVza3RvcD86IHtcbiAgICAgICAgcm9vdD86IEludGVycG9sYXRpb248VGhlbWU+O1xuICAgICAgfTtcbiAgICB9O1xuICB9O1xufTtcblxuZXhwb3J0IGZ1bmN0aW9uIFN0aWNreUhlYWRlclNrZWxldG9uKHtcbiAgc3R5bGVzLFxuICBpc0FudE1hbixcbiAgc2hvd0xhbmd1YWdlU2VjdGlvbkJ1dHRvbiA9IHRydWUsXG59OiBTdGlja3lIZWFkZXJTa2VsZXRvblByb3BzKSB7XG4gIHJldHVybiAoXG4gICAgPEZsZXg8J2hlYWRlcic+XG4gICAgICBjb21wb25lbnQ9XCJoZWFkZXJcIlxuICAgICAgY2xhc3NOYW1lPVwiY2xhc3Mtc2hvdy1zZWFyY2gtYmFyLWhlYWRlclwiXG4gICAgICBjc3M9e1tcbiAgICAgICAgY3NzKHtcbiAgICAgICAgICBwb3NpdGlvbjogJ3N0aWNreScsXG4gICAgICAgICAgdG9wOiAwLFxuICAgICAgICAgIGxlZnQ6IDAsXG4gICAgICAgICAgcmlnaHQ6IDAsXG4gICAgICAgICAgd2lkdGg6ICcxMDAlJyxcbiAgICAgICAgICBiYWNrZ3JvdW5kQ29sb3I6ICcjZmZmJyxcbiAgICAgICAgICB6SW5kZXg6IGdldFpJbmRleChpc0FudE1hbikuSEVBREVSLFxuICAgICAgICAgIGFsaWduSXRlbXM6ICdmbGV4LXN0YXJ0JyxcbiAgICAgICAgICBqdXN0aWZ5Q29udGVudDogJ2NlbnRlcicsXG5cbiAgICAgICAgICBbbWVkaWFRdWVyaWVzKCd0YWJsZXQnKV06IHtcbiAgICAgICAgICAgIGhlaWdodDogNTAsXG4gICAgICAgICAgfSxcbiAgICAgICAgfSksXG4gICAgICAgIHN0eWxlcz8uaGVhZGVyPy5yb290LFxuICAgICAgXX0+XG4gICAgICA8R3JvdXA8J2Rpdic+XG4gICAgICAgIGNzcz17W3N0eWxlSGVhZGVyQ29udGVudCwgc3R5bGVIZWFkZXJDb250YWluZXJJbm5lciwgc3R5bGVzPy5oZWFkZXI/LmNvbnRhaW5lcl19PlxuICAgICAgICA8RGVza3RvcEhlYWRlclNrZWxldG9uXG4gICAgICAgICAgc3R5bGVzPXtzdHlsZXM/LmhlYWRlcj8uZGVza3RvcH1cbiAgICAgICAgICBpc0FudE1hbj17aXNBbnRNYW59XG4gICAgICAgICAgc2hvd0xhbmd1YWdlU2VjdGlvbkJ1dHRvbj17c2hvd0xhbmd1YWdlU2VjdGlvbkJ1dHRvbn1cbiAgICAgICAgLz5cbiAgICAgICAgPE1vYmlsZUhlYWRlclNrZWxldG9uXG4gICAgICAgICAgc3R5bGVzPXtzdHlsZXM/LmhlYWRlcj8ubW9iaWxlfVxuICAgICAgICAgIHNob3dMYW5ndWFnZVNlY3Rpb25CdXR0b249e3Nob3dMYW5ndWFnZVNlY3Rpb25CdXR0b259XG4gICAgICAgIC8+XG4gICAgICA8L0dyb3VwPlxuICAgIDwvRmxleD5cbiAgKTtcbn1cblxuY29uc3QgRGVza3RvcEhlYWRlclNrZWxldG9uID0gKHtcbiAgc3R5bGVzLFxuICBpc0FudE1hbixcbiAgc2hvd0xhbmd1YWdlU2VjdGlvbkJ1dHRvbixcbn06IHtcbiAgc3R5bGVzPzoge1xuICAgIHJvb3Q/OiBJbnRlcnBvbGF0aW9uPFRoZW1lPjtcbiAgfTtcbiAgaXNBbnRNYW46IGJvb2xlYW47XG4gIHNob3dMYW5ndWFnZVNlY3Rpb25CdXR0b246IGJvb2xlYW47XG59KSA9PiAoXG4gIDxTdGFja1xuICAgIGp1c3RpZnk9XCJzdGFydFwiXG4gICAgYWxpZ249XCJjZW50ZXJcIlxuICAgIHc9XCIxMDAlXCJcbiAgICBjbGFzc05hbWU9XCJjbGFzcy1zaG93LXNlYXJjaC1iYXItd3JhcHBlclwiXG4gICAgY3NzPXt7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6ICd3aGl0ZScsXG4gICAgICBbbWVkaWFRdWVyaWVzKCd0YWJsZXQnKV06IHtcbiAgICAgICAgaGVpZ2h0OiAnYXV0bycsXG4gICAgICB9LFxuICAgIH19PlxuICAgIDxHcm91cDwnZGl2Jz5cbiAgICAgIHBvc2l0aW9uPVwiYXBhcnRcIlxuICAgICAgYWxpZ249XCJjZW50ZXJcIlxuICAgICAgc3BhY2luZz17MH1cbiAgICAgIHc9XCIxMDAlXCJcbiAgICAgIGg9e0hFQURFUl9IRUlHSFR9XG4gICAgICBub1dyYXBcbiAgICAgIGNzcz17W1xuICAgICAgICBjc3Moe1xuICAgICAgICAgIFttZWRpYVF1ZXJpZXMoJ3RhYmxldCcpXToge1xuICAgICAgICAgICAgZGlzcGxheTogJ25vbmUnLFxuICAgICAgICAgIH0sXG4gICAgICAgIH0pLFxuICAgICAgICBzdHlsZXM/LnJvb3QsXG4gICAgICBdfT5cbiAgICAgIDxIZWFkZXJCcmFuZExvZ29Ta2VsZXRvbiAvPlxuICAgICAgPEJveCBjc3M9e3sgcG9zaXRpb246ICdyZWxhdGl2ZScgfX0+XG4gICAgICAgIDxNZW51TGlzdFNrZWxldG9uIC8+XG4gICAgICAgIDxTZWFyY2hCYXJTa2VsZXRvbiBpc0FudE1hbj17aXNBbnRNYW59IC8+XG4gICAgICA8L0JveD5cbiAgICAgIDxSaWdodFNlY3Rpb25Ta2VsZXRvbiBzaG93TGFuZ3VhZ2VTZWN0aW9uQnV0dG9uPXtzaG93TGFuZ3VhZ2VTZWN0aW9uQnV0dG9ufSAvPlxuICAgIDwvR3JvdXA+XG4gIDwvU3RhY2s+XG4pO1xuXG5jb25zdCBSaWdodFNlY3Rpb25Ta2VsZXRvbiA9ICh7XG4gIHNob3dMYW5ndWFnZVNlY3Rpb25CdXR0b24sXG59OiB7XG4gIHNob3dMYW5ndWFnZVNlY3Rpb25CdXR0b246IGJvb2xlYW47XG59KSA9PiAoXG4gIDxHcm91cDwnZGl2Jz4gdz17R05CX1NJREVfV0lEVEh9IHNwYWNpbmc9ezEwfSBwb3NpdGlvbj1cInJpZ2h0XCI+XG4gICAgPEFjdGlvbkljb24gdmFyaWFudD1cImxpZ2h0XCIgc2l6ZT1cIm4tbWRcIiBjb2xvcj1cImdyYXlcIiByYWRpdXM9XCJ4bFwiIGRpc2FibGVkPlxuICAgICAgPEljb24gaWNvbj17c29saWQoJ2dyaWQnKX0gLz5cbiAgICA8L0FjdGlvbkljb24+XG4gICAge3Nob3dMYW5ndWFnZVNlY3Rpb25CdXR0b24gJiYgKFxuICAgICAgPEFjdGlvbkljb24gdmFyaWFudD1cImxpZ2h0XCIgc2l6ZT1cIm4tbWRcIiBjb2xvcj1cImdyYXlcIiByYWRpdXM9XCJ4bFwiIGRpc2FibGVkPlxuICAgICAgICA8SWNvbiBpY29uPXtzb2xpZCgnZ2xvYmUnKX0gLz5cbiAgICAgIDwvQWN0aW9uSWNvbj5cbiAgICApfVxuICAgIDxTa2VsZXRvbiB3aWR0aD17OTJ9IGhlaWdodD17NDJ9IHJhZGl1cz1cInhsXCIgLz5cbiAgPC9Hcm91cD5cbik7XG5cbmNvbnN0IFNlYXJjaEJhclNrZWxldG9uID0gKHsgaXNBbnRNYW4gfTogeyBpc0FudE1hbjogYm9vbGVhbiB9KSA9PiAoXG4gIDxHcm91cDwnZGl2Jz5cbiAgICBjbGFzc05hbWU9XCJjbGFzcy1zaG93LXNlYXJjaC1iYXJcIlxuICAgIGNzcz17c3R5bGVBcHBTaGVsbFNlYXJjaEJhcldyYXBwZXIoeyBzaG93TWVudUxpc3Q6IHRydWUsIGlzQW50TWFuIH0pfT5cbiAgICA8R3JvdXA8J2Rpdic+XG4gICAgICBjc3M9e3N0eWxlQXBwU2hlbGxTZWFyY2hCYXJJbm5lcldyYXBwZXIoe1xuICAgICAgICBzaG93TWVudUxpc3Q6IHRydWUsXG4gICAgICAgIGlzRm9jdXNlZDogZmFsc2UsXG4gICAgICAgIGlzTW9iaWxlOiBmYWxzZSxcbiAgICAgIH0pfT5cbiAgICAgIDxCb3ggY3NzPXt7IGZsZXg6IDEgfX0+PC9Cb3g+XG4gICAgICA8QWN0aW9uSWNvbiB0eXBlPVwic3VibWl0XCIgc2l6ZT1cIm4tbWRcIiB2YXJpYW50PVwiZmlsbGVkXCIgY29sb3I9XCJpbmZncmVlblwiIHJhZGl1cz17OTk5fSBkaXNhYmxlZD5cbiAgICAgICAgPEljb24gaWNvbj17c29saWQoJ3NlYXJjaCcpfSBzaXplPVwibWRcIiAvPlxuICAgICAgPC9BY3Rpb25JY29uPlxuICAgIDwvR3JvdXA+XG4gIDwvR3JvdXA+XG4pO1xuXG5jb25zdCBNZW51TGlzdFNrZWxldG9uID0gKCkgPT4gKFxuICA8R3JvdXA8J2Rpdic+IGg9ezQ0fT5cbiAgICA8R3JvdXA8J2Rpdic+IHNwYWNpbmc9ezEwfSBjbGFzc05hbWU9XCJjbGFzcy1zaG93LW1lbnUtbGlzdFwiIG5vV3JhcD5cbiAgICAgIDxNZW51SXRlbVdpdGhJY29uU2tlbGV0b24gdHlwZT1cIkNPVVJTRVNcIiAvPlxuICAgICAgPE1lbnVJdGVtV2l0aEljb25Ta2VsZXRvbiB0eXBlPVwiQ0hBTExFTkdFU1wiIHNob3dJbmRpY2F0b3IgLz5cbiAgICAgIDxNZW51SXRlbVdpdGhJY29uU2tlbGV0b24gdHlwZT1cIk1FTlRPUklOR1wiIC8+XG4gICAgICA8TWVudUl0ZW1XaXRoSWNvblNrZWxldG9uIHR5cGU9XCJDTElQU1wiIHNob3dJbmRpY2F0b3IgLz5cbiAgICAgIDxNZW51SXRlbVdpdGhJY29uU2tlbGV0b24gdHlwZT1cIlJPQURNQVBTXCIgLz5cbiAgICA8L0dyb3VwPlxuICA8L0dyb3VwPlxuKTtcblxuY29uc3QgTWVudUl0ZW1XaXRoSWNvblNrZWxldG9uID0gKHtcbiAgdHlwZSxcbiAgc2hvd0luZGljYXRvciA9IGZhbHNlLFxufToge1xuICB0eXBlOiBrZXlvZiB0eXBlb2YgTUVOVV9JVEVNUztcbiAgc2hvd0luZGljYXRvcj86IGJvb2xlYW47XG59KSA9PiAoXG4gIDxTdGFjayBqdXN0aWZ5PVwiY2VudGVyXCIgY2xhc3NOYW1lPXtgY2xhc3Mtc2hvdy1tZW51LSR7dHlwZS50b0xvd2VyQ2FzZSgpfWB9PlxuICAgIDxNZW51SXRlbVdpdGhJY29uIHR5cGU9e3R5cGV9IHNrZWxldG9uVHlwZT17dHlwZX0gc2hvd0luZGljYXRvcj17c2hvd0luZGljYXRvcn0gLz5cbiAgPC9TdGFjaz5cbik7XG5cbnR5cGUgTW9iaWxlSGVhZGVyU2tlbGV0b25Qcm9wcyA9IHtcbiAgc3R5bGVzPzoge1xuICAgIHJvb3Q/OiBJbnRlcnBvbGF0aW9uPFRoZW1lPjtcbiAgfTtcbiAgc2hvd0xhbmd1YWdlU2VjdGlvbkJ1dHRvbjogYm9vbGVhbjtcbn07XG5cbmNvbnN0IE1vYmlsZUhlYWRlclNrZWxldG9uID0gKHsgc3R5bGVzLCBzaG93TGFuZ3VhZ2VTZWN0aW9uQnV0dG9uIH06IE1vYmlsZUhlYWRlclNrZWxldG9uUHJvcHMpID0+IChcbiAgPFN0YWNrXG4gICAgdz1cIjEwMCVcIlxuICAgIHNwYWNpbmc9ezB9XG4gICAgY3NzPXt7XG4gICAgICBkaXNwbGF5OiAnbm9uZScsXG4gICAgICBbbWVkaWFRdWVyaWVzKCd0YWJsZXQnKV06IHtcbiAgICAgICAgZGlzcGxheTogJ2ZsZXgnLFxuICAgICAgfSxcbiAgICB9fT5cbiAgICA8R3JvdXA8J2Rpdic+IHc9XCIxMDAlXCIgaD17NTB9IGNzcz17W3N0eWxlcz8ucm9vdF19PlxuICAgICAgPEhlYWRlckJyYW5kTG9nb1NrZWxldG9uTW9iaWxlIC8+XG4gICAgICA8R3JvdXA8J2Rpdic+IHBvc2l0aW9uPVwicmlnaHRcIiBzcGFjaW5nPXs4fSBtbD17MTB9IG5vV3JhcCBjc3M9e3sgZmxleDogMSB9fT5cbiAgICAgICAge3Nob3dMYW5ndWFnZVNlY3Rpb25CdXR0b24gJiYgKFxuICAgICAgICAgIDxBY3Rpb25JY29uIHZhcmlhbnQ9XCJsaWdodFwiIHNpemU9XCJuLXNtXCIgY29sb3I9XCJncmF5XCIgcmFkaXVzPVwieGxcIiBkaXNhYmxlZD5cbiAgICAgICAgICAgIDxJY29uIGljb249e3NvbGlkKCdnbG9iZScpfSAvPlxuICAgICAgICAgIDwvQWN0aW9uSWNvbj5cbiAgICAgICAgKX1cbiAgICAgICAgPFNrZWxldG9uIHdpZHRoPXszNn0gaGVpZ2h0PXszNn0gcmFkaXVzPVwieGxcIiB2aXNpYmxlIC8+XG4gICAgICA8L0dyb3VwPlxuICAgIDwvR3JvdXA+XG4gICAgPFNlYXJjaEJhclNrZWxldG9uTW9iaWxlIC8+XG4gIDwvU3RhY2s+XG4pO1xuXG5jb25zdCBTZWFyY2hCYXJTa2VsZXRvbk1vYmlsZSA9ICgpID0+IChcbiAgPEdyb3VwPCdkaXYnPlxuICAgIHc9XCIxMDB2d1wiXG4gICAgY2xhc3NOYW1lPVwiY2xhc3Mtc2hvdy1zZWFyY2gtYmFyXCJcbiAgICBjc3M9e3N0eWxlQXBwU2hlbGxTZWFyY2hCYXJNb2JpbGVXcmFwcGVyKHsgc2hvd01lbnVMaXN0OiBmYWxzZSB9KX0+XG4gICAgPEdyb3VwPCdkaXYnPlxuICAgICAgdz1cIjEwMCVcIlxuICAgICAgY3NzPXtzdHlsZUFwcFNoZWxsU2VhcmNoQmFySW5uZXJXcmFwcGVyKHtcbiAgICAgICAgc2hvd01lbnVMaXN0OiBmYWxzZSxcbiAgICAgICAgaXNGb2N1c2VkOiBmYWxzZSxcbiAgICAgICAgaXNNb2JpbGU6IHRydWUsXG4gICAgICB9KX0+XG4gICAgICA8Qm94IGNzcz17eyBmbGV4OiAxIH19PjwvQm94PlxuICAgICAgPEFjdGlvbkljb24gdHlwZT1cInN1Ym1pdFwiIHNpemU9XCJuLXhzXCIgdmFyaWFudD1cImZpbGxlZFwiIGNvbG9yPVwiaW5mZ3JlZW5cIiByYWRpdXM9ezk5OX0gZGlzYWJsZWQ+XG4gICAgICAgIDxJY29uIGljb249e3NvbGlkKCdzZWFyY2gnKX0gc2l6ZT1cIm1kXCIgLz5cbiAgICAgIDwvQWN0aW9uSWNvbj5cbiAgICA8L0dyb3VwPlxuICA8L0dyb3VwPlxuKTtcblxuZXhwb3J0IGNvbnN0IHN0eWxlSGVhZGVyQ29udGFpbmVySW5uZXIgPSBjc3Moe1xuICBtYXhXaWR0aDogMTQ0MCxcbiAgcGFkZGluZzogJzAgMzJweCcsXG4gIGJhY2tncm91bmRDb2xvcjogJ3doaXRlJyxcblxuICBbbWVkaWFRdWVyaWVzKCdtb2JpbGUnKV06IHtcbiAgICBwYWRkaW5nOiAnMCAxNnB4JyxcbiAgfSxcbn0pO1xuIl19 */",
  toString: bI
};
const _a = ({
  isAntMan: g
}) => /* @__PURE__ */ W(v, { className: "class-show-search-bar", css: Ta({
  showMenuList: !0,
  isAntMan: g
}), children: /* @__PURE__ */ z(v, { css: $e({
  showMenuList: !0,
  isFocused: !1,
  isMobile: !1
}), children: [
  /* @__PURE__ */ W(w, { css: Ka }),
  /* @__PURE__ */ W(xg, { type: "submit", size: "n-md", variant: "filled", color: "infgreen", radius: 999, disabled: !0, children: /* @__PURE__ */ W(mg, { icon: Ke.faSearch, size: "md" }) })
] }) }), qa = () => /* @__PURE__ */ W(v, { h: 44, children: /* @__PURE__ */ z(v, { spacing: 10, className: "class-show-menu-list", noWrap: !0, children: [
  /* @__PURE__ */ W(Xg, { type: "COURSES" }),
  /* @__PURE__ */ W(Xg, { type: "CHALLENGES", showIndicator: !0 }),
  /* @__PURE__ */ W(Xg, { type: "MENTORING" }),
  /* @__PURE__ */ W(Xg, { type: "CLIPS", showIndicator: !0 }),
  /* @__PURE__ */ W(Xg, { type: "ROADMAPS" })
] }) }), Xg = ({
  type: g,
  showIndicator: I = !1
}) => /* @__PURE__ */ W($g, { justify: "center", className: `class-show-menu-${g.toLowerCase()}`, children: /* @__PURE__ */ W(Ya, { type: g, skeletonType: g, showIndicator: I }) });
var $a = process.env.NODE_ENV === "production" ? {
  name: "82a6rk",
  styles: "flex:1"
} : {
  name: "ow3ghr-MobileHeaderSkeleton",
  styles: "flex:1;label:MobileHeaderSkeleton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: bI
};
const gs = ({
  styles: g,
  showLanguageSectionButton: I
}) => /* @__PURE__ */ z($g, { w: "100%", spacing: 0, css: /* @__PURE__ */ S({
  display: "none",
  [U("tablet")]: {
    display: "flex"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:MobileHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: [
  /* @__PURE__ */ z(v, { w: "100%", h: 50, css: [g == null ? void 0 : g.root, process.env.NODE_ENV === "production" ? "" : ";label:MobileHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: [
    /* @__PURE__ */ W(Pa, {}),
    /* @__PURE__ */ z(v, { position: "right", spacing: 8, ml: 10, noWrap: !0, css: $a, children: [
      I && /* @__PURE__ */ W(xg, { variant: "light", size: "n-sm", color: "gray", radius: "xl", disabled: !0, children: /* @__PURE__ */ W(mg, { icon: MI.faGlobe }) }),
      /* @__PURE__ */ W(ge, { width: 36, height: 36, radius: "xl", visible: !0 })
    ] })
  ] }),
  /* @__PURE__ */ W(cs, {})
] });
var Is = process.env.NODE_ENV === "production" ? {
  name: "82a6rk",
  styles: "flex:1"
} : {
  name: "11fw941-SearchBarSkeletonMobile",
  styles: "flex:1;label:SearchBarSkeletonMobile;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: bI
};
const cs = () => /* @__PURE__ */ W(v, { w: "100vw", className: "class-show-search-bar", css: Ha({
  showMenuList: !1
}), children: /* @__PURE__ */ z(v, { w: "100%", css: $e({
  showMenuList: !1,
  isFocused: !1,
  isMobile: !0
}), children: [
  /* @__PURE__ */ W(w, { css: Is }),
  /* @__PURE__ */ W(xg, { type: "submit", size: "n-xs", variant: "filled", color: "infgreen", radius: 999, disabled: !0, children: /* @__PURE__ */ W(mg, { icon: Ke.faSearch, size: "md" }) })
] }) }), es = /* @__PURE__ */ S({
  maxWidth: 1440,
  padding: "0 32px",
  backgroundColor: "white",
  [U("mobile")]: {
    padding: "0 16px"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:styleHeaderContainerInner;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
export {
  Wa as $,
  pI as A,
  EI as B,
  Hg as C,
  Pe as D,
  lg as E,
  qg as F,
  Ws as G,
  Vs as H,
  Ib as I,
  xs as J,
  hs as K,
  Ln as L,
  bg as M,
  zn as N,
  ms as O,
  ye as P,
  sn as Q,
  F as R,
  Og as S,
  gb as T,
  nA as U,
  sA as V,
  lA as W,
  rb as X,
  Ns as Y,
  Be as Z,
  Ps as _,
  vl as a,
  hi as a$,
  ks as a0,
  tC as a1,
  rC as a2,
  GC as a3,
  JI as a4,
  bC as a5,
  nC as a6,
  CC as a7,
  Bs as a8,
  ps as a9,
  Ms as aA,
  Ds as aB,
  KI as aC,
  Hs as aD,
  Pb as aE,
  Ss as aF,
  Sa as aG,
  va as aH,
  bA as aI,
  ob as aJ,
  $e as aK,
  Ta as aL,
  aA as aM,
  Ha as aN,
  tA as aO,
  CA as aP,
  ha as aQ,
  $s as aR,
  Nc as aS,
  oe as aT,
  gI as aU,
  rc as aV,
  Cg as aW,
  $ as aX,
  D as aY,
  HI as aZ,
  El as a_,
  Ke as aa,
  Rs as ab,
  RC as ac,
  wa as ad,
  ys as ae,
  pc as af,
  ab as ag,
  Js as ah,
  zs as ai,
  Qe as aj,
  ya as ak,
  QI as al,
  Fs as am,
  js as an,
  Ra as ao,
  Na as ap,
  Ya as aq,
  GI as ar,
  qe as as,
  _e as at,
  U as au,
  IA as av,
  qs as aw,
  Ls as ax,
  eA as ay,
  vs as az,
  yl as b,
  Ys as b0,
  gA as b1,
  iA as b2,
  Pc as b3,
  wg as b4,
  Rc as b5,
  Kb as b6,
  eC as b7,
  Ts as b8,
  ws as b9,
  Us as ba,
  Mb as bb,
  j as bc,
  cA as bd,
  Ks as be,
  cg as bf,
  _s as bg,
  Ne as bh,
  hI as bi,
  _n as bj,
  _ as bk,
  En as bl,
  Dn as bm,
  $n as bn,
  fs as bo,
  Zs as bp,
  ng as c,
  Xe as d,
  be as e,
  ne as f,
  UI as g,
  XI as h,
  Eg as i,
  Bg as j,
  se as k,
  ue as l,
  OI as m,
  Jt as n,
  Es as o,
  Xa as p,
  E as q,
  tg as r,
  Os as s,
  ql as t,
  ve as u,
  mC as v,
  Q as w,
  mc as x,
  PI as y,
  Qs as z
};
